/* @generated from adl module hotel.api */

import * as ADL from './../runtime/adl';
import * as common from './../common';
import * as common_db from './../common/db';
import * as common_http from './../common/http';
import * as common_strings from './../common/strings';
import * as common_tabular from './../common/tabular';
import * as hotel_booking from './booking';
import * as hotel_common from './common';
import * as hotel_db from './db';
import * as ids_common from './../ids/common';
import * as ids_db from './../ids/db';
import * as ids_externalapi from './../ids/externalapi';
import * as ids_hotel from './../ids/hotel';
import * as sys_types from './../sys/types';

/**
 * Token used to represent a price search that has already begun.
 */
export type PriceToken = string;

const PriceToken_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Token used to represent a price search that has already begun.\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"PriceToken","version":{"kind":"nothing"}}};

export const snPriceToken: ADL.ScopedName = {moduleName:"hotel.api", name:"PriceToken"};

export function texprPriceToken(): ADL.ATypeExpr<PriceToken> {
  return {value : {typeRef : {kind: "reference", value : snPriceToken}, parameters : []}};
}

/**
 * Unique ID that represents a package returned from a particular hotel
 * search, can be used to book a single package with a supplier
 */
export type PackageId = string;

const PackageId_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Unique ID that represents a package returned from a particular hotel\nsearch, can be used to book a single package with a supplier\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"PackageId","version":{"kind":"nothing"}}};

export const snPackageId: ADL.ScopedName = {moduleName:"hotel.api", name:"PackageId"};

export function texprPackageId(): ADL.ATypeExpr<PackageId> {
  return {value : {typeRef : {kind: "reference", value : snPackageId}, parameters : []}};
}

export interface ApiRequests {
  /**
   * Login a user
   */
  login: common_http.HttpPost<LoginReq, LoginResp>;
  /**
   * Gets the logged in user details
   */
  whoAmI: common_http.HttpGet<UserProfile>;
  /**
   * Create a new user
   */
  createUser: common_http.HttpPost<UserReq, CreateUserResp>;
  /**
   * Update an existing user
   */
  updateUser: common_http.HttpPost<common_db.WithDbId<UserReq>, UpdateUserResp>;
  /**
   * Delete an existing user
   */
  deleteUser: common_http.HttpPost<hotel_db.AppUserId, DeleteUserResp>;
  /**
   * Update user password
   */
  updateUserPassword: common_http.HttpPost<UpdateUserPasswordReq, UpdateUserPasswordResp>;
  /**
   * Create an itinerary
   */
  createItinerary: common_http.HttpPost<CreateItineraryReq, CreateItineraryResp>;
  /**
   * Returns the itinerary with the provided itinerary number
   */
  getItineraryByNumber: common_http.HttpPost<GetItineraryReq, GetItineraryResp>;
  /**
   * Create a new draft booking in a particular itinerary. A draft booking is the initial state of all bookings
   */
  createDraftBooking: common_http.HttpPost<CreateBookingReq, CreateBookingResp>;
  /**
   * Create a new booking quote in a particular itinerary. A booking quote is requested by user
   */
  createBookingQuote: common_http.HttpPost<CreateBookingReq, CreateBookingResp>;
  /**
   * Creates a new agency, only BO/Admin level users are permitted to access this endpoint
   */
  createAgency: common_http.HttpPost<hotel_db.Agency, CreateAgencyResp>;
  /**
   * Updates an agency, only agency admin level users or above are permitted to access this endpoint
   */
  updateAgency: common_http.HttpPost<common_db.WithDbId<hotel_db.Agency>, UpdateAgencyResp>;
  /**
   * Gets information about an agency, given an agency id
   */
  getAgency: common_http.HttpPost<common_db.DbKey<hotel_db.Agency>, hotel_db.Agency>;
  /**
   * Query existing agencies sorted and filtered according to
   * the TableQuery request.
   */
  queryAgencies: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<hotel_db.Agency>>>;
  /**
   * Create an agent user
   */
  createAgentUser: common_http.HttpPost<CreateAgentUserReq, CreateAgentUserResp>;
  /**
   * Confirm the invite of an agent user
   */
  confirmInviteAgentUser: common_http.HttpPost<ConfirmInviteAgentUserReq, ConfirmInviteAgentUserResp>;
  /**
   * Validate the invite of an agent user
   */
  validateInviteAgentUser: common_http.HttpPost<ValidateInviteAgentUserReq, ValidateInviteAgentUserResp>;
  /**
   * Send an invite to a user
   */
  inviteUser: common_http.HttpPost<UserInviteReq, UserInviteResp>;
  /**
   * Query existing users sorted and filters according to the TableQuery request.
   */
  queryUsers: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<AppUserDetails>>>;
  searchLocations: common_http.HttpPost<ids_externalapi.LocationSearchReq, ids_externalapi.LocationSearchResp>;
  queryLocationInfo: common_http.HttpPost<ids_externalapi.LocationType, ids_externalapi.LocationInfoResp>;
  queryHotels: common_http.HttpPost<AgentHotelSearchQuery, AgentHotelSearchResp>;
  /**
   * Returns a list of nearby POIs for the hotel with the given ID
   */
  queryNearbyPoisToHotel: common_http.HttpPost<common_db.DbKey<ids_db.Hotel>, ids_externalapi.PoiNearHotel[]>;
  queryHotelImages: common_http.HttpPost<ids_externalapi.HotelImageReq, ids_externalapi.HotelImageResp>;
  queryLeadingPrices: common_http.HttpPost<LeadingPriceQuery, LeadingPriceQueryResp>;
  /**
   * Query packages available for a particular hotel
   */
  queryAvailablePackages: common_http.HttpPost<AvailablePackagesQuery, AvailablePackagesResp>;
  queryBookings: common_http.HttpPost<BookingSearchQuery, BookingSearchQueryResp>;
  /**
   * Gets bookings numbers grouped by shortcuts
   */
  countBookingShortcuts: common_http.HttpPost<BookingSearchShortcutQuery, BookingSearchShortcutCountResp>;
  /**
   * Query cancellation policies for a particular hotel's packages
   */
  queryCancellationPolicies: common_http.HttpPost<CancellationPoliciesQuery, CancellationPoliciesResp>;
  /**
   * Query details for completing a booking
   */
  queryPaymentDetails: common_http.HttpPost<PaymentDetailsReq, PaymentDetailsResp>;
  /**
   * Refresh a booking in quote state
   */
  refreshBookingQuote: common_http.HttpPost<common_db.DbKey<hotel_db.Booking>, RefreshBookingResp>;
  /**
   * Confirm a booking without payment (i.e. book and hold)
   */
  confirmBooking: common_http.HttpPost<ConfirmBookingReq, ConfirmBookingResp>;
  /**
   * Cancels a booking
   */
  cancelBooking: common_http.HttpPost<common_db.DbKey<hotel_db.Booking>, CancelBookingResp>;
  /**
   * Auto-cancellation job. This job will cancel all bookings that are overdue for payment automatically.
   * The API is intended to be triggered by a job scheduler, but it also has the capability of running on-demand.
   */
  autoCancelBookings: common_http.HttpPost<JobReq, JobResp>;
  /**
   * Status update to travelled job. This job will update the status of eligible bookings to travelled automatically.
   * The API is intended to be triggered by a job scheduler, but it also has the capability of running on-demand.
   */
  updateTravelledBookings: common_http.HttpPost<JobReq, JobResp>;
  /**
   * Commission due client payment status job. This job will update the client payment status of eligible bookings
   * to Commission Due automatically.
   * The API is intended to be triggered by a job scheduler, but it also has the capability of running on-demand.
   */
  updateCommissionDueBookings: common_http.HttpPost<JobReq, JobResp>;
  /**
   * Pays and confirms a booking, if possible
   */
  payForBooking: common_http.HttpPost<PayForBookingReq, PayForBookingResp>;
  /**
   * Gets bookings refundability statuses
   */
  queryBookingRefundability: common_http.HttpPost<BookingRefundabilityReq, BookingRefundabilityResp>;
  /**
   * Finalizes a pending payment.
   */
  finalizeBookingPayment: common_http.HttpPost<FinalizePaymentReq, FinalizePaymentResp>;
  /**
   * Query terms and conditions by its id or empty key to query the most recent one.
   */
  queryTermsAndConditions: common_http.HttpPost<common_db.DbKey<hotel_db.TermsAndConditions>, hotel_db.TermsAndConditions>;
  /**
   * Create Terms and Conditions
   */
  createTermsAndConditions: common_http.HttpPost<CreateTermsAndConditionsReq, CreateTermsAndConditionsResp>;
  /**
   * Gets payment config data
   */
  queryPaymentClientConfig: common_http.HttpGet<PaymentClientConfigResp>;
  /**
   * Gets reports
   */
  queryReports: common_http.HttpGet2<GetReportReq, GetReportResp>;
  /**
   * Creates a new comment for an itinerary
   */
  itineraryCommentCreate: common_http.HttpPost<ItineraryCommentCreateReq, ItineraryCommentData>;
  /**
   * Queries itinerary comments
   */
  itineraryCommentsQuery: common_http.HttpPost<ItineraryCommentsQuery, common.Paginated<ItineraryCommentData>>;
}

export function makeApiRequests(
  input: {
    login?: common_http.HttpPost<LoginReq, LoginResp>,
    whoAmI?: common_http.HttpGet<UserProfile>,
    createUser?: common_http.HttpPost<UserReq, CreateUserResp>,
    updateUser?: common_http.HttpPost<common_db.WithDbId<UserReq>, UpdateUserResp>,
    deleteUser?: common_http.HttpPost<hotel_db.AppUserId, DeleteUserResp>,
    updateUserPassword?: common_http.HttpPost<UpdateUserPasswordReq, UpdateUserPasswordResp>,
    createItinerary?: common_http.HttpPost<CreateItineraryReq, CreateItineraryResp>,
    getItineraryByNumber?: common_http.HttpPost<GetItineraryReq, GetItineraryResp>,
    createDraftBooking?: common_http.HttpPost<CreateBookingReq, CreateBookingResp>,
    createBookingQuote?: common_http.HttpPost<CreateBookingReq, CreateBookingResp>,
    createAgency?: common_http.HttpPost<hotel_db.Agency, CreateAgencyResp>,
    updateAgency?: common_http.HttpPost<common_db.WithDbId<hotel_db.Agency>, UpdateAgencyResp>,
    getAgency?: common_http.HttpPost<common_db.DbKey<hotel_db.Agency>, hotel_db.Agency>,
    queryAgencies?: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<hotel_db.Agency>>>,
    createAgentUser?: common_http.HttpPost<CreateAgentUserReq, CreateAgentUserResp>,
    confirmInviteAgentUser?: common_http.HttpPost<ConfirmInviteAgentUserReq, ConfirmInviteAgentUserResp>,
    validateInviteAgentUser?: common_http.HttpPost<ValidateInviteAgentUserReq, ValidateInviteAgentUserResp>,
    inviteUser?: common_http.HttpPost<UserInviteReq, UserInviteResp>,
    queryUsers?: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<AppUserDetails>>>,
    searchLocations?: common_http.HttpPost<ids_externalapi.LocationSearchReq, ids_externalapi.LocationSearchResp>,
    queryLocationInfo?: common_http.HttpPost<ids_externalapi.LocationType, ids_externalapi.LocationInfoResp>,
    queryHotels?: common_http.HttpPost<AgentHotelSearchQuery, AgentHotelSearchResp>,
    queryNearbyPoisToHotel?: common_http.HttpPost<common_db.DbKey<ids_db.Hotel>, ids_externalapi.PoiNearHotel[]>,
    queryHotelImages?: common_http.HttpPost<ids_externalapi.HotelImageReq, ids_externalapi.HotelImageResp>,
    queryLeadingPrices?: common_http.HttpPost<LeadingPriceQuery, LeadingPriceQueryResp>,
    queryAvailablePackages?: common_http.HttpPost<AvailablePackagesQuery, AvailablePackagesResp>,
    queryBookings?: common_http.HttpPost<BookingSearchQuery, BookingSearchQueryResp>,
    countBookingShortcuts?: common_http.HttpPost<BookingSearchShortcutQuery, BookingSearchShortcutCountResp>,
    queryCancellationPolicies?: common_http.HttpPost<CancellationPoliciesQuery, CancellationPoliciesResp>,
    queryPaymentDetails?: common_http.HttpPost<PaymentDetailsReq, PaymentDetailsResp>,
    refreshBookingQuote?: common_http.HttpPost<common_db.DbKey<hotel_db.Booking>, RefreshBookingResp>,
    confirmBooking?: common_http.HttpPost<ConfirmBookingReq, ConfirmBookingResp>,
    cancelBooking?: common_http.HttpPost<common_db.DbKey<hotel_db.Booking>, CancelBookingResp>,
    autoCancelBookings?: common_http.HttpPost<JobReq, JobResp>,
    updateTravelledBookings?: common_http.HttpPost<JobReq, JobResp>,
    updateCommissionDueBookings?: common_http.HttpPost<JobReq, JobResp>,
    payForBooking?: common_http.HttpPost<PayForBookingReq, PayForBookingResp>,
    queryBookingRefundability?: common_http.HttpPost<BookingRefundabilityReq, BookingRefundabilityResp>,
    finalizeBookingPayment?: common_http.HttpPost<FinalizePaymentReq, FinalizePaymentResp>,
    queryTermsAndConditions?: common_http.HttpPost<common_db.DbKey<hotel_db.TermsAndConditions>, hotel_db.TermsAndConditions>,
    createTermsAndConditions?: common_http.HttpPost<CreateTermsAndConditionsReq, CreateTermsAndConditionsResp>,
    queryPaymentClientConfig?: common_http.HttpGet<PaymentClientConfigResp>,
    queryReports?: common_http.HttpGet2<GetReportReq, GetReportResp>,
    itineraryCommentCreate?: common_http.HttpPost<ItineraryCommentCreateReq, ItineraryCommentData>,
    itineraryCommentsQuery?: common_http.HttpPost<ItineraryCommentsQuery, common.Paginated<ItineraryCommentData>>,
  }
): ApiRequests {
  return {
    login: input.login === undefined ? {path : "/login", security : {kind : "public"}, reqType : texprLoginReq(), respType : texprLoginResp()} : input.login,
    whoAmI: input.whoAmI === undefined ? {path : "/whoami", security : {kind : "token"}, respType : texprUserProfile()} : input.whoAmI,
    createUser: input.createUser === undefined ? {path : "/users/create", security : {kind : "tokenWithRole", value : "admin"}, reqType : texprUserReq(), respType : texprCreateUserResp()} : input.createUser,
    updateUser: input.updateUser === undefined ? {path : "/users/update", security : {kind : "tokenWithRole", value : "agent"}, reqType : common_db.texprWithDbId(texprUserReq()), respType : texprUpdateUserResp()} : input.updateUser,
    deleteUser: input.deleteUser === undefined ? {path : "/users/delete", security : {kind : "tokenWithRole", value : "agency-admin"}, reqType : hotel_db.texprAppUserId(), respType : texprDeleteUserResp()} : input.deleteUser,
    updateUserPassword: input.updateUserPassword === undefined ? {path : "/users/password", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprUpdateUserPasswordReq(), respType : texprUpdateUserPasswordResp()} : input.updateUserPassword,
    createItinerary: input.createItinerary === undefined ? {path : "/itinerary/create", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprCreateItineraryReq(), respType : texprCreateItineraryResp()} : input.createItinerary,
    getItineraryByNumber: input.getItineraryByNumber === undefined ? {path : "/itinerary/get", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprGetItineraryReq(), respType : texprGetItineraryResp()} : input.getItineraryByNumber,
    createDraftBooking: input.createDraftBooking === undefined ? {path : "/hotel/booking/draft/create", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprCreateBookingReq(), respType : texprCreateBookingResp()} : input.createDraftBooking,
    createBookingQuote: input.createBookingQuote === undefined ? {path : "/hotel/booking/quote/create", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprCreateBookingReq(), respType : texprCreateBookingResp()} : input.createBookingQuote,
    createAgency: input.createAgency === undefined ? {path : "/agency/create", security : {kind : "tokenWithRole", value : "back-office"}, reqType : hotel_db.texprAgency(), respType : texprCreateAgencyResp()} : input.createAgency,
    updateAgency: input.updateAgency === undefined ? {path : "/agency/update", security : {kind : "tokenWithRole", value : "agency-admin"}, reqType : common_db.texprWithDbId(hotel_db.texprAgency()), respType : texprUpdateAgencyResp()} : input.updateAgency,
    getAgency: input.getAgency === undefined ? {path : "/agency/get", security : {kind : "tokenWithRole", value : "agent"}, reqType : common_db.texprDbKey(hotel_db.texprAgency()), respType : hotel_db.texprAgency()} : input.getAgency,
    queryAgencies: input.queryAgencies === undefined ? {path : "/agency/query", security : {kind : "tokenWithRole", value : "agency-admin"}, reqType : common_tabular.texprTableQuery(), respType : common.texprPaginated(common_db.texprWithDbId(hotel_db.texprAgency()))} : input.queryAgencies,
    createAgentUser: input.createAgentUser === undefined ? {path : "/agency/user/create", security : {kind : "tokenWithRole", value : "agency-admin"}, reqType : texprCreateAgentUserReq(), respType : texprCreateAgentUserResp()} : input.createAgentUser,
    confirmInviteAgentUser: input.confirmInviteAgentUser === undefined ? {path : "/agency/user/invite/confirm", security : {kind : "public"}, reqType : texprConfirmInviteAgentUserReq(), respType : texprConfirmInviteAgentUserResp()} : input.confirmInviteAgentUser,
    validateInviteAgentUser: input.validateInviteAgentUser === undefined ? {path : "/agency/user/invite/validate", security : {kind : "public"}, reqType : texprValidateInviteAgentUserReq(), respType : texprValidateInviteAgentUserResp()} : input.validateInviteAgentUser,
    inviteUser: input.inviteUser === undefined ? {path : "/user/invite", security : {kind : "public"}, reqType : texprUserInviteReq(), respType : texprUserInviteResp()} : input.inviteUser,
    queryUsers: input.queryUsers === undefined ? {path : "/users/query", security : {kind : "tokenWithRole", value : "agency-admin"}, reqType : common_tabular.texprTableQuery(), respType : common.texprPaginated(common_db.texprWithDbId(texprAppUserDetails()))} : input.queryUsers,
    searchLocations: input.searchLocations === undefined ? {path : "/location/search", security : {kind : "token"}, reqType : ids_externalapi.texprLocationSearchReq(), respType : ids_externalapi.texprLocationSearchResp()} : input.searchLocations,
    queryLocationInfo: input.queryLocationInfo === undefined ? {path : "/location/info", security : {kind : "token"}, reqType : ids_externalapi.texprLocationType(), respType : ids_externalapi.texprLocationInfoResp()} : input.queryLocationInfo,
    queryHotels: input.queryHotels === undefined ? {path : "/hotel/search", security : {kind : "token"}, reqType : texprAgentHotelSearchQuery(), respType : texprAgentHotelSearchResp()} : input.queryHotels,
    queryNearbyPoisToHotel: input.queryNearbyPoisToHotel === undefined ? {path : "/hotels/pois", security : {kind : "token"}, reqType : common_db.texprDbKey(ids_db.texprHotel()), respType : ADL.texprVector(ids_externalapi.texprPoiNearHotel())} : input.queryNearbyPoisToHotel,
    queryHotelImages: input.queryHotelImages === undefined ? {path : "/hotel/images", security : {kind : "token"}, reqType : ids_externalapi.texprHotelImageReq(), respType : ids_externalapi.texprHotelImageResp()} : input.queryHotelImages,
    queryLeadingPrices: input.queryLeadingPrices === undefined ? {path : "/hotel/search/price", security : {kind : "token"}, reqType : texprLeadingPriceQuery(), respType : texprLeadingPriceQueryResp()} : input.queryLeadingPrices,
    queryAvailablePackages: input.queryAvailablePackages === undefined ? {path : "/hotel/search/packages", security : {kind : "token"}, reqType : texprAvailablePackagesQuery(), respType : texprAvailablePackagesResp()} : input.queryAvailablePackages,
    queryBookings: input.queryBookings === undefined ? {path : "/booking/search", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprBookingSearchQuery(), respType : texprBookingSearchQueryResp()} : input.queryBookings,
    countBookingShortcuts: input.countBookingShortcuts === undefined ? {path : "/booking/shortcuts/count", security : {kind : "tokenWithRole", value : "agent"}, reqType : texprBookingSearchShortcutQuery(), respType : texprBookingSearchShortcutCountResp()} : input.countBookingShortcuts,
    queryCancellationPolicies: input.queryCancellationPolicies === undefined ? {path : "/hotel/search/cancellation", security : {kind : "token"}, reqType : texprCancellationPoliciesQuery(), respType : texprCancellationPoliciesResp()} : input.queryCancellationPolicies,
    queryPaymentDetails: input.queryPaymentDetails === undefined ? {path : "/hotel/booking/price", security : {kind : "token"}, reqType : texprPaymentDetailsReq(), respType : texprPaymentDetailsResp()} : input.queryPaymentDetails,
    refreshBookingQuote: input.refreshBookingQuote === undefined ? {path : "/hotel/booking/refresh", security : {kind : "tokenWithRole", value : "agent"}, reqType : common_db.texprDbKey(hotel_db.texprBooking()), respType : texprRefreshBookingResp()} : input.refreshBookingQuote,
    confirmBooking: input.confirmBooking === undefined ? {path : "/hotel/booking/confirm", security : {kind : "token"}, reqType : texprConfirmBookingReq(), respType : texprConfirmBookingResp()} : input.confirmBooking,
    cancelBooking: input.cancelBooking === undefined ? {path : "/hotel/booking/cancel", security : {kind : "token"}, reqType : common_db.texprDbKey(hotel_db.texprBooking()), respType : texprCancelBookingResp()} : input.cancelBooking,
    autoCancelBookings: input.autoCancelBookings === undefined ? {path : "/hotel/booking/autocancel", security : {kind : "tokenWithRole", value : "api"}, reqType : texprJobReq(), respType : texprJobResp()} : input.autoCancelBookings,
    updateTravelledBookings: input.updateTravelledBookings === undefined ? {path : "/hotel/booking/updateTravelled", security : {kind : "tokenWithRole", value : "api"}, reqType : texprJobReq(), respType : texprJobResp()} : input.updateTravelledBookings,
    updateCommissionDueBookings: input.updateCommissionDueBookings === undefined ? {path : "/hotel/booking/updateCommissionDue", security : {kind : "tokenWithRole", value : "api"}, reqType : texprJobReq(), respType : texprJobResp()} : input.updateCommissionDueBookings,
    payForBooking: input.payForBooking === undefined ? {path : "/hotel/booking/pay", security : {kind : "token"}, reqType : texprPayForBookingReq(), respType : texprPayForBookingResp()} : input.payForBooking,
    queryBookingRefundability: input.queryBookingRefundability === undefined ? {path : "/hotel/booking/refundability", security : {kind : "token"}, reqType : texprBookingRefundabilityReq(), respType : texprBookingRefundabilityResp()} : input.queryBookingRefundability,
    finalizeBookingPayment: input.finalizeBookingPayment === undefined ? {path : "/hotel/booking/payment/finalize", security : {kind : "tokenWithRole", value : "api"}, reqType : texprFinalizePaymentReq(), respType : texprFinalizePaymentResp()} : input.finalizeBookingPayment,
    queryTermsAndConditions: input.queryTermsAndConditions === undefined ? {path : "/general/terms/get", security : {kind : "token"}, reqType : common_db.texprDbKey(hotel_db.texprTermsAndConditions()), respType : hotel_db.texprTermsAndConditions()} : input.queryTermsAndConditions,
    createTermsAndConditions: input.createTermsAndConditions === undefined ? {path : "/general/terms/create", security : {kind : "token"}, reqType : texprCreateTermsAndConditionsReq(), respType : texprCreateTermsAndConditionsResp()} : input.createTermsAndConditions,
    queryPaymentClientConfig: input.queryPaymentClientConfig === undefined ? {path : "/payments/config", security : {kind : "token"}, respType : texprPaymentClientConfigResp()} : input.queryPaymentClientConfig,
    queryReports: input.queryReports === undefined ? {path : "/reports", security : {kind : "token"}, paramsType : texprGetReportReq(), respType : texprGetReportResp()} : input.queryReports,
    itineraryCommentCreate: input.itineraryCommentCreate === undefined ? {path : "/itinerary/comment/create", security : {kind : "tokenWithRole", value : "back-office"}, reqType : texprItineraryCommentCreateReq(), respType : texprItineraryCommentData()} : input.itineraryCommentCreate,
    itineraryCommentsQuery: input.itineraryCommentsQuery === undefined ? {path : "/itinerary/comments/query", security : {kind : "tokenWithRole", value : "back-office"}, reqType : texprItineraryCommentsQuery(), respType : common.texprPaginated(texprItineraryCommentData())} : input.itineraryCommentsQuery,
  };
}

const ApiRequests_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Login a user\n"}],"serializedName":"login","default":{"kind":"just","value":{"path":"/login","security":"public"}},"name":"login","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LoginReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LoginResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets the logged in user details\n"}],"serializedName":"whoAmI","default":{"kind":"just","value":{"path":"/whoami","security":"token"}},"name":"whoAmI","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpGet"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UserProfile"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create a new user\n"}],"serializedName":"createUser","default":{"kind":"just","value":{"path":"/users/create","security":{"tokenWithRole":"admin"}}},"name":"createUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UserReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateUserResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Update an existing user\n"}],"serializedName":"updateUser","default":{"kind":"just","value":{"path":"/users/update","security":{"tokenWithRole":"agent"}}},"name":"updateUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UserReq"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UpdateUserResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Delete an existing user\n"}],"serializedName":"deleteUser","default":{"kind":"just","value":{"path":"/users/delete","security":{"tokenWithRole":"agency-admin"}}},"name":"deleteUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUserId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"DeleteUserResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Update user password\n"}],"serializedName":"updateUserPassword","default":{"kind":"just","value":{"path":"/users/password","security":{"tokenWithRole":"agent"}}},"name":"updateUserPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UpdateUserPasswordReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UpdateUserPasswordResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create an itinerary\n"}],"serializedName":"createItinerary","default":{"kind":"just","value":{"path":"/itinerary/create","security":{"tokenWithRole":"agent"}}},"name":"createItinerary","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateItineraryReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateItineraryResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns the itinerary with the provided itinerary number\n"}],"serializedName":"getItineraryByNumber","default":{"kind":"just","value":{"path":"/itinerary/get","security":{"tokenWithRole":"agent"}}},"name":"getItineraryByNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"GetItineraryReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"GetItineraryResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create a new draft booking in a particular itinerary. A draft booking is the initial state of all bookings\n"}],"serializedName":"createDraftBooking","default":{"kind":"just","value":{"path":"/hotel/booking/draft/create","security":{"tokenWithRole":"agent"}}},"name":"createDraftBooking","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateBookingReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateBookingResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create a new booking quote in a particular itinerary. A booking quote is requested by user\n"}],"serializedName":"createBookingQuote","default":{"kind":"just","value":{"path":"/hotel/booking/quote/create","security":{"tokenWithRole":"agent"}}},"name":"createBookingQuote","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateBookingReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateBookingResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Creates a new agency, only BO/Admin level users are permitted to access this endpoint\n"}],"serializedName":"createAgency","default":{"kind":"just","value":{"path":"/agency/create","security":{"tokenWithRole":"back-office"}}},"name":"createAgency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateAgencyResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Updates an agency, only agency admin level users or above are permitted to access this endpoint\n"}],"serializedName":"updateAgency","default":{"kind":"just","value":{"path":"/agency/update","security":{"tokenWithRole":"agency-admin"}}},"name":"updateAgency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UpdateAgencyResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets information about an agency, given an agency id\n"}],"serializedName":"getAgency","default":{"kind":"just","value":{"path":"/agency/get","security":{"tokenWithRole":"agent"}}},"name":"getAgency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query existing agencies sorted and filtered according to\nthe TableQuery request.\n"}],"serializedName":"queryAgencies","default":{"kind":"just","value":{"path":"/agency/query","security":{"tokenWithRole":"agency-admin"}}},"name":"queryAgencies","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.tabular","name":"TableQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create an agent user\n"}],"serializedName":"createAgentUser","default":{"kind":"just","value":{"path":"/agency/user/create","security":{"tokenWithRole":"agency-admin"}}},"name":"createAgentUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateAgentUserReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateAgentUserResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Confirm the invite of an agent user\n"}],"serializedName":"confirmInviteAgentUser","default":{"kind":"just","value":{"path":"/agency/user/invite/confirm","security":"public"}},"name":"confirmInviteAgentUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ConfirmInviteAgentUserReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ConfirmInviteAgentUserResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Validate the invite of an agent user\n"}],"serializedName":"validateInviteAgentUser","default":{"kind":"just","value":{"path":"/agency/user/invite/validate","security":"public"}},"name":"validateInviteAgentUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ValidateInviteAgentUserReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ValidateInviteAgentUserResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Send an invite to a user\n"}],"serializedName":"inviteUser","default":{"kind":"just","value":{"path":"/user/invite","security":"public"}},"name":"inviteUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UserInviteReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"UserInviteResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query existing users sorted and filters according to the TableQuery request.\n"}],"serializedName":"queryUsers","default":{"kind":"just","value":{"path":"/users/query","security":{"tokenWithRole":"agency-admin"}}},"name":"queryUsers","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.tabular","name":"TableQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AppUserDetails"}},"parameters":[]}]}]}]}},{"annotations":[],"serializedName":"searchLocations","default":{"kind":"just","value":{"path":"/location/search","security":"token"}},"name":"searchLocations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationSearchReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationSearchResp"}},"parameters":[]}]}},{"annotations":[],"serializedName":"queryLocationInfo","default":{"kind":"just","value":{"path":"/location/info","security":"token"}},"name":"queryLocationInfo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationType"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationInfoResp"}},"parameters":[]}]}},{"annotations":[],"serializedName":"queryHotels","default":{"kind":"just","value":{"path":"/hotel/search","security":"token"}},"name":"queryHotels","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AgentHotelSearchQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AgentHotelSearchResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returns a list of nearby POIs for the hotel with the given ID\n"}],"serializedName":"queryNearbyPoisToHotel","default":{"kind":"just","value":{"path":"/hotels/pois","security":"token"}},"name":"queryNearbyPoisToHotel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]},{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"PoiNearHotel"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"queryHotelImages","default":{"kind":"just","value":{"path":"/hotel/images","security":"token"}},"name":"queryHotelImages","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelImageReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"HotelImageResp"}},"parameters":[]}]}},{"annotations":[],"serializedName":"queryLeadingPrices","default":{"kind":"just","value":{"path":"/hotel/search/price","security":"token"}},"name":"queryLeadingPrices","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LeadingPriceQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LeadingPriceQueryResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query packages available for a particular hotel\n"}],"serializedName":"queryAvailablePackages","default":{"kind":"just","value":{"path":"/hotel/search/packages","security":"token"}},"name":"queryAvailablePackages","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AvailablePackagesQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AvailablePackagesResp"}},"parameters":[]}]}},{"annotations":[],"serializedName":"queryBookings","default":{"kind":"just","value":{"path":"/booking/search","security":{"tokenWithRole":"agent"}}},"name":"queryBookings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingSearchQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingSearchQueryResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets bookings numbers grouped by shortcuts\n"}],"serializedName":"countBookingShortcuts","default":{"kind":"just","value":{"path":"/booking/shortcuts/count","security":{"tokenWithRole":"agent"}}},"name":"countBookingShortcuts","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingSearchShortcutQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingSearchShortcutCountResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query cancellation policies for a particular hotel's packages\n"}],"serializedName":"queryCancellationPolicies","default":{"kind":"just","value":{"path":"/hotel/search/cancellation","security":"token"}},"name":"queryCancellationPolicies","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CancellationPoliciesQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CancellationPoliciesResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query details for completing a booking\n"}],"serializedName":"queryPaymentDetails","default":{"kind":"just","value":{"path":"/hotel/booking/price","security":"token"}},"name":"queryPaymentDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PaymentDetailsReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PaymentDetailsResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Refresh a booking in quote state\n"}],"serializedName":"refreshBookingQuote","default":{"kind":"just","value":{"path":"/hotel/booking/refresh","security":{"tokenWithRole":"agent"}}},"name":"refreshBookingQuote","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"RefreshBookingResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Confirm a booking without payment (i.e. book and hold)\n"}],"serializedName":"confirmBooking","default":{"kind":"just","value":{"path":"/hotel/booking/confirm","security":"token"}},"name":"confirmBooking","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ConfirmBookingReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ConfirmBookingResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancels a booking\n"}],"serializedName":"cancelBooking","default":{"kind":"just","value":{"path":"/hotel/booking/cancel","security":"token"}},"name":"cancelBooking","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CancelBookingResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Auto-cancellation job. This job will cancel all bookings that are overdue for payment automatically.\nThe API is intended to be triggered by a job scheduler, but it also has the capability of running on-demand.\n"}],"serializedName":"autoCancelBookings","default":{"kind":"just","value":{"path":"/hotel/booking/autocancel","security":{"tokenWithRole":"api"}}},"name":"autoCancelBookings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Status update to travelled job. This job will update the status of eligible bookings to travelled automatically.\nThe API is intended to be triggered by a job scheduler, but it also has the capability of running on-demand.\n"}],"serializedName":"updateTravelledBookings","default":{"kind":"just","value":{"path":"/hotel/booking/updateTravelled","security":{"tokenWithRole":"api"}}},"name":"updateTravelledBookings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Commission due client payment status job. This job will update the client payment status of eligible bookings\nto Commission Due automatically.\nThe API is intended to be triggered by a job scheduler, but it also has the capability of running on-demand.\n"}],"serializedName":"updateCommissionDueBookings","default":{"kind":"just","value":{"path":"/hotel/booking/updateCommissionDue","security":{"tokenWithRole":"api"}}},"name":"updateCommissionDueBookings","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Pays and confirms a booking, if possible\n"}],"serializedName":"payForBooking","default":{"kind":"just","value":{"path":"/hotel/booking/pay","security":"token"}},"name":"payForBooking","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PayForBookingReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PayForBookingResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets bookings refundability statuses\n"}],"serializedName":"queryBookingRefundability","default":{"kind":"just","value":{"path":"/hotel/booking/refundability","security":"token"}},"name":"queryBookingRefundability","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingRefundabilityReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingRefundabilityResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Finalizes a pending payment.\n"}],"serializedName":"finalizeBookingPayment","default":{"kind":"just","value":{"path":"/hotel/booking/payment/finalize","security":{"tokenWithRole":"api"}}},"name":"finalizeBookingPayment","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"FinalizePaymentReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"FinalizePaymentResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query terms and conditions by its id or empty key to query the most recent one.\n"}],"serializedName":"queryTermsAndConditions","default":{"kind":"just","value":{"path":"/general/terms/get","security":"token"}},"name":"queryTermsAndConditions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"TermsAndConditions"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"TermsAndConditions"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create Terms and Conditions\n"}],"serializedName":"createTermsAndConditions","default":{"kind":"just","value":{"path":"/general/terms/create","security":"token"}},"name":"createTermsAndConditions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateTermsAndConditionsReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreateTermsAndConditionsResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets payment config data\n"}],"serializedName":"queryPaymentClientConfig","default":{"kind":"just","value":{"path":"/payments/config","security":"token"}},"name":"queryPaymentClientConfig","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpGet"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PaymentClientConfigResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets reports\n"}],"serializedName":"queryReports","default":{"kind":"just","value":{"path":"/reports","security":"token"}},"name":"queryReports","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpGet2"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"GetReportReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"GetReportResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Creates a new comment for an itinerary\n"}],"serializedName":"itineraryCommentCreate","default":{"kind":"just","value":{"path":"/itinerary/comment/create","security":{"tokenWithRole":"back-office"}}},"name":"itineraryCommentCreate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ItineraryCommentCreateReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ItineraryCommentData"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Queries itinerary comments\n"}],"serializedName":"itineraryCommentsQuery","default":{"kind":"just","value":{"path":"/itinerary/comments/query","security":{"tokenWithRole":"back-office"}}},"name":"itineraryCommentsQuery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ItineraryCommentsQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ItineraryCommentData"}},"parameters":[]}]}]}}]}},"name":"ApiRequests","version":{"kind":"nothing"}}};

export const snApiRequests: ADL.ScopedName = {moduleName:"hotel.api", name:"ApiRequests"};

export function texprApiRequests(): ADL.ATypeExpr<ApiRequests> {
  return {value : {typeRef : {kind: "reference", value : snApiRequests}, parameters : []}};
}

export interface GetItineraryReq {
  itineraryNumber: string;
}

export function makeGetItineraryReq(
  input: {
    itineraryNumber: string,
  }
): GetItineraryReq {
  return {
    itineraryNumber: input.itineraryNumber,
  };
}

const GetItineraryReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"itineraryNumber","default":{"kind":"nothing"},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"GetItineraryReq","version":{"kind":"nothing"}}};

export const snGetItineraryReq: ADL.ScopedName = {moduleName:"hotel.api", name:"GetItineraryReq"};

export function texprGetItineraryReq(): ADL.ATypeExpr<GetItineraryReq> {
  return {value : {typeRef : {kind: "reference", value : snGetItineraryReq}, parameters : []}};
}

export interface GetItineraryResp_NoSuchItinerary {
  kind: 'noSuchItinerary';
}
export interface GetItineraryResp_Itinerary {
  kind: 'itinerary';
  value: ItineraryDetails;
}

export type GetItineraryResp = GetItineraryResp_NoSuchItinerary | GetItineraryResp_Itinerary;

export interface GetItineraryRespOpts {
  noSuchItinerary: null;
  itinerary: ItineraryDetails;
}

export function makeGetItineraryResp<K extends keyof GetItineraryRespOpts>(kind: K, value: GetItineraryRespOpts[K]) { return {kind, value}; }

const GetItineraryResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"noSuchItinerary","default":{"kind":"nothing"},"name":"noSuchItinerary","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"itinerary","default":{"kind":"nothing"},"name":"itinerary","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ItineraryDetails"}},"parameters":[]}}]}},"name":"GetItineraryResp","version":{"kind":"nothing"}}};

export const snGetItineraryResp: ADL.ScopedName = {moduleName:"hotel.api", name:"GetItineraryResp"};

export function texprGetItineraryResp(): ADL.ATypeExpr<GetItineraryResp> {
  return {value : {typeRef : {kind: "reference", value : snGetItineraryResp}, parameters : []}};
}

export interface ItineraryDetails {
  /**
   * Details of the itinerary
   */
  itinerary: common_db.WithDbId<hotel_db.Itinerary>;
  /**
   * Total balance due
   */
  balanceDue: hotel_common.PriceValue;
  /**
   * Total net price with tax
   */
  netPriceWithTax: hotel_common.PriceValue;
  /**
   * Total gross price with tax
   */
  grossPriceWithTax: hotel_common.PriceValue;
  /**
   * Total commission to be paid out
   */
  commission: hotel_common.PriceValue;
  /**
   * Total supplier price, null if the caller is an agent and cannot see this data
   */
  supplierPrice: (hotel_common.PriceValue|null);
  /**
   * Total buy price, null if the caller is an agent and cannot see this data
   */
  buyPrice: (hotel_common.PriceValue|null);
}

export function makeItineraryDetails(
  input: {
    itinerary: common_db.WithDbId<hotel_db.Itinerary>,
    balanceDue: hotel_common.PriceValue,
    netPriceWithTax: hotel_common.PriceValue,
    grossPriceWithTax: hotel_common.PriceValue,
    commission: hotel_common.PriceValue,
    supplierPrice: (hotel_common.PriceValue|null),
    buyPrice: (hotel_common.PriceValue|null),
  }
): ItineraryDetails {
  return {
    itinerary: input.itinerary,
    balanceDue: input.balanceDue,
    netPriceWithTax: input.netPriceWithTax,
    grossPriceWithTax: input.grossPriceWithTax,
    commission: input.commission,
    supplierPrice: input.supplierPrice,
    buyPrice: input.buyPrice,
  };
}

const ItineraryDetails_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of the itinerary\n"}],"serializedName":"itinerary","default":{"kind":"nothing"},"name":"itinerary","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total balance due\n"}],"serializedName":"balanceDue","default":{"kind":"nothing"},"name":"balanceDue","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total net price with tax\n"}],"serializedName":"netPriceWithTax","default":{"kind":"nothing"},"name":"netPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total gross price with tax\n"}],"serializedName":"grossPriceWithTax","default":{"kind":"nothing"},"name":"grossPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total commission to be paid out\n"}],"serializedName":"commission","default":{"kind":"nothing"},"name":"commission","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total supplier price, null if the caller is an agent and cannot see this data\n"}],"serializedName":"supplierPrice","default":{"kind":"nothing"},"name":"supplierPrice","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total buy price, null if the caller is an agent and cannot see this data\n"}],"serializedName":"buyPrice","default":{"kind":"nothing"},"name":"buyPrice","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}]}}]}},"name":"ItineraryDetails","version":{"kind":"nothing"}}};

export const snItineraryDetails: ADL.ScopedName = {moduleName:"hotel.api", name:"ItineraryDetails"};

export function texprItineraryDetails(): ADL.ATypeExpr<ItineraryDetails> {
  return {value : {typeRef : {kind: "reference", value : snItineraryDetails}, parameters : []}};
}

export interface CancelBookingResp_Success {
  kind: 'success';
}
export interface CancelBookingResp_InvalidBookingId {
  kind: 'invalidBookingId';
}
export interface CancelBookingResp_Error {
  kind: 'error';
  value: string;
}

export type CancelBookingResp = CancelBookingResp_Success | CancelBookingResp_InvalidBookingId | CancelBookingResp_Error;

export interface CancelBookingRespOpts {
  success: null;
  invalidBookingId: null;
  error: string;
}

export function makeCancelBookingResp<K extends keyof CancelBookingRespOpts>(kind: K, value: CancelBookingRespOpts[K]) { return {kind, value}; }

const CancelBookingResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"invalidBookingId","default":{"kind":"nothing"},"name":"invalidBookingId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CancelBookingResp","version":{"kind":"nothing"}}};

export const snCancelBookingResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CancelBookingResp"};

export function texprCancelBookingResp(): ADL.ATypeExpr<CancelBookingResp> {
  return {value : {typeRef : {kind: "reference", value : snCancelBookingResp}, parameters : []}};
}

export interface JobReq {
  /**
   * The job run mode
   */
  runMode: JobRunMode;
}

export function makeJobReq(
  input: {
    runMode: JobRunMode,
  }
): JobReq {
  return {
    runMode: input.runMode,
  };
}

const JobReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The job run mode\n"}],"serializedName":"runMode","default":{"kind":"nothing"},"name":"runMode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobRunMode"}},"parameters":[]}}]}},"name":"JobReq","version":{"kind":"nothing"}}};

export const snJobReq: ADL.ScopedName = {moduleName:"hotel.api", name:"JobReq"};

export function texprJobReq(): ADL.ATypeExpr<JobReq> {
  return {value : {typeRef : {kind: "reference", value : snJobReq}, parameters : []}};
}

export interface JobResp_JobReport {
  kind: 'jobReport';
  value: JobReport;
}
export interface JobResp_NoEligibleItems {
  kind: 'noEligibleItems';
}
export interface JobResp_Error {
  kind: 'error';
  value: string;
}

export type JobResp = JobResp_JobReport | JobResp_NoEligibleItems | JobResp_Error;

export interface JobRespOpts {
  /**
   * Successful response that comes with a job report
   */
  jobReport: JobReport;
  /**
   * No eligible items were found that match the given criteria
   */
  noEligibleItems: null;
  /**
   * An unknown error occurred, the reason for which will be provided in the message
   */
  error: string;
}

export function makeJobResp<K extends keyof JobRespOpts>(kind: K, value: JobRespOpts[K]) { return {kind, value}; }

const JobResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Successful response that comes with a job report\n"}],"serializedName":"jobReport","default":{"kind":"nothing"},"name":"jobReport","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobReport"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"No eligible items were found that match the given criteria\n"}],"serializedName":"noEligibleItems","default":{"kind":"nothing"},"name":"noEligibleItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An unknown error occurred, the reason for which will be provided in the message\n"}],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"JobResp","version":{"kind":"nothing"}}};

export const snJobResp: ADL.ScopedName = {moduleName:"hotel.api", name:"JobResp"};

export function texprJobResp(): ADL.ATypeExpr<JobResp> {
  return {value : {typeRef : {kind: "reference", value : snJobResp}, parameters : []}};
}

export enum JobRunMode {
  readOnly,
  update,
}

const JobRunMode_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The read-only mode will search for and report eligible items, but it will not process them\n"}],"serializedName":"readOnly","default":{"kind":"nothing"},"name":"readOnly","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The update mode will process the items that match the given criteria\n"}],"serializedName":"update","default":{"kind":"nothing"},"name":"update","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"JobRunMode","version":{"kind":"nothing"}}};

export const snJobRunMode: ADL.ScopedName = {moduleName:"hotel.api", name:"JobRunMode"};

export function texprJobRunMode(): ADL.ATypeExpr<JobRunMode> {
  return {value : {typeRef : {kind: "reference", value : snJobRunMode}, parameters : []}};
}

export interface JobReport {
  /**
   * The description of the job. It can be anything that makes sense and is used in logging.
   */
  description: string;
  /**
   * The running mode of the job
   */
  mode: JobRunMode;
  /**
   * The exact time (in UTC) when the job was executed
   */
  started: common.Instant;
  /**
   * The exact time (in UTC) when the job was completed
   */
  finished: common.Instant;
  /**
   * Total processing time in seconds
   */
  durationSec: number;
  /**
   * A count of all eligible items
   */
  numOfEligibleItems: number;
  /**
   * A count of all items that were successfully processed
   */
  numOfSuccessfulItems: number;
  /**
   * A count of all bookings that failed to be processed
   */
  numOfFailedItems: number;
  /**
   * A list of all eligible items found
   */
  eligibleItems: string[];
  /**
   * A list of all items that were successfully processed
   */
  successfulItems: string[];
  /**
   * A list of all items that failed to be processed, with a description of the error (if available)
   */
  failedItems: sys_types.Pair<string, string>[];
}

export function makeJobReport(
  input: {
    description: string,
    mode: JobRunMode,
    started: common.Instant,
    finished: common.Instant,
    durationSec: number,
    numOfEligibleItems: number,
    numOfSuccessfulItems: number,
    numOfFailedItems: number,
    eligibleItems: string[],
    successfulItems: string[],
    failedItems: sys_types.Pair<string, string>[],
  }
): JobReport {
  return {
    description: input.description,
    mode: input.mode,
    started: input.started,
    finished: input.finished,
    durationSec: input.durationSec,
    numOfEligibleItems: input.numOfEligibleItems,
    numOfSuccessfulItems: input.numOfSuccessfulItems,
    numOfFailedItems: input.numOfFailedItems,
    eligibleItems: input.eligibleItems,
    successfulItems: input.successfulItems,
    failedItems: input.failedItems,
  };
}

const JobReport_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The description of the job. It can be anything that makes sense and is used in logging.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The running mode of the job\n"}],"serializedName":"mode","default":{"kind":"nothing"},"name":"mode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"JobRunMode"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The exact time (in UTC) when the job was executed\n"}],"serializedName":"started","default":{"kind":"nothing"},"name":"started","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The exact time (in UTC) when the job was completed\n"}],"serializedName":"finished","default":{"kind":"nothing"},"name":"finished","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total processing time in seconds\n"}],"serializedName":"durationSec","default":{"kind":"nothing"},"name":"durationSec","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A count of all eligible items\n"}],"serializedName":"numOfEligibleItems","default":{"kind":"nothing"},"name":"numOfEligibleItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A count of all items that were successfully processed\n"}],"serializedName":"numOfSuccessfulItems","default":{"kind":"nothing"},"name":"numOfSuccessfulItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A count of all bookings that failed to be processed\n"}],"serializedName":"numOfFailedItems","default":{"kind":"nothing"},"name":"numOfFailedItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A list of all eligible items found\n"}],"serializedName":"eligibleItems","default":{"kind":"nothing"},"name":"eligibleItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A list of all items that were successfully processed\n"}],"serializedName":"successfulItems","default":{"kind":"nothing"},"name":"successfulItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A list of all items that failed to be processed, with a description of the error (if available)\n"}],"serializedName":"failedItems","default":{"kind":"nothing"},"name":"failedItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Pair"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]},{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}}]}},"name":"JobReport","version":{"kind":"nothing"}}};

export const snJobReport: ADL.ScopedName = {moduleName:"hotel.api", name:"JobReport"};

export function texprJobReport(): ADL.ATypeExpr<JobReport> {
  return {value : {typeRef : {kind: "reference", value : snJobReport}, parameters : []}};
}

export interface ConfirmBookingReq {
  /**
   * The ID of the booking to confirm
   */
  bookingId: common_db.DbKey<hotel_db.Booking>;
  /**
   * The package details used to obtain the latest quote for this booking, if not
   * provided, the quote will be refreshed before making the booking
   */
  packageDetails: (SupplierPackageDetails|null);
}

export function makeConfirmBookingReq(
  input: {
    bookingId: common_db.DbKey<hotel_db.Booking>,
    packageDetails?: (SupplierPackageDetails|null),
  }
): ConfirmBookingReq {
  return {
    bookingId: input.bookingId,
    packageDetails: input.packageDetails === undefined ? null : input.packageDetails,
  };
}

const ConfirmBookingReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the booking to confirm\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package details used to obtain the latest quote for this booking, if not\nprovided, the quote will be refreshed before making the booking\n"}],"serializedName":"packageDetails","default":{"kind":"just","value":null},"name":"packageDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"SupplierPackageDetails"}},"parameters":[]}]}}]}},"name":"ConfirmBookingReq","version":{"kind":"nothing"}}};

export const snConfirmBookingReq: ADL.ScopedName = {moduleName:"hotel.api", name:"ConfirmBookingReq"};

export function texprConfirmBookingReq(): ADL.ATypeExpr<ConfirmBookingReq> {
  return {value : {typeRef : {kind: "reference", value : snConfirmBookingReq}, parameters : []}};
}

/**
 * Describes a payment gateway config data
 */
export interface PaymentClientConfig {
  /**
   * Name of the target gateway
   */
  gatewayName: common_strings.StringNE;
  /**
   * Bootstrap key which is used by clients to integrate with the
   * target gateway, if required
   */
  clientKey: common_strings.StringNE;
  /**
   * Additional gateway specific data
   */
  extra: {[key: string]: string};
}

export function makePaymentClientConfig(
  input: {
    gatewayName: common_strings.StringNE,
    clientKey: common_strings.StringNE,
    extra: {[key: string]: string},
  }
): PaymentClientConfig {
  return {
    gatewayName: input.gatewayName,
    clientKey: input.clientKey,
    extra: input.extra,
  };
}

const PaymentClientConfig_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Describes a payment gateway config data\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of the target gateway\n"}],"serializedName":"gatewayName","default":{"kind":"nothing"},"name":"gatewayName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bootstrap key which is used by clients to integrate with the\ntarget gateway, if required\n"}],"serializedName":"clientKey","default":{"kind":"nothing"},"name":"clientKey","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Additional gateway specific data\n"}],"serializedName":"extra","default":{"kind":"nothing"},"name":"extra","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"PaymentClientConfig","version":{"kind":"nothing"}}};

export const snPaymentClientConfig: ADL.ScopedName = {moduleName:"hotel.api", name:"PaymentClientConfig"};

export function texprPaymentClientConfig(): ADL.ATypeExpr<PaymentClientConfig> {
  return {value : {typeRef : {kind: "reference", value : snPaymentClientConfig}, parameters : []}};
}

export interface PaymentClientConfigResp_Config {
  kind: 'config';
  value: PaymentClientConfig;
}
export interface PaymentClientConfigResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

/**
 * Payment gateway config data
 */
export type PaymentClientConfigResp = PaymentClientConfigResp_Config | PaymentClientConfigResp_Error;

export interface PaymentClientConfigRespOpts {
  config: PaymentClientConfig;
  error: common_strings.StringNE;
}

export function makePaymentClientConfigResp<K extends keyof PaymentClientConfigRespOpts>(kind: K, value: PaymentClientConfigRespOpts[K]) { return {kind, value}; }

const PaymentClientConfigResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment gateway config data\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"config","default":{"kind":"nothing"},"name":"config","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PaymentClientConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"PaymentClientConfigResp","version":{"kind":"nothing"}}};

export const snPaymentClientConfigResp: ADL.ScopedName = {moduleName:"hotel.api", name:"PaymentClientConfigResp"};

export function texprPaymentClientConfigResp(): ADL.ATypeExpr<PaymentClientConfigResp> {
  return {value : {typeRef : {kind: "reference", value : snPaymentClientConfigResp}, parameters : []}};
}

/**
 * A token from the payment gateway that can be used to process a payment
 */
export type CreditCardToken = string;

const CreditCardToken_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A token from the payment gateway that can be used to process a payment\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"CreditCardToken","version":{"kind":"nothing"}}};

export const snCreditCardToken: ADL.ScopedName = {moduleName:"hotel.api", name:"CreditCardToken"};

export function texprCreditCardToken(): ADL.ATypeExpr<CreditCardToken> {
  return {value : {typeRef : {kind: "reference", value : snCreditCardToken}, parameters : []}};
}

export interface PayForBookingReq {
  /**
   * The ID of the booking to confirm
   */
  bookingId: common_db.DbKey<hotel_db.Booking>;
  /**
   * The package details used to obtain the latest quote for this booking (if
   * the booking is still in quote state), if not provided, the quote will be
   * refreshed before making the booking
   */
  packageDetails: (SupplierPackageDetails|null);
  /**
   * Tokenized credit card details, if required
   */
  creditCardToken: (CreditCardToken|null);
  /**
   * Payment options
   */
  paymentOptions: hotel_booking.PaymentOptions;
}

export function makePayForBookingReq(
  input: {
    bookingId: common_db.DbKey<hotel_db.Booking>,
    packageDetails?: (SupplierPackageDetails|null),
    creditCardToken: (CreditCardToken|null),
    paymentOptions: hotel_booking.PaymentOptions,
  }
): PayForBookingReq {
  return {
    bookingId: input.bookingId,
    packageDetails: input.packageDetails === undefined ? null : input.packageDetails,
    creditCardToken: input.creditCardToken,
    paymentOptions: input.paymentOptions,
  };
}

const PayForBookingReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the booking to confirm\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package details used to obtain the latest quote for this booking (if\nthe booking is still in quote state), if not provided, the quote will be\nrefreshed before making the booking\n"}],"serializedName":"packageDetails","default":{"kind":"just","value":null},"name":"packageDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"SupplierPackageDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Tokenized credit card details, if required\n"}],"serializedName":"creditCardToken","default":{"kind":"nothing"},"name":"creditCardToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"CreditCardToken"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment options\n"}],"serializedName":"paymentOptions","default":{"kind":"nothing"},"name":"paymentOptions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"PaymentOptions"}},"parameters":[]}}]}},"name":"PayForBookingReq","version":{"kind":"nothing"}}};

export const snPayForBookingReq: ADL.ScopedName = {moduleName:"hotel.api", name:"PayForBookingReq"};

export function texprPayForBookingReq(): ADL.ATypeExpr<PayForBookingReq> {
  return {value : {typeRef : {kind: "reference", value : snPayForBookingReq}, parameters : []}};
}

/**
 * Successful payment result data.
 */
export interface BookingPaymentResult {
  status: hotel_booking.BookingPaymentStatus;
  transactionToken: (common_strings.StringNE|null);
  extra: {[key: string]: string};
}

export function makeBookingPaymentResult(
  input: {
    status: hotel_booking.BookingPaymentStatus,
    transactionToken: (common_strings.StringNE|null),
    extra: {[key: string]: string},
  }
): BookingPaymentResult {
  return {
    status: input.status,
    transactionToken: input.transactionToken,
    extra: input.extra,
  };
}

const BookingPaymentResult_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Successful payment result data.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"BookingPaymentStatus"}},"parameters":[]}},{"annotations":[],"serializedName":"transactionToken","default":{"kind":"nothing"},"name":"transactionToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"extra","default":{"kind":"nothing"},"name":"extra","typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"BookingPaymentResult","version":{"kind":"nothing"}}};

export const snBookingPaymentResult: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingPaymentResult"};

export function texprBookingPaymentResult(): ADL.ATypeExpr<BookingPaymentResult> {
  return {value : {typeRef : {kind: "reference", value : snBookingPaymentResult}, parameters : []}};
}

export interface PayForBookingResp_Success {
  kind: 'success';
  value: BookingPaymentResult;
}
export interface PayForBookingResp_PackageNotAvailable {
  kind: 'packageNotAvailable';
}
export interface PayForBookingResp_CannotConfirm {
  kind: 'cannotConfirm';
  value: string;
}
export interface PayForBookingResp_InstantPurchaseRequired {
  kind: 'instantPurchaseRequired';
}
export interface PayForBookingResp_SupplierError {
  kind: 'supplierError';
}
export interface PayForBookingResp_InvalidBookingId {
  kind: 'invalidBookingId';
}
export interface PayForBookingResp_PriceChanged {
  kind: 'priceChanged';
}
export interface PayForBookingResp_CardError {
  kind: 'cardError';
}
export interface PayForBookingResp_Error {
  kind: 'error';
  value: string;
}

export type PayForBookingResp = PayForBookingResp_Success | PayForBookingResp_PackageNotAvailable | PayForBookingResp_CannotConfirm | PayForBookingResp_InstantPurchaseRequired | PayForBookingResp_SupplierError | PayForBookingResp_InvalidBookingId | PayForBookingResp_PriceChanged | PayForBookingResp_CardError | PayForBookingResp_Error;

export interface PayForBookingRespOpts {
  /**
   * The booking payment was accepted.
   * Explore the BookingPaymentResult.status to find out the current state.
   */
  success: BookingPaymentResult;
  /**
   * The package is no longer available
   */
  packageNotAvailable: null;
  /**
   * The booking could not be confirmed, the reason for which will be provided
   * in the String message, e.g. booking already confirmed
   */
  cannotConfirm: string;
  /**
   * The hotel cannot be booked without upfront payment.
   */
  instantPurchaseRequired: null;
  /**
   * An error occurred when trying to pay for the booking with the supplier.
   * The user should contact the company to resolve this
   */
  supplierError: null;
  /**
   * The booking ID provided is invalid
   */
  invalidBookingId: null;
  /**
   * The price has changed since the quote was generated, so the agent must
   * verify that they are happy with the new price before attempting to book
   * again
   */
  priceChanged: null;
  /**
   * The credit card provided by the agent could not be charged
   */
  cardError: null;
  /**
   * An unknown error occurred, the reason for which will be provided in the
   * message
   */
  error: string;
}

export function makePayForBookingResp<K extends keyof PayForBookingRespOpts>(kind: K, value: PayForBookingRespOpts[K]) { return {kind, value}; }

const PayForBookingResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking payment was accepted.\nExplore the BookingPaymentResult.status to find out the current state.\n"}],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingPaymentResult"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package is no longer available\n"}],"serializedName":"packageNotAvailable","default":{"kind":"nothing"},"name":"packageNotAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking could not be confirmed, the reason for which will be provided\nin the String message, e.g. booking already confirmed\n"}],"serializedName":"cannotConfirm","default":{"kind":"nothing"},"name":"cannotConfirm","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel cannot be booked without upfront payment.\n"}],"serializedName":"instantPurchaseRequired","default":{"kind":"nothing"},"name":"instantPurchaseRequired","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An error occurred when trying to pay for the booking with the supplier.\nThe user should contact the company to resolve this\n"}],"serializedName":"supplierError","default":{"kind":"nothing"},"name":"supplierError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking ID provided is invalid\n"}],"serializedName":"invalidBookingId","default":{"kind":"nothing"},"name":"invalidBookingId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price has changed since the quote was generated, so the agent must\nverify that they are happy with the new price before attempting to book\nagain\n"}],"serializedName":"priceChanged","default":{"kind":"nothing"},"name":"priceChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The credit card provided by the agent could not be charged\n"}],"serializedName":"cardError","default":{"kind":"nothing"},"name":"cardError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An unknown error occurred, the reason for which will be provided in the\nmessage\n"}],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"PayForBookingResp","version":{"kind":"nothing"}}};

export const snPayForBookingResp: ADL.ScopedName = {moduleName:"hotel.api", name:"PayForBookingResp"};

export function texprPayForBookingResp(): ADL.ATypeExpr<PayForBookingResp> {
  return {value : {typeRef : {kind: "reference", value : snPayForBookingResp}, parameters : []}};
}

export interface FinalizePaymentReq {
  /**
   * Affected payment reference
   */
  paymentId: common_db.DbKey<hotel_db.Payment>;
  /**
   * Affected transaction reference
   */
  transactionRef: hotel_booking.TransactionRef;
}

export function makeFinalizePaymentReq(
  input: {
    paymentId: common_db.DbKey<hotel_db.Payment>,
    transactionRef: hotel_booking.TransactionRef,
  }
): FinalizePaymentReq {
  return {
    paymentId: input.paymentId,
    transactionRef: input.transactionRef,
  };
}

const FinalizePaymentReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Affected payment reference\n"}],"serializedName":"paymentId","default":{"kind":"nothing"},"name":"paymentId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Payment"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Affected transaction reference\n"}],"serializedName":"transactionRef","default":{"kind":"nothing"},"name":"transactionRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"TransactionRef"}},"parameters":[]}}]}},"name":"FinalizePaymentReq","version":{"kind":"nothing"}}};

export const snFinalizePaymentReq: ADL.ScopedName = {moduleName:"hotel.api", name:"FinalizePaymentReq"};

export function texprFinalizePaymentReq(): ADL.ATypeExpr<FinalizePaymentReq> {
  return {value : {typeRef : {kind: "reference", value : snFinalizePaymentReq}, parameters : []}};
}

export interface FinalizePaymentResp_Success {
  kind: 'success';
}
export interface FinalizePaymentResp_Error {
  kind: 'error';
  value: string;
}

export type FinalizePaymentResp = FinalizePaymentResp_Success | FinalizePaymentResp_Error;

export interface FinalizePaymentRespOpts {
  success: null;
  error: string;
}

export function makeFinalizePaymentResp<K extends keyof FinalizePaymentRespOpts>(kind: K, value: FinalizePaymentRespOpts[K]) { return {kind, value}; }

const FinalizePaymentResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"FinalizePaymentResp","version":{"kind":"nothing"}}};

export const snFinalizePaymentResp: ADL.ScopedName = {moduleName:"hotel.api", name:"FinalizePaymentResp"};

export function texprFinalizePaymentResp(): ADL.ATypeExpr<FinalizePaymentResp> {
  return {value : {typeRef : {kind: "reference", value : snFinalizePaymentResp}, parameters : []}};
}

export interface SupplierPackageDetails {
  /**
   * The price token representing the search for a hotel
   */
  priceToken: PriceToken;
  /**
   * The ID of the selected package
   */
  packageId: PackageId;
}

export function makeSupplierPackageDetails(
  input: {
    priceToken: PriceToken,
    packageId: PackageId,
  }
): SupplierPackageDetails {
  return {
    priceToken: input.priceToken,
    packageId: input.packageId,
  };
}

const SupplierPackageDetails_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token representing the search for a hotel\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the selected package\n"}],"serializedName":"packageId","default":{"kind":"nothing"},"name":"packageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageId"}},"parameters":[]}}]}},"name":"SupplierPackageDetails","version":{"kind":"nothing"}}};

export const snSupplierPackageDetails: ADL.ScopedName = {moduleName:"hotel.api", name:"SupplierPackageDetails"};

export function texprSupplierPackageDetails(): ADL.ATypeExpr<SupplierPackageDetails> {
  return {value : {typeRef : {kind: "reference", value : snSupplierPackageDetails}, parameters : []}};
}

export interface ConfirmBookingResp_Success {
  kind: 'success';
}
export interface ConfirmBookingResp_PackageNotAvailable {
  kind: 'packageNotAvailable';
}
export interface ConfirmBookingResp_CannotConfirm {
  kind: 'cannotConfirm';
  value: string;
}
export interface ConfirmBookingResp_InstantPurchaseRequired {
  kind: 'instantPurchaseRequired';
}
export interface ConfirmBookingResp_SupplierError {
  kind: 'supplierError';
}
export interface ConfirmBookingResp_InvalidBookingId {
  kind: 'invalidBookingId';
}
export interface ConfirmBookingResp_Error {
  kind: 'error';
  value: string;
}

export type ConfirmBookingResp = ConfirmBookingResp_Success | ConfirmBookingResp_PackageNotAvailable | ConfirmBookingResp_CannotConfirm | ConfirmBookingResp_InstantPurchaseRequired | ConfirmBookingResp_SupplierError | ConfirmBookingResp_InvalidBookingId | ConfirmBookingResp_Error;

export interface ConfirmBookingRespOpts {
  /**
   * The booking was confirmed successfully
   */
  success: null;
  /**
   * The package is no longer available
   */
  packageNotAvailable: null;
  /**
   * The booking could not be confirmed, the reason for which will be provided
   * in the String message, e.g. booking already confirmed
   */
  cannotConfirm: string;
  /**
   * The hotel cannot be booked without upfront payment.
   */
  instantPurchaseRequired: null;
  /**
   * An error occurred when trying to confirm the booking with the supplier.
   * The user should try again later
   */
  supplierError: null;
  /**
   * The booking ID provided is invalid
   */
  invalidBookingId: null;
  /**
   * An unknown error occurred, the reason for which will be provided in the
   * message
   */
  error: string;
}

export function makeConfirmBookingResp<K extends keyof ConfirmBookingRespOpts>(kind: K, value: ConfirmBookingRespOpts[K]) { return {kind, value}; }

const ConfirmBookingResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking was confirmed successfully\n"}],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package is no longer available\n"}],"serializedName":"packageNotAvailable","default":{"kind":"nothing"},"name":"packageNotAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking could not be confirmed, the reason for which will be provided\nin the String message, e.g. booking already confirmed\n"}],"serializedName":"cannotConfirm","default":{"kind":"nothing"},"name":"cannotConfirm","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel cannot be booked without upfront payment.\n"}],"serializedName":"instantPurchaseRequired","default":{"kind":"nothing"},"name":"instantPurchaseRequired","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An error occurred when trying to confirm the booking with the supplier.\nThe user should try again later\n"}],"serializedName":"supplierError","default":{"kind":"nothing"},"name":"supplierError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking ID provided is invalid\n"}],"serializedName":"invalidBookingId","default":{"kind":"nothing"},"name":"invalidBookingId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An unknown error occurred, the reason for which will be provided in the\nmessage\n"}],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ConfirmBookingResp","version":{"kind":"nothing"}}};

export const snConfirmBookingResp: ADL.ScopedName = {moduleName:"hotel.api", name:"ConfirmBookingResp"};

export function texprConfirmBookingResp(): ADL.ATypeExpr<ConfirmBookingResp> {
  return {value : {typeRef : {kind: "reference", value : snConfirmBookingResp}, parameters : []}};
}

export interface PaymentDetailsReq {
  /**
   * The price token used to perform the initial search
   */
  priceToken: PriceToken;
  /**
   * The hotel ID we want price details for, this must be a hotel that was
   * used for a AvailablePackagesQuery for this PriceToken
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * The ID of the package that we want payment details for. Must be a package
   * ID that was returned from AvailablePackagesQuery using this PriceToken
   */
  packageId: PackageId;
  /**
   * The commission percentage that the agent wants to apply to this booking
   */
  commissionPercentage: common.BigDecimal;
}

export function makePaymentDetailsReq(
  input: {
    priceToken: PriceToken,
    hotelId: common_db.DbKey<ids_db.Hotel>,
    packageId: PackageId,
    commissionPercentage: common.BigDecimal,
  }
): PaymentDetailsReq {
  return {
    priceToken: input.priceToken,
    hotelId: input.hotelId,
    packageId: input.packageId,
    commissionPercentage: input.commissionPercentage,
  };
}

const PaymentDetailsReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token used to perform the initial search\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel ID we want price details for, this must be a hotel that was\nused for a AvailablePackagesQuery for this PriceToken\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the package that we want payment details for. Must be a package\nID that was returned from AvailablePackagesQuery using this PriceToken\n"}],"serializedName":"packageId","default":{"kind":"nothing"},"name":"packageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageId"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The commission percentage that the agent wants to apply to this booking\n"}],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"PaymentDetailsReq","version":{"kind":"nothing"}}};

export const snPaymentDetailsReq: ADL.ScopedName = {moduleName:"hotel.api", name:"PaymentDetailsReq"};

export function texprPaymentDetailsReq(): ADL.ATypeExpr<PaymentDetailsReq> {
  return {value : {typeRef : {kind: "reference", value : snPaymentDetailsReq}, parameters : []}};
}

export interface PaymentDetailsResp_Details {
  kind: 'details';
  value: PaymentDetails;
}
export interface PaymentDetailsResp_InvalidPriceToken {
  kind: 'invalidPriceToken';
}
export interface PaymentDetailsResp_InvalidHotelId {
  kind: 'invalidHotelId';
}
export interface PaymentDetailsResp_SupplierError {
  kind: 'supplierError';
}
export interface PaymentDetailsResp_PackageNotAvailable {
  kind: 'packageNotAvailable';
}

export type PaymentDetailsResp = PaymentDetailsResp_Details | PaymentDetailsResp_InvalidPriceToken | PaymentDetailsResp_InvalidHotelId | PaymentDetailsResp_SupplierError | PaymentDetailsResp_PackageNotAvailable;

export interface PaymentDetailsRespOpts {
  /**
   * Payment details were fetched successfully
   */
  details: PaymentDetails;
  /**
   * The price token provided was invalid or expired. The user will have to
   * repeat their search
   */
  invalidPriceToken: null;
  /**
   * The hotel ID provided was invalid
   */
  invalidHotelId: null;
  /**
   * The supplier returned an error and the price details could not be fetched
   */
  supplierError: null;
  /**
   * The package has become unavailable
   */
  packageNotAvailable: null;
}

export function makePaymentDetailsResp<K extends keyof PaymentDetailsRespOpts>(kind: K, value: PaymentDetailsRespOpts[K]) { return {kind, value}; }

const PaymentDetailsResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment details were fetched successfully\n"}],"serializedName":"details","default":{"kind":"nothing"},"name":"details","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PaymentDetails"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token provided was invalid or expired. The user will have to\nrepeat their search\n"}],"serializedName":"invalidPriceToken","default":{"kind":"nothing"},"name":"invalidPriceToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel ID provided was invalid\n"}],"serializedName":"invalidHotelId","default":{"kind":"nothing"},"name":"invalidHotelId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The supplier returned an error and the price details could not be fetched\n"}],"serializedName":"supplierError","default":{"kind":"nothing"},"name":"supplierError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package has become unavailable\n"}],"serializedName":"packageNotAvailable","default":{"kind":"nothing"},"name":"packageNotAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"PaymentDetailsResp","version":{"kind":"nothing"}}};

export const snPaymentDetailsResp: ADL.ScopedName = {moduleName:"hotel.api", name:"PaymentDetailsResp"};

export function texprPaymentDetailsResp(): ADL.ATypeExpr<PaymentDetailsResp> {
  return {value : {typeRef : {kind: "reference", value : snPaymentDetailsResp}, parameters : []}};
}

/**
 * Booking price details.
 */
export interface PaymentDetails {
  /**
   * Buy price including the platform markup and tax
   */
  netPriceWithTax: hotel_common.PriceValue;
  /**
   * The netPrice including the agent commission and tax
   */
  grossPriceWithTax: hotel_common.PriceValue;
  /**
   * True if the user has the option to book-and-hold without paying
   */
  canBookAndHold: boolean;
}

export function makePaymentDetails(
  input: {
    netPriceWithTax: hotel_common.PriceValue,
    grossPriceWithTax: hotel_common.PriceValue,
    canBookAndHold: boolean,
  }
): PaymentDetails {
  return {
    netPriceWithTax: input.netPriceWithTax,
    grossPriceWithTax: input.grossPriceWithTax,
    canBookAndHold: input.canBookAndHold,
  };
}

const PaymentDetails_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking price details.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Buy price including the platform markup and tax\n"}],"serializedName":"netPriceWithTax","default":{"kind":"nothing"},"name":"netPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The netPrice including the agent commission and tax\n"}],"serializedName":"grossPriceWithTax","default":{"kind":"nothing"},"name":"grossPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"True if the user has the option to book-and-hold without paying\n"}],"serializedName":"canBookAndHold","default":{"kind":"nothing"},"name":"canBookAndHold","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"PaymentDetails","version":{"kind":"nothing"}}};

export const snPaymentDetails: ADL.ScopedName = {moduleName:"hotel.api", name:"PaymentDetails"};

export function texprPaymentDetails(): ADL.ATypeExpr<PaymentDetails> {
  return {value : {typeRef : {kind: "reference", value : snPaymentDetails}, parameters : []}};
}

export interface CancellationPoliciesQuery {
  hotelId: common_db.DbKey<ids_db.Hotel>;
  priceToken: PriceToken;
  commissionPercentage: common.BigDecimal;
}

export function makeCancellationPoliciesQuery(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    priceToken: PriceToken,
    commissionPercentage: common.BigDecimal,
  }
): CancellationPoliciesQuery {
  return {
    hotelId: input.hotelId,
    priceToken: input.priceToken,
    commissionPercentage: input.commissionPercentage,
  };
}

const CancellationPoliciesQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"CancellationPoliciesQuery","version":{"kind":"nothing"}}};

export const snCancellationPoliciesQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"CancellationPoliciesQuery"};

export function texprCancellationPoliciesQuery(): ADL.ATypeExpr<CancellationPoliciesQuery> {
  return {value : {typeRef : {kind: "reference", value : snCancellationPoliciesQuery}, parameters : []}};
}

export interface CancellationPoliciesResp_PackageCancellationPolicies {
  kind: 'packageCancellationPolicies';
  value: PackageCancellationPolicyWithId[];
}
export interface CancellationPoliciesResp_InvalidPriceToken {
  kind: 'invalidPriceToken';
}
export interface CancellationPoliciesResp_InvalidHotelId {
  kind: 'invalidHotelId';
}

export type CancellationPoliciesResp = CancellationPoliciesResp_PackageCancellationPolicies | CancellationPoliciesResp_InvalidPriceToken | CancellationPoliciesResp_InvalidHotelId;

export interface CancellationPoliciesRespOpts {
  /**
   * Successful response with a list of cancellation policies to present to the client
   */
  packageCancellationPolicies: PackageCancellationPolicyWithId[];
  /**
   * The price token provided by the client is either invalid or expired and
   * they should initiate their search again
   */
  invalidPriceToken: null;
  /**
   * The hotel ID requested was not included in the results of the hotel
   * search defined by the provided price token
   */
  invalidHotelId: null;
}

export function makeCancellationPoliciesResp<K extends keyof CancellationPoliciesRespOpts>(kind: K, value: CancellationPoliciesRespOpts[K]) { return {kind, value}; }

const CancellationPoliciesResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Successful response with a list of cancellation policies to present to the client\n"}],"serializedName":"packageCancellationPolicies","default":{"kind":"nothing"},"name":"packageCancellationPolicies","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageCancellationPolicyWithId"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token provided by the client is either invalid or expired and\nthey should initiate their search again\n"}],"serializedName":"invalidPriceToken","default":{"kind":"nothing"},"name":"invalidPriceToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel ID requested was not included in the results of the hotel\nsearch defined by the provided price token\n"}],"serializedName":"invalidHotelId","default":{"kind":"nothing"},"name":"invalidHotelId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CancellationPoliciesResp","version":{"kind":"nothing"}}};

export const snCancellationPoliciesResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CancellationPoliciesResp"};

export function texprCancellationPoliciesResp(): ADL.ATypeExpr<CancellationPoliciesResp> {
  return {value : {typeRef : {kind: "reference", value : snCancellationPoliciesResp}, parameters : []}};
}

export interface PackageCancellationPolicyWithId {
  packageId: PackageId;
  policy: hotel_common.PackageCancellationPolicy;
}

export function makePackageCancellationPolicyWithId(
  input: {
    packageId: PackageId,
    policy: hotel_common.PackageCancellationPolicy,
  }
): PackageCancellationPolicyWithId {
  return {
    packageId: input.packageId,
    policy: input.policy,
  };
}

const PackageCancellationPolicyWithId_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"packageId","default":{"kind":"nothing"},"name":"packageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageId"}},"parameters":[]}},{"annotations":[],"serializedName":"policy","default":{"kind":"nothing"},"name":"policy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PackageCancellationPolicy"}},"parameters":[]}}]}},"name":"PackageCancellationPolicyWithId","version":{"kind":"nothing"}}};

export const snPackageCancellationPolicyWithId: ADL.ScopedName = {moduleName:"hotel.api", name:"PackageCancellationPolicyWithId"};

export function texprPackageCancellationPolicyWithId(): ADL.ATypeExpr<PackageCancellationPolicyWithId> {
  return {value : {typeRef : {kind: "reference", value : snPackageCancellationPolicyWithId}, parameters : []}};
}

export interface AvailablePackagesQuery {
  hotelId: common_db.DbKey<ids_db.Hotel>;
  priceToken: PriceToken;
  commissionPercentage: common.BigDecimal;
}

export function makeAvailablePackagesQuery(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    priceToken: PriceToken,
    commissionPercentage: common.BigDecimal,
  }
): AvailablePackagesQuery {
  return {
    hotelId: input.hotelId,
    priceToken: input.priceToken,
    commissionPercentage: input.commissionPercentage,
  };
}

const AvailablePackagesQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"AvailablePackagesQuery","version":{"kind":"nothing"}}};

export const snAvailablePackagesQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"AvailablePackagesQuery"};

export function texprAvailablePackagesQuery(): ADL.ATypeExpr<AvailablePackagesQuery> {
  return {value : {typeRef : {kind: "reference", value : snAvailablePackagesQuery}, parameters : []}};
}

export interface AvailablePackagesResp_Packages {
  kind: 'packages';
  value: PackageInfo[];
}
export interface AvailablePackagesResp_InvalidPriceToken {
  kind: 'invalidPriceToken';
}
export interface AvailablePackagesResp_InvalidHotelId {
  kind: 'invalidHotelId';
}

export type AvailablePackagesResp = AvailablePackagesResp_Packages | AvailablePackagesResp_InvalidPriceToken | AvailablePackagesResp_InvalidHotelId;

export interface AvailablePackagesRespOpts {
  /**
   * Successful response with a list of packages to present to the client
   */
  packages: PackageInfo[];
  /**
   * The price token provided by the client is either invalid or expired and
   * they should initiate their search again
   */
  invalidPriceToken: null;
  /**
   * The hotel ID requested was not included in the results of the hotel
   * search defined by the provided price token
   */
  invalidHotelId: null;
}

export function makeAvailablePackagesResp<K extends keyof AvailablePackagesRespOpts>(kind: K, value: AvailablePackagesRespOpts[K]) { return {kind, value}; }

const AvailablePackagesResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Successful response with a list of packages to present to the client\n"}],"serializedName":"packages","default":{"kind":"nothing"},"name":"packages","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageInfo"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token provided by the client is either invalid or expired and\nthey should initiate their search again\n"}],"serializedName":"invalidPriceToken","default":{"kind":"nothing"},"name":"invalidPriceToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel ID requested was not included in the results of the hotel\nsearch defined by the provided price token\n"}],"serializedName":"invalidHotelId","default":{"kind":"nothing"},"name":"invalidHotelId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"AvailablePackagesResp","version":{"kind":"nothing"}}};

export const snAvailablePackagesResp: ADL.ScopedName = {moduleName:"hotel.api", name:"AvailablePackagesResp"};

export function texprAvailablePackagesResp(): ADL.ATypeExpr<AvailablePackagesResp> {
  return {value : {typeRef : {kind: "reference", value : snAvailablePackagesResp}, parameters : []}};
}

export interface PackageInfo {
  /**
   * ID of the package that can be used to book this hotel room
   */
  packageId: PackageId;
  /**
   * The room keys of the package content source
   */
  roomKeys: string[];
  /**
   * The name of the room, e.g. "Double queen"
   */
  name: string;
  /**
   * Description of the bed configuration in this room, e.g. "2 double beds"
   */
  bedConfigurations: string[];
  /**
   * The maximum number of occupants in this room
   */
  occupancy: number;
  /**
   * Total floor area of this room, or null if this information is not
   * available
   */
  area: (ids_hotel.AreaSqM|null);
  /**
   * Cancellation policy for this room
   */
  cancellationPolicy: SimpleCancellationPolicy;
  /**
   * Thumbnail image to use for the room in the listing results, or null if
   * one isn't available
   */
  thumbnailUrl: (string|null);
  /**
   * Board for this room
   */
  board: hotel_booking.Board;
  /**
   * Any room amenities available for this room type, e.g. Free wifi
   */
  roomAmenities: string[];
  /**
   * The total rate for this room
   */
  price: hotel_common.PriceValue;
  /**
   * Full taxes and fees breakdown as received from supplier
   */
  taxesAndFees: TaxesAndFees[];
  /**
   * Indication of package rate for the provided room package
   */
  isPackageRate: boolean;
}

export function makePackageInfo(
  input: {
    packageId: PackageId,
    roomKeys: string[],
    name: string,
    bedConfigurations: string[],
    occupancy: number,
    area?: (ids_hotel.AreaSqM|null),
    cancellationPolicy: SimpleCancellationPolicy,
    thumbnailUrl?: (string|null),
    board: hotel_booking.Board,
    roomAmenities: string[],
    price: hotel_common.PriceValue,
    taxesAndFees: TaxesAndFees[],
    isPackageRate: boolean,
  }
): PackageInfo {
  return {
    packageId: input.packageId,
    roomKeys: input.roomKeys,
    name: input.name,
    bedConfigurations: input.bedConfigurations,
    occupancy: input.occupancy,
    area: input.area === undefined ? null : input.area,
    cancellationPolicy: input.cancellationPolicy,
    thumbnailUrl: input.thumbnailUrl === undefined ? null : input.thumbnailUrl,
    board: input.board,
    roomAmenities: input.roomAmenities,
    price: input.price,
    taxesAndFees: input.taxesAndFees,
    isPackageRate: input.isPackageRate,
  };
}

const PackageInfo_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"ID of the package that can be used to book this hotel room\n"}],"serializedName":"packageId","default":{"kind":"nothing"},"name":"packageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageId"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The room keys of the package content source\n"}],"serializedName":"roomKeys","default":{"kind":"nothing"},"name":"roomKeys","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The name of the room, e.g. \"Double queen\"\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Description of the bed configuration in this room, e.g. \"2 double beds\"\n"}],"serializedName":"bedConfigurations","default":{"kind":"nothing"},"name":"bedConfigurations","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The maximum number of occupants in this room\n"}],"serializedName":"occupancy","default":{"kind":"nothing"},"name":"occupancy","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total floor area of this room, or null if this information is not\navailable\n"}],"serializedName":"area","default":{"kind":"just","value":null},"name":"area","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"AreaSqM"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancellation policy for this room\n"}],"serializedName":"cancellationPolicy","default":{"kind":"nothing"},"name":"cancellationPolicy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"SimpleCancellationPolicy"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Thumbnail image to use for the room in the listing results, or null if\none isn't available\n"}],"serializedName":"thumbnailUrl","default":{"kind":"just","value":null},"name":"thumbnailUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Board for this room\n"}],"serializedName":"board","default":{"kind":"nothing"},"name":"board","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"Board"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Any room amenities available for this room type, e.g. Free wifi\n"}],"serializedName":"roomAmenities","default":{"kind":"nothing"},"name":"roomAmenities","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The total rate for this room\n"}],"serializedName":"price","default":{"kind":"nothing"},"name":"price","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Full taxes and fees breakdown as received from supplier\n"}],"serializedName":"taxesAndFees","default":{"kind":"nothing"},"name":"taxesAndFees","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"TaxesAndFees"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Indication of package rate for the provided room package\n"}],"serializedName":"isPackageRate","default":{"kind":"nothing"},"name":"isPackageRate","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"PackageInfo","version":{"kind":"nothing"}}};

export const snPackageInfo: ADL.ScopedName = {moduleName:"hotel.api", name:"PackageInfo"};

export function texprPackageInfo(): ADL.ATypeExpr<PackageInfo> {
  return {value : {typeRef : {kind: "reference", value : snPackageInfo}, parameters : []}};
}

export interface TaxesAndFees {
  /**
   * The taxes and fees title as the supplier returned
   */
  feeTitle: string;
  /**
   * The decimal value and currency of the taxes and fees as the supplier returned
   */
  fee: hotel_common.PriceValue;
  /**
   * Represents the taxes and fees categorization type
   */
  unitType: string;
  /**
   * Represents the tax repetitive type
   */
  frequencyType: string;
  /**
   * Represents if the taxes and fees are included in the final price
   */
  isIncludedInPrice: boolean;
  /**
   * Represents if the taxes and fees are mandatory to be paid
   */
  isMandatory: boolean;
  /**
   * Represents if the tax or fee is percentage value or an absolute value
   */
  isValuePercentage: (boolean|null);
}

export function makeTaxesAndFees(
  input: {
    feeTitle: string,
    fee: hotel_common.PriceValue,
    unitType: string,
    frequencyType: string,
    isIncludedInPrice: boolean,
    isMandatory: boolean,
    isValuePercentage: (boolean|null),
  }
): TaxesAndFees {
  return {
    feeTitle: input.feeTitle,
    fee: input.fee,
    unitType: input.unitType,
    frequencyType: input.frequencyType,
    isIncludedInPrice: input.isIncludedInPrice,
    isMandatory: input.isMandatory,
    isValuePercentage: input.isValuePercentage,
  };
}

const TaxesAndFees_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The taxes and fees title as the supplier returned\n"}],"serializedName":"feeTitle","default":{"kind":"nothing"},"name":"feeTitle","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The decimal value and currency of the taxes and fees as the supplier returned\n"}],"serializedName":"fee","default":{"kind":"nothing"},"name":"fee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the taxes and fees categorization type\n"}],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the tax repetitive type\n"}],"serializedName":"frequencyType","default":{"kind":"nothing"},"name":"frequencyType","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents if the taxes and fees are included in the final price\n"}],"serializedName":"isIncludedInPrice","default":{"kind":"nothing"},"name":"isIncludedInPrice","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents if the taxes and fees are mandatory to be paid\n"}],"serializedName":"isMandatory","default":{"kind":"nothing"},"name":"isMandatory","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents if the tax or fee is percentage value or an absolute value\n"}],"serializedName":"isValuePercentage","default":{"kind":"nothing"},"name":"isValuePercentage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}}]}},"name":"TaxesAndFees","version":{"kind":"nothing"}}};

export const snTaxesAndFees: ADL.ScopedName = {moduleName:"hotel.api", name:"TaxesAndFees"};

export function texprTaxesAndFees(): ADL.ATypeExpr<TaxesAndFees> {
  return {value : {typeRef : {kind: "reference", value : snTaxesAndFees}, parameters : []}};
}

export interface SimpleCancellationPolicy_FreeCancellation {
  kind: 'freeCancellation';
}
export interface SimpleCancellationPolicy_FreeCancellationUntil {
  kind: 'freeCancellationUntil';
  value: common.LocalDate;
}
export interface SimpleCancellationPolicy_NoCancellation {
  kind: 'noCancellation';
}
export interface SimpleCancellationPolicy_CancellationNotAvailable {
  kind: 'cancellationNotAvailable';
}

/**
 * Simple representation of a package's cancellation policy
 */
export type SimpleCancellationPolicy = SimpleCancellationPolicy_FreeCancellation | SimpleCancellationPolicy_FreeCancellationUntil | SimpleCancellationPolicy_NoCancellation | SimpleCancellationPolicy_CancellationNotAvailable;

export interface SimpleCancellationPolicyOpts {
  freeCancellation: null;
  freeCancellationUntil: common.LocalDate;
  noCancellation: null;
  cancellationNotAvailable: null;
}

export function makeSimpleCancellationPolicy<K extends keyof SimpleCancellationPolicyOpts>(kind: K, value: SimpleCancellationPolicyOpts[K]) { return {kind, value}; }

const SimpleCancellationPolicy_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Simple representation of a package's cancellation policy\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"freeCancellation","default":{"kind":"nothing"},"name":"freeCancellation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"freeCancellationUntil","default":{"kind":"nothing"},"name":"freeCancellationUntil","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"noCancellation","default":{"kind":"nothing"},"name":"noCancellation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"cancellationNotAvailable","default":{"kind":"nothing"},"name":"cancellationNotAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SimpleCancellationPolicy","version":{"kind":"nothing"}}};

export const snSimpleCancellationPolicy: ADL.ScopedName = {moduleName:"hotel.api", name:"SimpleCancellationPolicy"};

export function texprSimpleCancellationPolicy(): ADL.ATypeExpr<SimpleCancellationPolicy> {
  return {value : {typeRef : {kind: "reference", value : snSimpleCancellationPolicy}, parameters : []}};
}

export interface LeadingPriceQuery {
  /**
   * Hotels to query the price for
   */
  hotelsToQuery: common_db.DbKey<ids_db.Hotel>[];
  /**
   * The search to reference for these prices
   */
  priceToken: PriceToken;
  /**
   * Commission percentage to use for this search
   */
  commissionPercentage: common.BigDecimal;
}

export function makeLeadingPriceQuery(
  input: {
    hotelsToQuery: common_db.DbKey<ids_db.Hotel>[],
    priceToken: PriceToken,
    commissionPercentage: common.BigDecimal,
  }
): LeadingPriceQuery {
  return {
    hotelsToQuery: input.hotelsToQuery,
    priceToken: input.priceToken,
    commissionPercentage: input.commissionPercentage,
  };
}

const LeadingPriceQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotels to query the price for\n"}],"serializedName":"hotelsToQuery","default":{"kind":"nothing"},"name":"hotelsToQuery","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The search to reference for these prices\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Commission percentage to use for this search\n"}],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"LeadingPriceQuery","version":{"kind":"nothing"}}};

export const snLeadingPriceQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"LeadingPriceQuery"};

export function texprLeadingPriceQuery(): ADL.ATypeExpr<LeadingPriceQuery> {
  return {value : {typeRef : {kind: "reference", value : snLeadingPriceQuery}, parameters : []}};
}

export interface LeadingPriceQueryResp {
  /**
   * The prices returned from the price search
   */
  prices: HotelLeadingPrice[];
}

export function makeLeadingPriceQueryResp(
  input: {
    prices: HotelLeadingPrice[],
  }
): LeadingPriceQueryResp {
  return {
    prices: input.prices,
  };
}

const LeadingPriceQueryResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The prices returned from the price search\n"}],"serializedName":"prices","default":{"kind":"nothing"},"name":"prices","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelLeadingPrice"}},"parameters":[]}]}}]}},"name":"LeadingPriceQueryResp","version":{"kind":"nothing"}}};

export const snLeadingPriceQueryResp: ADL.ScopedName = {moduleName:"hotel.api", name:"LeadingPriceQueryResp"};

export function texprLeadingPriceQueryResp(): ADL.ATypeExpr<LeadingPriceQueryResp> {
  return {value : {typeRef : {kind: "reference", value : snLeadingPriceQueryResp}, parameters : []}};
}

export interface HotelLeadingPrice {
  /**
   * The ID of the hotel that this leading price belongs to
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * The leading price for the hotel, null if no leading price search has been
   * initiated for this hotel ID
   */
  leadingPrice: (LeadingPriceType|null);
}

export function makeHotelLeadingPrice(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    leadingPrice: (LeadingPriceType|null),
  }
): HotelLeadingPrice {
  return {
    hotelId: input.hotelId,
    leadingPrice: input.leadingPrice,
  };
}

const HotelLeadingPrice_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the hotel that this leading price belongs to\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The leading price for the hotel, null if no leading price search has been\ninitiated for this hotel ID\n"}],"serializedName":"leadingPrice","default":{"kind":"nothing"},"name":"leadingPrice","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LeadingPriceType"}},"parameters":[]}]}}]}},"name":"HotelLeadingPrice","version":{"kind":"nothing"}}};

export const snHotelLeadingPrice: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelLeadingPrice"};

export function texprHotelLeadingPrice(): ADL.ATypeExpr<HotelLeadingPrice> {
  return {value : {typeRef : {kind: "reference", value : snHotelLeadingPrice}, parameters : []}};
}

export interface LeadingPriceType_Pending {
  kind: 'pending';
}
export interface LeadingPriceType_Partial {
  kind: 'partial';
  value: LeadingPrice;
}
export interface LeadingPriceType_Complete {
  kind: 'complete';
  value: LeadingPrice;
}
export interface LeadingPriceType_Unavailable {
  kind: 'unavailable';
  value: (LeadingPrice|null);
}

/**
 * The data received from the hotel suppliers regarding the Leading price for a particular hotel
 */
export type LeadingPriceType = LeadingPriceType_Pending | LeadingPriceType_Partial | LeadingPriceType_Complete | LeadingPriceType_Unavailable;

export interface LeadingPriceTypeOpts {
  /**
   * Still waiting to hear back from *any* supplier regarding this hotel
   */
  pending: null;
  /**
   * We are still waiting to hear back from some of the suppliers for this
   * hotel's price. But this is the best price we have so far
   */
  partial: LeadingPrice;
  /**
   * This is the list price of the hotel based on the available information
   * from all suppliers
   */
  complete: LeadingPrice;
  /**
   * All suppliers have returned that the hotel is unavailable. If a leading
   * price is provided this indicates what the price would have been if there
   * were any left
   */
  unavailable: (LeadingPrice|null);
}

export function makeLeadingPriceType<K extends keyof LeadingPriceTypeOpts>(kind: K, value: LeadingPriceTypeOpts[K]) { return {kind, value}; }

const LeadingPriceType_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The data received from the hotel suppliers regarding the Leading price for a particular hotel\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Still waiting to hear back from *any* supplier regarding this hotel\n"}],"serializedName":"pending","default":{"kind":"nothing"},"name":"pending","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"We are still waiting to hear back from some of the suppliers for this\nhotel's price. But this is the best price we have so far\n"}],"serializedName":"partial","default":{"kind":"nothing"},"name":"partial","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LeadingPrice"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"This is the list price of the hotel based on the available information\nfrom all suppliers\n"}],"serializedName":"complete","default":{"kind":"nothing"},"name":"complete","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LeadingPrice"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"All suppliers have returned that the hotel is unavailable. If a leading\nprice is provided this indicates what the price would have been if there\nwere any left\n"}],"serializedName":"unavailable","default":{"kind":"nothing"},"name":"unavailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LeadingPrice"}},"parameters":[]}]}}]}},"name":"LeadingPriceType","version":{"kind":"nothing"}}};

export const snLeadingPriceType: ADL.ScopedName = {moduleName:"hotel.api", name:"LeadingPriceType"};

export function texprLeadingPriceType(): ADL.ATypeExpr<LeadingPriceType> {
  return {value : {typeRef : {kind: "reference", value : snLeadingPriceType}, parameters : []}};
}

export interface LeadingPrice {
  /**
   * The total price of the stay for this hotel, based on their list price
   */
  price: hotel_common.PriceValue;
  /**
   * A description of the room used to calculate this price
   */
  roomDescription: string;
  /**
   * The area of the room used to calculate this price
   */
  roomArea: number;
  /**
   * A description of the bed in the room used to calculate this price
   */
  bedDescription: string;
}

export function makeLeadingPrice(
  input: {
    price: hotel_common.PriceValue,
    roomDescription: string,
    roomArea: number,
    bedDescription: string,
  }
): LeadingPrice {
  return {
    price: input.price,
    roomDescription: input.roomDescription,
    roomArea: input.roomArea,
    bedDescription: input.bedDescription,
  };
}

const LeadingPrice_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The total price of the stay for this hotel, based on their list price\n"}],"serializedName":"price","default":{"kind":"nothing"},"name":"price","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A description of the room used to calculate this price\n"}],"serializedName":"roomDescription","default":{"kind":"nothing"},"name":"roomDescription","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The area of the room used to calculate this price\n"}],"serializedName":"roomArea","default":{"kind":"nothing"},"name":"roomArea","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A description of the bed in the room used to calculate this price\n"}],"serializedName":"bedDescription","default":{"kind":"nothing"},"name":"bedDescription","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"LeadingPrice","version":{"kind":"nothing"}}};

export const snLeadingPrice: ADL.ScopedName = {moduleName:"hotel.api", name:"LeadingPrice"};

export function texprLeadingPrice(): ADL.ATypeExpr<LeadingPrice> {
  return {value : {typeRef : {kind: "reference", value : snLeadingPrice}, parameters : []}};
}

export interface AgentHotelSearchResp_InvalidPriceToken {
  kind: 'invalidPriceToken';
}
export interface AgentHotelSearchResp_NoHotelsAvailable {
  kind: 'noHotelsAvailable';
}
export interface AgentHotelSearchResp_AvailableHotels {
  kind: 'availableHotels';
  value: AvailableHotels;
}

export type AgentHotelSearchResp = AgentHotelSearchResp_InvalidPriceToken | AgentHotelSearchResp_NoHotelsAvailable | AgentHotelSearchResp_AvailableHotels;

export interface AgentHotelSearchRespOpts {
  /**
   * Returned if the price token provided is invalid
   */
  invalidPriceToken: null;
  /**
   * No hotels are available in this location
   */
  noHotelsAvailable: null;
  /**
   * Defines hotels available to choose from
   */
  availableHotels: AvailableHotels;
}

export function makeAgentHotelSearchResp<K extends keyof AgentHotelSearchRespOpts>(kind: K, value: AgentHotelSearchRespOpts[K]) { return {kind, value}; }

const AgentHotelSearchResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Returned if the price token provided is invalid\n"}],"serializedName":"invalidPriceToken","default":{"kind":"nothing"},"name":"invalidPriceToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"No hotels are available in this location\n"}],"serializedName":"noHotelsAvailable","default":{"kind":"nothing"},"name":"noHotelsAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines hotels available to choose from\n"}],"serializedName":"availableHotels","default":{"kind":"nothing"},"name":"availableHotels","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AvailableHotels"}},"parameters":[]}}]}},"name":"AgentHotelSearchResp","version":{"kind":"nothing"}}};

export const snAgentHotelSearchResp: ADL.ScopedName = {moduleName:"hotel.api", name:"AgentHotelSearchResp"};

export function texprAgentHotelSearchResp(): ADL.ATypeExpr<AgentHotelSearchResp> {
  return {value : {typeRef : {kind: "reference", value : snAgentHotelSearchResp}, parameters : []}};
}

/**
 * Defines hotels available to choose from
 */
export interface AvailableHotels {
  /**
   * Hotels returned by the search. Note that this list could be empty if the
   * user has made their filters too restrictive
   */
  hotels: common.Paginated<HotelListingDetails>;
  /**
   * Token to use for searching hotel pricing or modifying the filters for the search.
   * When no price has been requested (for simple hotel query), them no price token is provided.
   */
  priceToken: (PriceToken|null);
}

export function makeAvailableHotels(
  input: {
    hotels: common.Paginated<HotelListingDetails>,
    priceToken: (PriceToken|null),
  }
): AvailableHotels {
  return {
    hotels: input.hotels,
    priceToken: input.priceToken,
  };
}

const AvailableHotels_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines hotels available to choose from\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotels returned by the search. Note that this list could be empty if the\nuser has made their filters too restrictive\n"}],"serializedName":"hotels","default":{"kind":"nothing"},"name":"hotels","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelListingDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Token to use for searching hotel pricing or modifying the filters for the search.\nWhen no price has been requested (for simple hotel query), them no price token is provided.\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}]}}]}},"name":"AvailableHotels","version":{"kind":"nothing"}}};

export const snAvailableHotels: ADL.ScopedName = {moduleName:"hotel.api", name:"AvailableHotels"};

export function texprAvailableHotels(): ADL.ATypeExpr<AvailableHotels> {
  return {value : {typeRef : {kind: "reference", value : snAvailableHotels}, parameters : []}};
}

/**
 * Details of a hotel used to render the search results page
 */
export interface HotelListingDetails {
  /**
   * The internal ID of the hotel
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * The name of the hotel
   */
  name: string;
  /**
   * A curated description of the hotel property, if present
   */
  description: (common_strings.StringNE|null);
  /**
   * Hotel point/coordinates
   */
  point: common.LatLng;
  /**
   * The address of the hotel
   */
  address: ids_common.Address;
  /**
   * Phone number of hotel, if present.
   */
  phoneNumber: (ids_common.PhoneNumber|null);
  /**
   * Fax number of the hotel, if present.
   */
  faxNum: (ids_common.PhoneNumber|null);
  /**
   * Email address of hotel, if present.
   */
  emailAddress: (common_strings.EmailAddress|null);
  /**
   * The star rating of the hotel
   */
  starRating: ids_common.StarRating;
  /**
   * The ID of the hotel category to which the hotel belongs
   */
  hotelCategory: (common_db.DbKey<ids_db.HotelCategory>|null);
  /**
   * Gallery images to use for the listing
   */
  images: ids_externalapi.GalleryImage[];
  /**
   * List of amenities this hotel has
   */
  amenities: common_db.DbKey<ids_db.Amenity>[];
  /**
   * Hotel chain this hotel belongs to, null if the hotel does not belong to a chain
   */
  hotelChain: (common_db.DbKey<ids_db.HotelChain>|null);
  /**
   * The distance to the search location provided in metres
   */
  distanceToLocation: number;
  /**
   * The nearest airports to the hotel
   */
  nearestAirports: ids_externalapi.PoiNearHotel[];
}

export function makeHotelListingDetails(
  input: {
    hotelId: common_db.DbKey<ids_db.Hotel>,
    name: string,
    description: (common_strings.StringNE|null),
    point: common.LatLng,
    address: ids_common.Address,
    phoneNumber: (ids_common.PhoneNumber|null),
    faxNum: (ids_common.PhoneNumber|null),
    emailAddress: (common_strings.EmailAddress|null),
    starRating: ids_common.StarRating,
    hotelCategory: (common_db.DbKey<ids_db.HotelCategory>|null),
    images: ids_externalapi.GalleryImage[],
    amenities: common_db.DbKey<ids_db.Amenity>[],
    hotelChain: (common_db.DbKey<ids_db.HotelChain>|null),
    distanceToLocation: number,
    nearestAirports: ids_externalapi.PoiNearHotel[],
  }
): HotelListingDetails {
  return {
    hotelId: input.hotelId,
    name: input.name,
    description: input.description,
    point: input.point,
    address: input.address,
    phoneNumber: input.phoneNumber,
    faxNum: input.faxNum,
    emailAddress: input.emailAddress,
    starRating: input.starRating,
    hotelCategory: input.hotelCategory,
    images: input.images,
    amenities: input.amenities,
    hotelChain: input.hotelChain,
    distanceToLocation: input.distanceToLocation,
    nearestAirports: input.nearestAirports,
  };
}

const HotelListingDetails_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of a hotel used to render the search results page\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The internal ID of the hotel\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The name of the hotel\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A curated description of the hotel property, if present\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel point/coordinates\n"}],"serializedName":"point","default":{"kind":"nothing"},"name":"point","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The address of the hotel\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Phone number of hotel, if present.\n"}],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Fax number of the hotel, if present.\n"}],"serializedName":"faxNum","default":{"kind":"nothing"},"name":"faxNum","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email address of hotel, if present.\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The star rating of the hotel\n"}],"serializedName":"starRating","default":{"kind":"nothing"},"name":"starRating","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StarRating"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the hotel category to which the hotel belongs\n"}],"serializedName":"hotelCategory","default":{"kind":"nothing"},"name":"hotelCategory","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gallery images to use for the listing\n"}],"serializedName":"images","default":{"kind":"nothing"},"name":"images","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"GalleryImage"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"List of amenities this hotel has\n"}],"serializedName":"amenities","default":{"kind":"nothing"},"name":"amenities","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel chain this hotel belongs to, null if the hotel does not belong to a chain\n"}],"serializedName":"hotelChain","default":{"kind":"nothing"},"name":"hotelChain","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelChain"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The distance to the search location provided in metres\n"}],"serializedName":"distanceToLocation","default":{"kind":"nothing"},"name":"distanceToLocation","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The nearest airports to the hotel\n"}],"serializedName":"nearestAirports","default":{"kind":"nothing"},"name":"nearestAirports","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"PoiNearHotel"}},"parameters":[]}]}}]}},"name":"HotelListingDetails","version":{"kind":"nothing"}}};

export const snHotelListingDetails: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelListingDetails"};

export function texprHotelListingDetails(): ADL.ATypeExpr<HotelListingDetails> {
  return {value : {typeRef : {kind: "reference", value : snHotelListingDetails}, parameters : []}};
}

/**
 * Defines search parameters for a hotel search
 */
export interface AgentHotelSearchQuery {
  /**
   * Defines where hotels should be searched for
   */
  searchParams: RoomSearchType;
  /**
   * Defines the order in which the search results should be displayed
   */
  order: HotelSearchSortOrder;
  /**
   * Number of items to return
   */
  count: number;
  /**
   * The offset of the next page of results
   */
  offset: number;
}

export function makeAgentHotelSearchQuery(
  input: {
    searchParams: RoomSearchType,
    order: HotelSearchSortOrder,
    count: number,
    offset: number,
  }
): AgentHotelSearchQuery {
  return {
    searchParams: input.searchParams,
    order: input.order,
    count: input.count,
    offset: input.offset,
  };
}

const AgentHotelSearchQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines search parameters for a hotel search\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines where hotels should be searched for\n"}],"serializedName":"searchParams","default":{"kind":"nothing"},"name":"searchParams","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"RoomSearchType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines the order in which the search results should be displayed\n"}],"serializedName":"order","default":{"kind":"nothing"},"name":"order","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelSearchSortOrder"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Number of items to return\n"}],"serializedName":"count","default":{"kind":"nothing"},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The offset of the next page of results\n"}],"serializedName":"offset","default":{"kind":"nothing"},"name":"offset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"AgentHotelSearchQuery","version":{"kind":"nothing"}}};

export const snAgentHotelSearchQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"AgentHotelSearchQuery"};

export function texprAgentHotelSearchQuery(): ADL.ATypeExpr<AgentHotelSearchQuery> {
  return {value : {typeRef : {kind: "reference", value : snAgentHotelSearchQuery}, parameters : []}};
}

export interface RoomSearchType_HotelQuery {
  kind: 'hotelQuery';
  value: HotelQueryParameters;
}
export interface RoomSearchType_NewSearch {
  kind: 'newSearch';
  value: HotelSearchParameters;
}
export interface RoomSearchType_ExistingSearch {
  kind: 'existingSearch';
  value: ExistingSearchParameters;
}

/**
 * Defines the type of hotel room search that is being made
 */
export type RoomSearchType = RoomSearchType_HotelQuery | RoomSearchType_NewSearch | RoomSearchType_ExistingSearch;

export interface RoomSearchTypeOpts {
  /**
   * A hotel query in IDS is being performed, which returns available hotels.
   * This query is not meant for finding the best deal as no leading price search is initiated.
   * Instead, it's used primarily to compare map results and other potential internal services.
   */
  hotelQuery: HotelQueryParameters;
  /**
   * A search is being performed, which should initiate a new search for leading prices from suppliers
   */
  newSearch: HotelSearchParameters;
  /**
   * An existing search is being repeated, no additional price queries should be made
   */
  existingSearch: ExistingSearchParameters;
}

export function makeRoomSearchType<K extends keyof RoomSearchTypeOpts>(kind: K, value: RoomSearchTypeOpts[K]) { return {kind, value}; }

const RoomSearchType_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines the type of hotel room search that is being made\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A hotel query in IDS is being performed, which returns available hotels.\nThis query is not meant for finding the best deal as no leading price search is initiated.\nInstead, it's used primarily to compare map results and other potential internal services.\n"}],"serializedName":"hotelQuery","default":{"kind":"nothing"},"name":"hotelQuery","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelQueryParameters"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A search is being performed, which should initiate a new search for leading prices from suppliers\n"}],"serializedName":"newSearch","default":{"kind":"nothing"},"name":"newSearch","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelSearchParameters"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An existing search is being repeated, no additional price queries should be made\n"}],"serializedName":"existingSearch","default":{"kind":"nothing"},"name":"existingSearch","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ExistingSearchParameters"}},"parameters":[]}}]}},"name":"RoomSearchType","version":{"kind":"nothing"}}};

export const snRoomSearchType: ADL.ScopedName = {moduleName:"hotel.api", name:"RoomSearchType"};

export function texprRoomSearchType(): ADL.ATypeExpr<RoomSearchType> {
  return {value : {typeRef : {kind: "reference", value : snRoomSearchType}, parameters : []}};
}

/**
 * Identifier and filters to apply to an existing hotel search
 */
export interface ExistingSearchParameters {
  /**
   * The token representing the search that should be filtered
   */
  priceToken: PriceToken;
  /**
   * The filters to apply to the search
   */
  filters: HotelSearchFilters;
}

export function makeExistingSearchParameters(
  input: {
    priceToken: PriceToken,
    filters: HotelSearchFilters,
  }
): ExistingSearchParameters {
  return {
    priceToken: input.priceToken,
    filters: input.filters,
  };
}

const ExistingSearchParameters_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Identifier and filters to apply to an existing hotel search\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The token representing the search that should be filtered\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The filters to apply to the search\n"}],"serializedName":"filters","default":{"kind":"nothing"},"name":"filters","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelSearchFilters"}},"parameters":[]}}]}},"name":"ExistingSearchParameters","version":{"kind":"nothing"}}};

export const snExistingSearchParameters: ADL.ScopedName = {moduleName:"hotel.api", name:"ExistingSearchParameters"};

export function texprExistingSearchParameters(): ADL.ATypeExpr<ExistingSearchParameters> {
  return {value : {typeRef : {kind: "reference", value : snExistingSearchParameters}, parameters : []}};
}

/**
 * Details of a room type search to be performed
 */
export interface HotelSearchParameters {
  /**
   * The location where the hotel search is being made
   */
  location: ids_externalapi.LocationType;
  /**
   * Details of the room that's required for this search
   */
  stayDetails: StayDetails;
}

export function makeHotelSearchParameters(
  input: {
    location: ids_externalapi.LocationType,
    stayDetails: StayDetails,
  }
): HotelSearchParameters {
  return {
    location: input.location,
    stayDetails: input.stayDetails,
  };
}

const HotelSearchParameters_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of a room type search to be performed\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The location where the hotel search is being made\n"}],"serializedName":"location","default":{"kind":"nothing"},"name":"location","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of the room that's required for this search\n"}],"serializedName":"stayDetails","default":{"kind":"nothing"},"name":"stayDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"StayDetails"}},"parameters":[]}}]}},"name":"HotelSearchParameters","version":{"kind":"nothing"}}};

export const snHotelSearchParameters: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelSearchParameters"};

export function texprHotelSearchParameters(): ADL.ATypeExpr<HotelSearchParameters> {
  return {value : {typeRef : {kind: "reference", value : snHotelSearchParameters}, parameters : []}};
}

export interface StayDetails {
  /**
   * Date when the guest will check in
   */
  checkIn: common.LocalDate;
  /**
   * Date when the guest will check out
   */
  checkOut: common.LocalDate;
  /**
   * Defines the types of rooms that are required
   */
  rooms: HotelRoom[];
}

export function makeStayDetails(
  input: {
    checkIn: common.LocalDate,
    checkOut: common.LocalDate,
    rooms: HotelRoom[],
  }
): StayDetails {
  return {
    checkIn: input.checkIn,
    checkOut: input.checkOut,
    rooms: input.rooms,
  };
}

const StayDetails_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date when the guest will check in\n"}],"serializedName":"checkIn","default":{"kind":"nothing"},"name":"checkIn","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date when the guest will check out\n"}],"serializedName":"checkOut","default":{"kind":"nothing"},"name":"checkOut","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Defines the types of rooms that are required\n"}],"serializedName":"rooms","default":{"kind":"nothing"},"name":"rooms","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelRoom"}},"parameters":[]}]}}]}},"name":"StayDetails","version":{"kind":"nothing"}}};

export const snStayDetails: ADL.ScopedName = {moduleName:"hotel.api", name:"StayDetails"};

export function texprStayDetails(): ADL.ATypeExpr<StayDetails> {
  return {value : {typeRef : {kind: "reference", value : snStayDetails}, parameters : []}};
}

/**
 * Hotel location details for the query to be performed
 */
export interface HotelQueryParameters {
  /**
   * The location where the hotel search is being made
   */
  location: ids_externalapi.LocationType;
  /**
   * The filters to apply to the search
   */
  filters: (HotelSearchFilters|null);
}

export function makeHotelQueryParameters(
  input: {
    location: ids_externalapi.LocationType,
    filters: (HotelSearchFilters|null),
  }
): HotelQueryParameters {
  return {
    location: input.location,
    filters: input.filters,
  };
}

const HotelQueryParameters_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel location details for the query to be performed\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The location where the hotel search is being made\n"}],"serializedName":"location","default":{"kind":"nothing"},"name":"location","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.externalapi","name":"LocationType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The filters to apply to the search\n"}],"serializedName":"filters","default":{"kind":"nothing"},"name":"filters","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"HotelSearchFilters"}},"parameters":[]}]}}]}},"name":"HotelQueryParameters","version":{"kind":"nothing"}}};

export const snHotelQueryParameters: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelQueryParameters"};

export function texprHotelQueryParameters(): ADL.ATypeExpr<HotelQueryParameters> {
  return {value : {typeRef : {kind: "reference", value : snHotelQueryParameters}, parameters : []}};
}

export interface HotelRoom {
  /**
   * The number of adults in the room
   */
  numAdults: number;
  /**
   * Details of the children in the room
   */
  children: Child[];
}

export function makeHotelRoom(
  input: {
    numAdults: number,
    children: Child[],
  }
): HotelRoom {
  return {
    numAdults: input.numAdults,
    children: input.children,
  };
}

const HotelRoom_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The number of adults in the room\n"}],"serializedName":"numAdults","default":{"kind":"nothing"},"name":"numAdults","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of the children in the room\n"}],"serializedName":"children","default":{"kind":"nothing"},"name":"children","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"Child"}},"parameters":[]}]}}]}},"name":"HotelRoom","version":{"kind":"nothing"}}};

export const snHotelRoom: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelRoom"};

export function texprHotelRoom(): ADL.ATypeExpr<HotelRoom> {
  return {value : {typeRef : {kind: "reference", value : snHotelRoom}, parameters : []}};
}

/**
 * Booking parameters for a child in a room
 */
export interface Child {
  /**
   * The age of the child during the booking
   */
  age: number;
}

export function makeChild(
  input: {
    age: number,
  }
): Child {
  return {
    age: input.age,
  };
}

const Child_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking parameters for a child in a room\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The age of the child during the booking\n"}],"serializedName":"age","default":{"kind":"nothing"},"name":"age","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"Child","version":{"kind":"nothing"}}};

export const snChild: ADL.ScopedName = {moduleName:"hotel.api", name:"Child"};

export function texprChild(): ADL.ATypeExpr<Child> {
  return {value : {typeRef : {kind: "reference", value : snChild}, parameters : []}};
}

export interface HotelSearchFilters {
  /**
   * A wildcard search for a hotel name
   */
  hotelName: (common_strings.StringNE|null);
  /**
   * Filters by amenities available at the hotel (empty list signifies any amenities)
   */
  amenities: common_db.DbKey<ids_db.Amenity>[];
  /**
   * Filters by star ratings of the hotel (empty list signifies any stars)
   */
  starRatings: ids_common.StarRating[];
  /**
   * Filters by hotels in the given list of categories (empty list signifies no filtering)
   */
  hotelCategories: common_db.DbKey<ids_db.HotelCategory>[];
  /**
   * Filters hotels based on the provided sub-regions (empty list signifies no filtering)
   * Note that the regions provided here must be a sub region of regionId,
   * otherwise they will have no filtering effect
   */
  regions: common_db.DbKey<ids_db.Region>[];
  /**
   * Filters by hotels that are members of the given chains (empty list signifies no filtering)
   */
  hotelChains: common_db.DbKey<ids_db.HotelChain>[];
}

export function makeHotelSearchFilters(
  input: {
    hotelName: (common_strings.StringNE|null),
    amenities: common_db.DbKey<ids_db.Amenity>[],
    starRatings: ids_common.StarRating[],
    hotelCategories: common_db.DbKey<ids_db.HotelCategory>[],
    regions: common_db.DbKey<ids_db.Region>[],
    hotelChains: common_db.DbKey<ids_db.HotelChain>[],
  }
): HotelSearchFilters {
  return {
    hotelName: input.hotelName,
    amenities: input.amenities,
    starRatings: input.starRatings,
    hotelCategories: input.hotelCategories,
    regions: input.regions,
    hotelChains: input.hotelChains,
  };
}

const HotelSearchFilters_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A wildcard search for a hotel name\n"}],"serializedName":"hotelName","default":{"kind":"nothing"},"name":"hotelName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by amenities available at the hotel (empty list signifies any amenities)\n"}],"serializedName":"amenities","default":{"kind":"nothing"},"name":"amenities","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by star ratings of the hotel (empty list signifies any stars)\n"}],"serializedName":"starRatings","default":{"kind":"nothing"},"name":"starRatings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StarRating"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by hotels in the given list of categories (empty list signifies no filtering)\n"}],"serializedName":"hotelCategories","default":{"kind":"nothing"},"name":"hotelCategories","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters hotels based on the provided sub-regions (empty list signifies no filtering)\nNote that the regions provided here must be a sub region of regionId,\notherwise they will have no filtering effect\n"}],"serializedName":"regions","default":{"kind":"nothing"},"name":"regions","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Filters by hotels that are members of the given chains (empty list signifies no filtering)\n"}],"serializedName":"hotelChains","default":{"kind":"nothing"},"name":"hotelChains","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelChain"}},"parameters":[]}]}]}}]}},"name":"HotelSearchFilters","version":{"kind":"nothing"}}};

export const snHotelSearchFilters: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelSearchFilters"};

export function texprHotelSearchFilters(): ADL.ATypeExpr<HotelSearchFilters> {
  return {value : {typeRef : {kind: "reference", value : snHotelSearchFilters}, parameters : []}};
}

export enum HotelSearchSortOrder {
  popularity,
  distance,
}

const HotelSearchSortOrder_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"popularity","default":{"kind":"nothing"},"name":"popularity","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"distance","default":{"kind":"nothing"},"name":"distance","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"HotelSearchSortOrder","version":{"kind":"nothing"}}};

export const snHotelSearchSortOrder: ADL.ScopedName = {moduleName:"hotel.api", name:"HotelSearchSortOrder"};

export function texprHotelSearchSortOrder(): ADL.ATypeExpr<HotelSearchSortOrder> {
  return {value : {typeRef : {kind: "reference", value : snHotelSearchSortOrder}, parameters : []}};
}

export interface CreateItineraryReq {
  /**
   * Description of itinerary.
   */
  description: (common_strings.StringNE|null);
  /**
   * Id of agency user associated with itinerary.
   */
  agencyUserId: common_db.DbKey<hotel_db.AppUser>;
}

export function makeCreateItineraryReq(
  input: {
    description: (common_strings.StringNE|null),
    agencyUserId: common_db.DbKey<hotel_db.AppUser>,
  }
): CreateItineraryReq {
  return {
    description: input.description,
    agencyUserId: input.agencyUserId,
  };
}

const CreateItineraryReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Description of itinerary.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of agency user associated with itinerary.\n"}],"serializedName":"agencyUserId","default":{"kind":"nothing"},"name":"agencyUserId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}}]}},"name":"CreateItineraryReq","version":{"kind":"nothing"}}};

export const snCreateItineraryReq: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateItineraryReq"};

export function texprCreateItineraryReq(): ADL.ATypeExpr<CreateItineraryReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateItineraryReq}, parameters : []}};
}

export interface CreateItineraryResp_Success {
  kind: 'success';
  value: common_db.WithDbId<hotel_db.Itinerary>;
}
export interface CreateItineraryResp_Error {
  kind: 'error';
  value: string;
}

export type CreateItineraryResp = CreateItineraryResp_Success | CreateItineraryResp_Error;

export interface CreateItineraryRespOpts {
  success: common_db.WithDbId<hotel_db.Itinerary>;
  error: string;
}

export function makeCreateItineraryResp<K extends keyof CreateItineraryRespOpts>(kind: K, value: CreateItineraryRespOpts[K]) { return {kind, value}; }

const CreateItineraryResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CreateItineraryResp","version":{"kind":"nothing"}}};

export const snCreateItineraryResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateItineraryResp"};

export function texprCreateItineraryResp(): ADL.ATypeExpr<CreateItineraryResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateItineraryResp}, parameters : []}};
}

export interface CreateBookingReq {
  /**
   * Id of itinerary this booking is associated with.
   */
  itineraryId: common_db.DbKey<hotel_db.Itinerary>;
  /**
   * Details about hotel.
   */
  hotelDetails: hotel_booking.HotelDetails;
  /**
   * Details that are required to obtain a price for this hotel
   */
  paymentDetailsReq: PaymentDetailsReq;
  /**
   * Taxes and fees associated with this booking.
   */
  taxesAndFees: TaxesAndFees[];
  /**
   * Supplier room id
   */
  supplierHotelRoomId: (string|null);
  /**
   * Id of hotel room if available.
   */
  hotelRoomId: (hotel_common.HotelRoomId|null);
  /**
   * Name of hotel room.
   */
  roomName: common_strings.StringNE;
  /**
   * Board description e.g. Room Only, Breakfast Included etc.
   */
  board: hotel_booking.Board;
  /**
   * Details of the people staying in the booked rooms.
   */
  rooms: hotel_booking.RoomOccupancyDetails[];
  /**
   * Special requests.
   */
  specialRequests: hotel_booking.StandardSpecialRequest[];
  /**
   * Date of check in.
   */
  checkInDate: common.LocalDate;
  /**
   * Date of check out.
   */
  checkOutDate: common.LocalDate;
  /**
   * Payment due date.
   */
  paymentDueDate: common.LocalDate;
  /**
   * Cancellation policy of booking.
   */
  cancellationPolicy: hotel_common.PackageCancellationPolicy;
  /**
   * Optional agent reference.
   */
  agentReference: (string|null);
}

export function makeCreateBookingReq(
  input: {
    itineraryId: common_db.DbKey<hotel_db.Itinerary>,
    hotelDetails: hotel_booking.HotelDetails,
    paymentDetailsReq: PaymentDetailsReq,
    taxesAndFees: TaxesAndFees[],
    supplierHotelRoomId: (string|null),
    hotelRoomId: (hotel_common.HotelRoomId|null),
    roomName: common_strings.StringNE,
    board: hotel_booking.Board,
    rooms: hotel_booking.RoomOccupancyDetails[],
    specialRequests: hotel_booking.StandardSpecialRequest[],
    checkInDate: common.LocalDate,
    checkOutDate: common.LocalDate,
    paymentDueDate: common.LocalDate,
    cancellationPolicy: hotel_common.PackageCancellationPolicy,
    agentReference: (string|null),
  }
): CreateBookingReq {
  return {
    itineraryId: input.itineraryId,
    hotelDetails: input.hotelDetails,
    paymentDetailsReq: input.paymentDetailsReq,
    taxesAndFees: input.taxesAndFees,
    supplierHotelRoomId: input.supplierHotelRoomId,
    hotelRoomId: input.hotelRoomId,
    roomName: input.roomName,
    board: input.board,
    rooms: input.rooms,
    specialRequests: input.specialRequests,
    checkInDate: input.checkInDate,
    checkOutDate: input.checkOutDate,
    paymentDueDate: input.paymentDueDate,
    cancellationPolicy: input.cancellationPolicy,
    agentReference: input.agentReference,
  };
}

const CreateBookingReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of itinerary this booking is associated with.\n"}],"serializedName":"itineraryId","default":{"kind":"nothing"},"name":"itineraryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details about hotel.\n"}],"serializedName":"hotelDetails","default":{"kind":"nothing"},"name":"hotelDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"HotelDetails"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details that are required to obtain a price for this hotel\n"}],"serializedName":"paymentDetailsReq","default":{"kind":"nothing"},"name":"paymentDetailsReq","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PaymentDetailsReq"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Taxes and fees associated with this booking.\n"}],"serializedName":"taxesAndFees","default":{"kind":"nothing"},"name":"taxesAndFees","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"TaxesAndFees"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier room id\n"}],"serializedName":"supplierHotelRoomId","default":{"kind":"nothing"},"name":"supplierHotelRoomId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of hotel room if available.\n"}],"serializedName":"hotelRoomId","default":{"kind":"nothing"},"name":"hotelRoomId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"HotelRoomId"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of hotel room.\n"}],"serializedName":"roomName","default":{"kind":"nothing"},"name":"roomName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Board description e.g. Room Only, Breakfast Included etc.\n"}],"serializedName":"board","default":{"kind":"nothing"},"name":"board","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"Board"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of the people staying in the booked rooms.\n"}],"serializedName":"rooms","default":{"kind":"nothing"},"name":"rooms","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"RoomOccupancyDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Special requests.\n"}],"serializedName":"specialRequests","default":{"kind":"nothing"},"name":"specialRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"StandardSpecialRequest"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date of check in.\n"}],"serializedName":"checkInDate","default":{"kind":"nothing"},"name":"checkInDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date of check out.\n"}],"serializedName":"checkOutDate","default":{"kind":"nothing"},"name":"checkOutDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment due date.\n"}],"serializedName":"paymentDueDate","default":{"kind":"nothing"},"name":"paymentDueDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancellation policy of booking.\n"}],"serializedName":"cancellationPolicy","default":{"kind":"nothing"},"name":"cancellationPolicy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PackageCancellationPolicy"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Optional agent reference.\n"}],"serializedName":"agentReference","default":{"kind":"nothing"},"name":"agentReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CreateBookingReq","version":{"kind":"nothing"}}};

export const snCreateBookingReq: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateBookingReq"};

export function texprCreateBookingReq(): ADL.ATypeExpr<CreateBookingReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateBookingReq}, parameters : []}};
}

export interface CreateBookingResp_Success {
  kind: 'success';
  value: common_db.DbKey<hotel_db.Booking>;
}
export interface CreateBookingResp_PackageNotAvailable {
  kind: 'packageNotAvailable';
}
export interface CreateBookingResp_Error {
  kind: 'error';
  value: string;
}

export type CreateBookingResp = CreateBookingResp_Success | CreateBookingResp_PackageNotAvailable | CreateBookingResp_Error;

export interface CreateBookingRespOpts {
  /**
   * The booking was created successfully
   */
  success: common_db.DbKey<hotel_db.Booking>;
  /**
   * The package has become not available, no booking was created
   */
  packageNotAvailable: null;
  /**
   * An error has occurred, which is described in the provided error message
   */
  error: string;
}

export function makeCreateBookingResp<K extends keyof CreateBookingRespOpts>(kind: K, value: CreateBookingRespOpts[K]) { return {kind, value}; }

const CreateBookingResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking was created successfully\n"}],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package has become not available, no booking was created\n"}],"serializedName":"packageNotAvailable","default":{"kind":"nothing"},"name":"packageNotAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An error has occurred, which is described in the provided error message\n"}],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CreateBookingResp","version":{"kind":"nothing"}}};

export const snCreateBookingResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateBookingResp"};

export function texprCreateBookingResp(): ADL.ATypeExpr<CreateBookingResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateBookingResp}, parameters : []}};
}

export interface RefreshBookingResp_PackageDetails {
  kind: 'packageDetails';
  value: SupplierPackageDetails;
}
export interface RefreshBookingResp_InvalidBookingId {
  kind: 'invalidBookingId';
}
export interface RefreshBookingResp_PackageNotAvailable {
  kind: 'packageNotAvailable';
}
export interface RefreshBookingResp_SupplierError {
  kind: 'supplierError';
}
export interface RefreshBookingResp_PriceChanged {
  kind: 'priceChanged';
}
export interface RefreshBookingResp_Error {
  kind: 'error';
  value: string;
}

export type RefreshBookingResp = RefreshBookingResp_PackageDetails | RefreshBookingResp_InvalidBookingId | RefreshBookingResp_PackageNotAvailable | RefreshBookingResp_SupplierError | RefreshBookingResp_PriceChanged | RefreshBookingResp_Error;

export interface RefreshBookingRespOpts {
  /**
   * Successful refresh with the refreshed package details used to
   * make a payment and/or confirm a booking
   */
  packageDetails: SupplierPackageDetails;
  /**
   * The booking ID provided is invalid
   */
  invalidBookingId: null;
  /**
   * The package is no longer available
   */
  packageNotAvailable: null;
  /**
   * The supplier returned an error and the price details could not be fetched
   */
  supplierError: null;
  /**
   * The price has changed since the quote was created, so the agent must
   * be notified of the new price
   */
  priceChanged: null;
  /**
   * An error has occurred, which is described in the provided error message
   */
  error: string;
}

export function makeRefreshBookingResp<K extends keyof RefreshBookingRespOpts>(kind: K, value: RefreshBookingRespOpts[K]) { return {kind, value}; }

const RefreshBookingResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Successful refresh with the refreshed package details used to\nmake a payment and/or confirm a booking\n"}],"serializedName":"packageDetails","default":{"kind":"nothing"},"name":"packageDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"SupplierPackageDetails"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The booking ID provided is invalid\n"}],"serializedName":"invalidBookingId","default":{"kind":"nothing"},"name":"invalidBookingId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The package is no longer available\n"}],"serializedName":"packageNotAvailable","default":{"kind":"nothing"},"name":"packageNotAvailable","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The supplier returned an error and the price details could not be fetched\n"}],"serializedName":"supplierError","default":{"kind":"nothing"},"name":"supplierError","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price has changed since the quote was created, so the agent must\nbe notified of the new price\n"}],"serializedName":"priceChanged","default":{"kind":"nothing"},"name":"priceChanged","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An error has occurred, which is described in the provided error message\n"}],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"RefreshBookingResp","version":{"kind":"nothing"}}};

export const snRefreshBookingResp: ADL.ScopedName = {moduleName:"hotel.api", name:"RefreshBookingResp"};

export function texprRefreshBookingResp(): ADL.ATypeExpr<RefreshBookingResp> {
  return {value : {typeRef : {kind: "reference", value : snRefreshBookingResp}, parameters : []}};
}

export interface UpdateAgencyResp_Success {
  kind: 'success';
}
export interface UpdateAgencyResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

export type UpdateAgencyResp = UpdateAgencyResp_Success | UpdateAgencyResp_Error;

export interface UpdateAgencyRespOpts {
  success: null;
  error: common_strings.StringNE;
}

export function makeUpdateAgencyResp<K extends keyof UpdateAgencyRespOpts>(kind: K, value: UpdateAgencyRespOpts[K]) { return {kind, value}; }

const UpdateAgencyResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"UpdateAgencyResp","version":{"kind":"nothing"}}};

export const snUpdateAgencyResp: ADL.ScopedName = {moduleName:"hotel.api", name:"UpdateAgencyResp"};

export function texprUpdateAgencyResp(): ADL.ATypeExpr<UpdateAgencyResp> {
  return {value : {typeRef : {kind: "reference", value : snUpdateAgencyResp}, parameters : []}};
}

export interface CreateAgencyResp_Success {
  kind: 'success';
  value: common_db.DbKey<hotel_db.Agency>;
}
export interface CreateAgencyResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

export type CreateAgencyResp = CreateAgencyResp_Success | CreateAgencyResp_Error;

export interface CreateAgencyRespOpts {
  success: common_db.DbKey<hotel_db.Agency>;
  error: common_strings.StringNE;
}

export function makeCreateAgencyResp<K extends keyof CreateAgencyRespOpts>(kind: K, value: CreateAgencyRespOpts[K]) { return {kind, value}; }

const CreateAgencyResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"CreateAgencyResp","version":{"kind":"nothing"}}};

export const snCreateAgencyResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateAgencyResp"};

export function texprCreateAgencyResp(): ADL.ATypeExpr<CreateAgencyResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateAgencyResp}, parameters : []}};
}

export interface CreateAgentUserReq {
  fullname: common_strings.StringNE;
  emailAddress: common_strings.EmailAddress;
  phoneNumber: (ids_common.PhoneNumber|null);
  isAgencyAdmin: boolean;
  agencyId: (string|null);
}

export function makeCreateAgentUserReq(
  input: {
    fullname: common_strings.StringNE,
    emailAddress: common_strings.EmailAddress,
    phoneNumber: (ids_common.PhoneNumber|null),
    isAgencyAdmin: boolean,
    agencyId: (string|null),
  }
): CreateAgentUserReq {
  return {
    fullname: input.fullname,
    emailAddress: input.emailAddress,
    phoneNumber: input.phoneNumber,
    isAgencyAdmin: input.isAgencyAdmin,
    agencyId: input.agencyId,
  };
}

const CreateAgentUserReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}},{"annotations":[],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[],"serializedName":"isAgencyAdmin","default":{"kind":"nothing"},"name":"isAgencyAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"agencyId","default":{"kind":"nothing"},"name":"agencyId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CreateAgentUserReq","version":{"kind":"nothing"}}};

export const snCreateAgentUserReq: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateAgentUserReq"};

export function texprCreateAgentUserReq(): ADL.ATypeExpr<CreateAgentUserReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateAgentUserReq}, parameters : []}};
}

export interface CreateAgentUserResp_Success {
  kind: 'success';
  value: common_db.DbKey<hotel_db.AppUser>;
}
export interface CreateAgentUserResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

export type CreateAgentUserResp = CreateAgentUserResp_Success | CreateAgentUserResp_Error;

export interface CreateAgentUserRespOpts {
  success: common_db.DbKey<hotel_db.AppUser>;
  error: common_strings.StringNE;
}

export function makeCreateAgentUserResp<K extends keyof CreateAgentUserRespOpts>(kind: K, value: CreateAgentUserRespOpts[K]) { return {kind, value}; }

const CreateAgentUserResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"CreateAgentUserResp","version":{"kind":"nothing"}}};

export const snCreateAgentUserResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateAgentUserResp"};

export function texprCreateAgentUserResp(): ADL.ATypeExpr<CreateAgentUserResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateAgentUserResp}, parameters : []}};
}

export interface ConfirmInviteAgentUserReq {
  inviteHash: string;
  password: string;
}

export function makeConfirmInviteAgentUserReq(
  input: {
    inviteHash: string,
    password: string,
  }
): ConfirmInviteAgentUserReq {
  return {
    inviteHash: input.inviteHash,
    password: input.password,
  };
}

const ConfirmInviteAgentUserReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"inviteHash","default":{"kind":"nothing"},"name":"inviteHash","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ConfirmInviteAgentUserReq","version":{"kind":"nothing"}}};

export const snConfirmInviteAgentUserReq: ADL.ScopedName = {moduleName:"hotel.api", name:"ConfirmInviteAgentUserReq"};

export function texprConfirmInviteAgentUserReq(): ADL.ATypeExpr<ConfirmInviteAgentUserReq> {
  return {value : {typeRef : {kind: "reference", value : snConfirmInviteAgentUserReq}, parameters : []}};
}

export interface ConfirmInviteAgentUserResp_Success {
  kind: 'success';
  value: common_db.DbKey<hotel_db.AppUser>;
}
export interface ConfirmInviteAgentUserResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

export type ConfirmInviteAgentUserResp = ConfirmInviteAgentUserResp_Success | ConfirmInviteAgentUserResp_Error;

export interface ConfirmInviteAgentUserRespOpts {
  success: common_db.DbKey<hotel_db.AppUser>;
  error: common_strings.StringNE;
}

export function makeConfirmInviteAgentUserResp<K extends keyof ConfirmInviteAgentUserRespOpts>(kind: K, value: ConfirmInviteAgentUserRespOpts[K]) { return {kind, value}; }

const ConfirmInviteAgentUserResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUser"}},"parameters":[]}]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"ConfirmInviteAgentUserResp","version":{"kind":"nothing"}}};

export const snConfirmInviteAgentUserResp: ADL.ScopedName = {moduleName:"hotel.api", name:"ConfirmInviteAgentUserResp"};

export function texprConfirmInviteAgentUserResp(): ADL.ATypeExpr<ConfirmInviteAgentUserResp> {
  return {value : {typeRef : {kind: "reference", value : snConfirmInviteAgentUserResp}, parameters : []}};
}

export interface ValidateInviteAgentUserReq {
  inviteHash: string;
}

export function makeValidateInviteAgentUserReq(
  input: {
    inviteHash: string,
  }
): ValidateInviteAgentUserReq {
  return {
    inviteHash: input.inviteHash,
  };
}

const ValidateInviteAgentUserReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"inviteHash","default":{"kind":"nothing"},"name":"inviteHash","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"ValidateInviteAgentUserReq","version":{"kind":"nothing"}}};

export const snValidateInviteAgentUserReq: ADL.ScopedName = {moduleName:"hotel.api", name:"ValidateInviteAgentUserReq"};

export function texprValidateInviteAgentUserReq(): ADL.ATypeExpr<ValidateInviteAgentUserReq> {
  return {value : {typeRef : {kind: "reference", value : snValidateInviteAgentUserReq}, parameters : []}};
}

export interface ValidateInviteAgentUserResp_Success {
  kind: 'success';
}
export interface ValidateInviteAgentUserResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

export type ValidateInviteAgentUserResp = ValidateInviteAgentUserResp_Success | ValidateInviteAgentUserResp_Error;

export interface ValidateInviteAgentUserRespOpts {
  success: null;
  error: common_strings.StringNE;
}

export function makeValidateInviteAgentUserResp<K extends keyof ValidateInviteAgentUserRespOpts>(kind: K, value: ValidateInviteAgentUserRespOpts[K]) { return {kind, value}; }

const ValidateInviteAgentUserResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"ValidateInviteAgentUserResp","version":{"kind":"nothing"}}};

export const snValidateInviteAgentUserResp: ADL.ScopedName = {moduleName:"hotel.api", name:"ValidateInviteAgentUserResp"};

export function texprValidateInviteAgentUserResp(): ADL.ATypeExpr<ValidateInviteAgentUserResp> {
  return {value : {typeRef : {kind: "reference", value : snValidateInviteAgentUserResp}, parameters : []}};
}

export interface UserInviteReq {
  email: string;
}

export function makeUserInviteReq(
  input: {
    email: string,
  }
): UserInviteReq {
  return {
    email: input.email,
  };
}

const UserInviteReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UserInviteReq","version":{"kind":"nothing"}}};

export const snUserInviteReq: ADL.ScopedName = {moduleName:"hotel.api", name:"UserInviteReq"};

export function texprUserInviteReq(): ADL.ATypeExpr<UserInviteReq> {
  return {value : {typeRef : {kind: "reference", value : snUserInviteReq}, parameters : []}};
}

export enum UserInviteResp {
  success,
}

const UserInviteResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"UserInviteResp","version":{"kind":"nothing"}}};

export const snUserInviteResp: ADL.ScopedName = {moduleName:"hotel.api", name:"UserInviteResp"};

export function texprUserInviteResp(): ADL.ATypeExpr<UserInviteResp> {
  return {value : {typeRef : {kind: "reference", value : snUserInviteResp}, parameters : []}};
}

export interface UserProfile {
  appUser: common_db.WithDbId<AppUserDetails>;
  fullname: string;
  email: string;
}

export function makeUserProfile(
  input: {
    appUser: common_db.WithDbId<AppUserDetails>,
    fullname: string,
    email: string,
  }
): UserProfile {
  return {
    appUser: input.appUser,
    fullname: input.fullname,
    email: input.email,
  };
}

const UserProfile_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"appUser","default":{"kind":"nothing"},"name":"appUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AppUserDetails"}},"parameters":[]}]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UserProfile","version":{"kind":"nothing"}}};

export const snUserProfile: ADL.ScopedName = {moduleName:"hotel.api", name:"UserProfile"};

export function texprUserProfile(): ADL.ATypeExpr<UserProfile> {
  return {value : {typeRef : {kind: "reference", value : snUserProfile}, parameters : []}};
}

/**
 * Details for a user
 */
export interface AppUserDetails {
  userType: hotel_db.AppUserType;
  fullname: common_strings.StringNE;
  email: common_strings.StringNE;
  /**
   * Status of the user.
   */
  userStatus: hotel_db.UserStatus;
  /**
   * Id of agency associated with this user, if present.
   */
  agencyId: (common_db.DbKey<hotel_db.Agency>|null);
  /**
   * Phone number of user if present.
   */
  phoneNumber: (ids_common.PhoneNumber|null);
  /**
   * Overriding commission percentage if present (for agents).
   */
  commissionPercentage: (common.BigDecimal|null);
}

export function makeAppUserDetails(
  input: {
    userType: hotel_db.AppUserType,
    fullname: common_strings.StringNE,
    email: common_strings.StringNE,
    userStatus: hotel_db.UserStatus,
    agencyId?: (common_db.DbKey<hotel_db.Agency>|null),
    phoneNumber?: (ids_common.PhoneNumber|null),
    commissionPercentage?: (common.BigDecimal|null),
  }
): AppUserDetails {
  return {
    userType: input.userType,
    fullname: input.fullname,
    email: input.email,
    userStatus: input.userStatus,
    agencyId: input.agencyId === undefined ? null : input.agencyId,
    phoneNumber: input.phoneNumber === undefined ? null : input.phoneNumber,
    commissionPercentage: input.commissionPercentage === undefined ? null : input.commissionPercentage,
  };
}

const AppUserDetails_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userType","default":{"kind":"nothing"},"name":"userType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUserType"}},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Status of the user.\n"}],"serializedName":"userStatus","default":{"kind":"nothing"},"name":"userStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"UserStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of agency associated with this user, if present.\n"}],"serializedName":"agencyId","default":{"kind":"just","value":null},"name":"agencyId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Phone number of user if present.\n"}],"serializedName":"phoneNumber","default":{"kind":"just","value":null},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Overriding commission percentage if present (for agents).\n"}],"serializedName":"commissionPercentage","default":{"kind":"just","value":null},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}}]}},"name":"AppUserDetails","version":{"kind":"nothing"}}};

export const snAppUserDetails: ADL.ScopedName = {moduleName:"hotel.api", name:"AppUserDetails"};

export function texprAppUserDetails(): ADL.ATypeExpr<AppUserDetails> {
  return {value : {typeRef : {kind: "reference", value : snAppUserDetails}, parameters : []}};
}

/**
 * Details for a user
 */
export interface UserReq {
  userType: hotel_db.AppUserType;
  fullname: string;
  email: string;
  agencyId: (common_db.DbKey<hotel_db.Agency>|null);
  phoneNumber: (ids_common.PhoneNumber|null);
  commissionPercentage: (common.BigDecimal|null);
}

export function makeUserReq(
  input: {
    userType: hotel_db.AppUserType,
    fullname: string,
    email: string,
    agencyId: (common_db.DbKey<hotel_db.Agency>|null),
    phoneNumber: (ids_common.PhoneNumber|null),
    commissionPercentage: (common.BigDecimal|null),
  }
): UserReq {
  return {
    userType: input.userType,
    fullname: input.fullname,
    email: input.email,
    agencyId: input.agencyId,
    phoneNumber: input.phoneNumber,
    commissionPercentage: input.commissionPercentage,
  };
}

const UserReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"userType","default":{"kind":"nothing"},"name":"userType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUserType"}},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"agencyId","default":{"kind":"nothing"},"name":"agencyId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Agency"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[],"serializedName":"commissionPercentage","default":{"kind":"nothing"},"name":"commissionPercentage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}}]}},"name":"UserReq","version":{"kind":"nothing"}}};

export const snUserReq: ADL.ScopedName = {moduleName:"hotel.api", name:"UserReq"};

export function texprUserReq(): ADL.ATypeExpr<UserReq> {
  return {value : {typeRef : {kind: "reference", value : snUserReq}, parameters : []}};
}

export interface LoginReq {
  email: common_strings.StringNE;
  password: common_strings.StringNE;
}

export function makeLoginReq(
  input: {
    email: common_strings.StringNE,
    password: common_strings.StringNE,
  }
): LoginReq {
  return {
    email: input.email,
    password: input.password,
  };
}

const LoginReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"LoginReq","version":{"kind":"nothing"}}};

export const snLoginReq: ADL.ScopedName = {moduleName:"hotel.api", name:"LoginReq"};

export function texprLoginReq(): ADL.ATypeExpr<LoginReq> {
  return {value : {typeRef : {kind: "reference", value : snLoginReq}, parameters : []}};
}

export interface LoginResp_AccessToken {
  kind: 'accessToken';
  value: common_strings.StringNE;
}
export interface LoginResp_InvalidCredentials {
  kind: 'invalidCredentials';
}

export type LoginResp = LoginResp_AccessToken | LoginResp_InvalidCredentials;

export interface LoginRespOpts {
  accessToken: common_strings.StringNE;
  invalidCredentials: null;
}

export function makeLoginResp<K extends keyof LoginRespOpts>(kind: K, value: LoginRespOpts[K]) { return {kind, value}; }

const LoginResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"accessToken","default":{"kind":"nothing"},"name":"accessToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"invalidCredentials","default":{"kind":"nothing"},"name":"invalidCredentials","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LoginResp","version":{"kind":"nothing"}}};

export const snLoginResp: ADL.ScopedName = {moduleName:"hotel.api", name:"LoginResp"};

export function texprLoginResp(): ADL.ATypeExpr<LoginResp> {
  return {value : {typeRef : {kind: "reference", value : snLoginResp}, parameters : []}};
}

export interface NewMessageReq {
  message: common_strings.StringML;
}

export function makeNewMessageReq(
  input: {
    message: common_strings.StringML,
  }
): NewMessageReq {
  return {
    message: input.message,
  };
}

const NewMessageReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}}]}},"name":"NewMessageReq","version":{"kind":"nothing"}}};

export const snNewMessageReq: ADL.ScopedName = {moduleName:"hotel.api", name:"NewMessageReq"};

export function texprNewMessageReq(): ADL.ATypeExpr<NewMessageReq> {
  return {value : {typeRef : {kind: "reference", value : snNewMessageReq}, parameters : []}};
}

export interface RecentMessagesReq {
  offset: number;
  count: number;
}

export function makeRecentMessagesReq(
  input: {
    offset?: number,
    count?: number,
  }
): RecentMessagesReq {
  return {
    offset: input.offset === undefined ? 0 : input.offset,
    count: input.count === undefined ? 20 : input.count,
  };
}

const RecentMessagesReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"offset","default":{"kind":"just","value":0},"name":"offset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"count","default":{"kind":"just","value":20},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"RecentMessagesReq","version":{"kind":"nothing"}}};

export const snRecentMessagesReq: ADL.ScopedName = {moduleName:"hotel.api", name:"RecentMessagesReq"};

export function texprRecentMessagesReq(): ADL.ATypeExpr<RecentMessagesReq> {
  return {value : {typeRef : {kind: "reference", value : snRecentMessagesReq}, parameters : []}};
}

export interface CreateUserResp_Success {
  kind: 'success';
  value: hotel_db.AppUserId;
}
export interface CreateUserResp_Error {
  kind: 'error';
  value: string;
}

export type CreateUserResp = CreateUserResp_Success | CreateUserResp_Error;

export interface CreateUserRespOpts {
  success: hotel_db.AppUserId;
  error: string;
}

export function makeCreateUserResp<K extends keyof CreateUserRespOpts>(kind: K, value: CreateUserRespOpts[K]) { return {kind, value}; }

const CreateUserResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"AppUserId"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CreateUserResp","version":{"kind":"nothing"}}};

export const snCreateUserResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateUserResp"};

export function texprCreateUserResp(): ADL.ATypeExpr<CreateUserResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateUserResp}, parameters : []}};
}

export interface UpdateUserResp_Success {
  kind: 'success';
}
export interface UpdateUserResp_Error {
  kind: 'error';
  value: string;
}

export type UpdateUserResp = UpdateUserResp_Success | UpdateUserResp_Error;

export interface UpdateUserRespOpts {
  success: null;
  error: string;
}

export function makeUpdateUserResp<K extends keyof UpdateUserRespOpts>(kind: K, value: UpdateUserRespOpts[K]) { return {kind, value}; }

const UpdateUserResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UpdateUserResp","version":{"kind":"nothing"}}};

export const snUpdateUserResp: ADL.ScopedName = {moduleName:"hotel.api", name:"UpdateUserResp"};

export function texprUpdateUserResp(): ADL.ATypeExpr<UpdateUserResp> {
  return {value : {typeRef : {kind: "reference", value : snUpdateUserResp}, parameters : []}};
}

export interface DeleteUserResp_Success {
  kind: 'success';
}
export interface DeleteUserResp_Error {
  kind: 'error';
  value: string;
}

export type DeleteUserResp = DeleteUserResp_Success | DeleteUserResp_Error;

export interface DeleteUserRespOpts {
  success: null;
  error: string;
}

export function makeDeleteUserResp<K extends keyof DeleteUserRespOpts>(kind: K, value: DeleteUserRespOpts[K]) { return {kind, value}; }

const DeleteUserResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"DeleteUserResp","version":{"kind":"nothing"}}};

export const snDeleteUserResp: ADL.ScopedName = {moduleName:"hotel.api", name:"DeleteUserResp"};

export function texprDeleteUserResp(): ADL.ATypeExpr<DeleteUserResp> {
  return {value : {typeRef : {kind: "reference", value : snDeleteUserResp}, parameters : []}};
}

export interface UpdateUserPasswordReq {
  oldPassword: string;
  newPassword: string;
}

export function makeUpdateUserPasswordReq(
  input: {
    oldPassword: string,
    newPassword: string,
  }
): UpdateUserPasswordReq {
  return {
    oldPassword: input.oldPassword,
    newPassword: input.newPassword,
  };
}

const UpdateUserPasswordReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"oldPassword","default":{"kind":"nothing"},"name":"oldPassword","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"newPassword","default":{"kind":"nothing"},"name":"newPassword","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UpdateUserPasswordReq","version":{"kind":"nothing"}}};

export const snUpdateUserPasswordReq: ADL.ScopedName = {moduleName:"hotel.api", name:"UpdateUserPasswordReq"};

export function texprUpdateUserPasswordReq(): ADL.ATypeExpr<UpdateUserPasswordReq> {
  return {value : {typeRef : {kind: "reference", value : snUpdateUserPasswordReq}, parameters : []}};
}

export interface UpdateUserPasswordResp_Success {
  kind: 'success';
}
export interface UpdateUserPasswordResp_Error {
  kind: 'error';
  value: string;
}

export type UpdateUserPasswordResp = UpdateUserPasswordResp_Success | UpdateUserPasswordResp_Error;

export interface UpdateUserPasswordRespOpts {
  success: null;
  error: string;
}

export function makeUpdateUserPasswordResp<K extends keyof UpdateUserPasswordRespOpts>(kind: K, value: UpdateUserPasswordRespOpts[K]) { return {kind, value}; }

const UpdateUserPasswordResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UpdateUserPasswordResp","version":{"kind":"nothing"}}};

export const snUpdateUserPasswordResp: ADL.ScopedName = {moduleName:"hotel.api", name:"UpdateUserPasswordResp"};

export function texprUpdateUserPasswordResp(): ADL.ATypeExpr<UpdateUserPasswordResp> {
  return {value : {typeRef : {kind: "reference", value : snUpdateUserPasswordResp}, parameters : []}};
}

export interface BookingSearchQuery {
  /**
   * Itinerary number to filter bookings by, if present.
   */
  itineraryNumber: (common_strings.StringNE|null);
  /**
   * Booking number to filter bookings by, if present.
   */
  bookingNumber: (common_strings.StringNE|null);
  /**
   * Name of destination to filter bookings by, if present.
   */
  destinationName: (common_strings.StringNE|null);
  /**
   * Country code to filter bookings by, if present.
   */
  countryCode: (ids_common.CountryCode|null);
  /**
   * Traveller first name to filter bookings by, if present.
   */
  firstName: (common_strings.StringNE|null);
  /**
   * Traveller last name to filter bookings by, if present.
   */
  lastName: (common_strings.StringNE|null);
  /**
   * Pending payment to filter bookings by, if present.
   */
  isPaymentPending: (boolean|null);
  /**
   * Created from date to filter bookings by, if present.
   */
  createdFrom: (common.Instant|null);
  /**
   * To date to filter bookings by, if present.
   */
  createdTo: (common.Instant|null);
  /**
   * Service-from date range
   */
  serviceFrom: (LocalDateRange|null);
  /**
   * Service-to date range
   */
  serviceTo: (LocalDateRange|null);
  /**
   * Payment-due date range
   */
  paymentDueDate: (LocalDateRange|null);
  /**
   * Instant purchase (if true) or book and hold filter (if false)
   */
  isInstantPurchase: (boolean|null);
  /**
   * Cancellation policy status
   */
  isCancellationPolicyActive: (boolean|null);
  /**
   * Client payment statuses
   */
  clientPaymentStatuses: hotel_booking.ClientPaymentStatus[];
  /**
   * Supplier payment statuses
   */
  supplierPaymentStatuses: hotel_booking.SupplierPaymentStatus[];
  /**
   * Live statuses to filter bookings by.
   */
  liveStatuses: hotel_booking.LiveStatus[];
  /**
   * Username to filter bookings by, if present.
   * TODO(jess): Update this to take an app user id.
   */
  userName: (common_strings.StringNE|null);
  /**
   * Cancellation result status filter
   */
  isCancellationFailed: (boolean|null);
  /**
   * Agent reference filter
   */
  agentRef: (common_strings.StringNE|null);
  /**
   * Number of items to return.
   */
  count: number;
  /**
   * The offset of the next page of results.
   */
  offset: number;
}

export function makeBookingSearchQuery(
  input: {
    itineraryNumber?: (common_strings.StringNE|null),
    bookingNumber?: (common_strings.StringNE|null),
    destinationName?: (common_strings.StringNE|null),
    countryCode?: (ids_common.CountryCode|null),
    firstName?: (common_strings.StringNE|null),
    lastName?: (common_strings.StringNE|null),
    isPaymentPending?: (boolean|null),
    createdFrom?: (common.Instant|null),
    createdTo?: (common.Instant|null),
    serviceFrom?: (LocalDateRange|null),
    serviceTo?: (LocalDateRange|null),
    paymentDueDate?: (LocalDateRange|null),
    isInstantPurchase?: (boolean|null),
    isCancellationPolicyActive?: (boolean|null),
    clientPaymentStatuses?: hotel_booking.ClientPaymentStatus[],
    supplierPaymentStatuses?: hotel_booking.SupplierPaymentStatus[],
    liveStatuses?: hotel_booking.LiveStatus[],
    userName?: (common_strings.StringNE|null),
    isCancellationFailed?: (boolean|null),
    agentRef?: (common_strings.StringNE|null),
    count?: number,
    offset?: number,
  }
): BookingSearchQuery {
  return {
    itineraryNumber: input.itineraryNumber === undefined ? null : input.itineraryNumber,
    bookingNumber: input.bookingNumber === undefined ? null : input.bookingNumber,
    destinationName: input.destinationName === undefined ? null : input.destinationName,
    countryCode: input.countryCode === undefined ? null : input.countryCode,
    firstName: input.firstName === undefined ? null : input.firstName,
    lastName: input.lastName === undefined ? null : input.lastName,
    isPaymentPending: input.isPaymentPending === undefined ? null : input.isPaymentPending,
    createdFrom: input.createdFrom === undefined ? null : input.createdFrom,
    createdTo: input.createdTo === undefined ? null : input.createdTo,
    serviceFrom: input.serviceFrom === undefined ? null : input.serviceFrom,
    serviceTo: input.serviceTo === undefined ? null : input.serviceTo,
    paymentDueDate: input.paymentDueDate === undefined ? null : input.paymentDueDate,
    isInstantPurchase: input.isInstantPurchase === undefined ? null : input.isInstantPurchase,
    isCancellationPolicyActive: input.isCancellationPolicyActive === undefined ? null : input.isCancellationPolicyActive,
    clientPaymentStatuses: input.clientPaymentStatuses === undefined ? [] : input.clientPaymentStatuses,
    supplierPaymentStatuses: input.supplierPaymentStatuses === undefined ? [] : input.supplierPaymentStatuses,
    liveStatuses: input.liveStatuses === undefined ? [] : input.liveStatuses,
    userName: input.userName === undefined ? null : input.userName,
    isCancellationFailed: input.isCancellationFailed === undefined ? null : input.isCancellationFailed,
    agentRef: input.agentRef === undefined ? null : input.agentRef,
    count: input.count === undefined ? 0 : input.count,
    offset: input.offset === undefined ? 20 : input.offset,
  };
}

const BookingSearchQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Itinerary number to filter bookings by, if present.\n"}],"serializedName":"itineraryNumber","default":{"kind":"just","value":null},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking number to filter bookings by, if present.\n"}],"serializedName":"bookingNumber","default":{"kind":"just","value":null},"name":"bookingNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of destination to filter bookings by, if present.\n"}],"serializedName":"destinationName","default":{"kind":"just","value":null},"name":"destinationName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Country code to filter bookings by, if present.\n"}],"serializedName":"countryCode","default":{"kind":"just","value":null},"name":"countryCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"CountryCode"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Traveller first name to filter bookings by, if present.\n"}],"serializedName":"firstName","default":{"kind":"just","value":null},"name":"firstName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Traveller last name to filter bookings by, if present.\n"}],"serializedName":"lastName","default":{"kind":"just","value":null},"name":"lastName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Pending payment to filter bookings by, if present.\n"}],"serializedName":"isPaymentPending","default":{"kind":"just","value":null},"name":"isPaymentPending","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Created from date to filter bookings by, if present.\n"}],"serializedName":"createdFrom","default":{"kind":"just","value":null},"name":"createdFrom","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"To date to filter bookings by, if present.\n"}],"serializedName":"createdTo","default":{"kind":"just","value":null},"name":"createdTo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Service-from date range\n"}],"serializedName":"serviceFrom","default":{"kind":"just","value":null},"name":"serviceFrom","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LocalDateRange"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Service-to date range\n"}],"serializedName":"serviceTo","default":{"kind":"just","value":null},"name":"serviceTo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LocalDateRange"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment-due date range\n"}],"serializedName":"paymentDueDate","default":{"kind":"just","value":null},"name":"paymentDueDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LocalDateRange"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Instant purchase (if true) or book and hold filter (if false)\n"}],"serializedName":"isInstantPurchase","default":{"kind":"just","value":null},"name":"isInstantPurchase","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancellation policy status\n"}],"serializedName":"isCancellationPolicyActive","default":{"kind":"just","value":null},"name":"isCancellationPolicyActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client payment statuses\n"}],"serializedName":"clientPaymentStatuses","default":{"kind":"just","value":[]},"name":"clientPaymentStatuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"ClientPaymentStatus"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier payment statuses\n"}],"serializedName":"supplierPaymentStatuses","default":{"kind":"just","value":[]},"name":"supplierPaymentStatuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"SupplierPaymentStatus"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Live statuses to filter bookings by.\n"}],"serializedName":"liveStatuses","default":{"kind":"just","value":[]},"name":"liveStatuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"LiveStatus"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Username to filter bookings by, if present.\nTODO(jess): Update this to take an app user id.\n"}],"serializedName":"userName","default":{"kind":"just","value":null},"name":"userName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancellation result status filter\n"}],"serializedName":"isCancellationFailed","default":{"kind":"just","value":null},"name":"isCancellationFailed","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Agent reference filter\n"}],"serializedName":"agentRef","default":{"kind":"just","value":null},"name":"agentRef","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Number of items to return.\n"}],"serializedName":"count","default":{"kind":"just","value":0},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The offset of the next page of results.\n"}],"serializedName":"offset","default":{"kind":"just","value":20},"name":"offset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"BookingSearchQuery","version":{"kind":"nothing"}}};

export const snBookingSearchQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingSearchQuery"};

export function texprBookingSearchQuery(): ADL.ATypeExpr<BookingSearchQuery> {
  return {value : {typeRef : {kind: "reference", value : snBookingSearchQuery}, parameters : []}};
}

export interface LocalDateRange {
  from: (common.LocalDate|null);
  to: (common.LocalDate|null);
}

export function makeLocalDateRange(
  input: {
    from?: (common.LocalDate|null),
    to?: (common.LocalDate|null),
  }
): LocalDateRange {
  return {
    from: input.from === undefined ? null : input.from,
    to: input.to === undefined ? null : input.to,
  };
}

const LocalDateRange_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"from","default":{"kind":"just","value":null},"name":"from","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"to","default":{"kind":"just","value":null},"name":"to","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"LocalDateRange","version":{"kind":"nothing"}}};

export const snLocalDateRange: ADL.ScopedName = {moduleName:"hotel.api", name:"LocalDateRange"};

export function texprLocalDateRange(): ADL.ATypeExpr<LocalDateRange> {
  return {value : {typeRef : {kind: "reference", value : snLocalDateRange}, parameters : []}};
}

export interface BookingSearchShortcutQuery {
  shortcuts: sys_types.Set<BookingSearchShortcut>;
}

export function makeBookingSearchShortcutQuery(
  input: {
    shortcuts: sys_types.Set<BookingSearchShortcut>,
  }
): BookingSearchShortcutQuery {
  return {
    shortcuts: input.shortcuts,
  };
}

const BookingSearchShortcutQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"shortcuts","default":{"kind":"nothing"},"name":"shortcuts","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingSearchShortcut"}},"parameters":[]}]}}]}},"name":"BookingSearchShortcutQuery","version":{"kind":"nothing"}}};

export const snBookingSearchShortcutQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingSearchShortcutQuery"};

export function texprBookingSearchShortcutQuery(): ADL.ATypeExpr<BookingSearchShortcutQuery> {
  return {value : {typeRef : {kind: "reference", value : snBookingSearchShortcutQuery}, parameters : []}};
}

export enum BookingSearchShortcut {
  quoteBookAndHold,
  quoteInstantPurchase,
  confirmedUnpaid,
  paymentDueIn2Days,
  confirmedAndPaid,
  refundPending,
  paymentDueIn30Days,
  departureWithin7Days,
}

const BookingSearchShortcut_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quoteBookAndHold","default":{"kind":"nothing"},"name":"quoteBookAndHold","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"quoteInstantPurchase","default":{"kind":"nothing"},"name":"quoteInstantPurchase","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"confirmedUnpaid","default":{"kind":"nothing"},"name":"confirmedUnpaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"paymentDueIn2Days","default":{"kind":"nothing"},"name":"paymentDueIn2Days","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"confirmedAndPaid","default":{"kind":"nothing"},"name":"confirmedAndPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"refundPending","default":{"kind":"nothing"},"name":"refundPending","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"paymentDueIn30Days","default":{"kind":"nothing"},"name":"paymentDueIn30Days","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"departureWithin7Days","default":{"kind":"nothing"},"name":"departureWithin7Days","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"BookingSearchShortcut","version":{"kind":"nothing"}}};

export const snBookingSearchShortcut: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingSearchShortcut"};

export function texprBookingSearchShortcut(): ADL.ATypeExpr<BookingSearchShortcut> {
  return {value : {typeRef : {kind: "reference", value : snBookingSearchShortcut}, parameters : []}};
}

export interface BookingSearchShortcutCountResp {
  shortcutTotals: ShortcutTotalsReport[];
}

export function makeBookingSearchShortcutCountResp(
  input: {
    shortcutTotals: ShortcutTotalsReport[],
  }
): BookingSearchShortcutCountResp {
  return {
    shortcutTotals: input.shortcutTotals,
  };
}

const BookingSearchShortcutCountResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"shortcutTotals","default":{"kind":"nothing"},"name":"shortcutTotals","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ShortcutTotalsReport"}},"parameters":[]}]}}]}},"name":"BookingSearchShortcutCountResp","version":{"kind":"nothing"}}};

export const snBookingSearchShortcutCountResp: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingSearchShortcutCountResp"};

export function texprBookingSearchShortcutCountResp(): ADL.ATypeExpr<BookingSearchShortcutCountResp> {
  return {value : {typeRef : {kind: "reference", value : snBookingSearchShortcutCountResp}, parameters : []}};
}

/**
 */
export interface ShortcutTotalsReport {
  /**
   * Shortcut name
   */
  shortcut: BookingSearchShortcut;
  /**
   * The total number of bookings in the corresponding shortcut
   */
  total: number;
}

export function makeShortcutTotalsReport(
  input: {
    shortcut: BookingSearchShortcut,
    total: number,
  }
): ShortcutTotalsReport {
  return {
    shortcut: input.shortcut,
    total: input.total,
  };
}

const ShortcutTotalsReport_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Shortcut name\n"}],"serializedName":"shortcut","default":{"kind":"nothing"},"name":"shortcut","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingSearchShortcut"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The total number of bookings in the corresponding shortcut\n"}],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}]}},"name":"ShortcutTotalsReport","version":{"kind":"nothing"}}};

export const snShortcutTotalsReport: ADL.ScopedName = {moduleName:"hotel.api", name:"ShortcutTotalsReport"};

export function texprShortcutTotalsReport(): ADL.ATypeExpr<ShortcutTotalsReport> {
  return {value : {typeRef : {kind: "reference", value : snShortcutTotalsReport}, parameters : []}};
}

export interface BookingSearchQueryResp_AgentBookingData {
  kind: 'agentBookingData';
  value: common.Paginated<AgentBookingData>;
}
export interface BookingSearchQueryResp_BackOfficeUserBookingData {
  kind: 'backOfficeUserBookingData';
  value: common.Paginated<BackOfficeUserBookingData>;
}

/**
 * Booking search results with applicable filters applied. The branch
 * returned will depend on the access level of the user calling the endpoint
 */
export type BookingSearchQueryResp = BookingSearchQueryResp_AgentBookingData | BookingSearchQueryResp_BackOfficeUserBookingData;

export interface BookingSearchQueryRespOpts {
  /**
   * Booking data that is visible to an agent
   */
  agentBookingData: common.Paginated<AgentBookingData>;
  /**
   * Booking data that is visible to Back Office User
   */
  backOfficeUserBookingData: common.Paginated<BackOfficeUserBookingData>;
}

export function makeBookingSearchQueryResp<K extends keyof BookingSearchQueryRespOpts>(kind: K, value: BookingSearchQueryRespOpts[K]) { return {kind, value}; }

const BookingSearchQueryResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking search results with applicable filters applied. The branch\nreturned will depend on the access level of the user calling the endpoint\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking data that is visible to an agent\n"}],"serializedName":"agentBookingData","default":{"kind":"nothing"},"name":"agentBookingData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AgentBookingData"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking data that is visible to Back Office User\n"}],"serializedName":"backOfficeUserBookingData","default":{"kind":"nothing"},"name":"backOfficeUserBookingData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BackOfficeUserBookingData"}},"parameters":[]}]}}]}},"name":"BookingSearchQueryResp","version":{"kind":"nothing"}}};

export const snBookingSearchQueryResp: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingSearchQueryResp"};

export function texprBookingSearchQueryResp(): ADL.ATypeExpr<BookingSearchQueryResp> {
  return {value : {typeRef : {kind: "reference", value : snBookingSearchQueryResp}, parameters : []}};
}

export interface AgentBookingData {
  bookingData: ClientBookingData;
  bookingPrice: AgentPaymentInformation;
  balance: AgentPaymentInformation;
  lineItems: AgentPaymentLineItem[];
}

export function makeAgentBookingData(
  input: {
    bookingData: ClientBookingData,
    bookingPrice: AgentPaymentInformation,
    balance: AgentPaymentInformation,
    lineItems: AgentPaymentLineItem[],
  }
): AgentBookingData {
  return {
    bookingData: input.bookingData,
    bookingPrice: input.bookingPrice,
    balance: input.balance,
    lineItems: input.lineItems,
  };
}

const AgentBookingData_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingData","default":{"kind":"nothing"},"name":"bookingData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ClientBookingData"}},"parameters":[]}},{"annotations":[],"serializedName":"bookingPrice","default":{"kind":"nothing"},"name":"bookingPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AgentPaymentInformation"}},"parameters":[]}},{"annotations":[],"serializedName":"balance","default":{"kind":"nothing"},"name":"balance","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AgentPaymentInformation"}},"parameters":[]}},{"annotations":[],"serializedName":"lineItems","default":{"kind":"nothing"},"name":"lineItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AgentPaymentLineItem"}},"parameters":[]}]}}]}},"name":"AgentBookingData","version":{"kind":"nothing"}}};

export const snAgentBookingData: ADL.ScopedName = {moduleName:"hotel.api", name:"AgentBookingData"};

export function texprAgentBookingData(): ADL.ATypeExpr<AgentBookingData> {
  return {value : {typeRef : {kind: "reference", value : snAgentBookingData}, parameters : []}};
}

/**
 * Price information that is relevant to an Agent
 */
export interface AgentPaymentInformation {
  netPriceWithTax: hotel_common.PriceValue;
  grossPriceWithTax: hotel_common.PriceValue;
}

export function makeAgentPaymentInformation(
  input: {
    netPriceWithTax: hotel_common.PriceValue,
    grossPriceWithTax: hotel_common.PriceValue,
  }
): AgentPaymentInformation {
  return {
    netPriceWithTax: input.netPriceWithTax,
    grossPriceWithTax: input.grossPriceWithTax,
  };
}

const AgentPaymentInformation_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Price information that is relevant to an Agent\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"netPriceWithTax","default":{"kind":"nothing"},"name":"netPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[],"serializedName":"grossPriceWithTax","default":{"kind":"nothing"},"name":"grossPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}}]}},"name":"AgentPaymentInformation","version":{"kind":"nothing"}}};

export const snAgentPaymentInformation: ADL.ScopedName = {moduleName:"hotel.api", name:"AgentPaymentInformation"};

export function texprAgentPaymentInformation(): ADL.ATypeExpr<AgentPaymentInformation> {
  return {value : {typeRef : {kind: "reference", value : snAgentPaymentInformation}, parameters : []}};
}

/**
 * Price information that is relevant to a Back Office user
 */
export interface BackOfficeUserPaymentInformation {
  supplierPrice: hotel_common.PriceValue;
  buyPrice: hotel_common.PriceValue;
  netPriceWithTax: hotel_common.PriceValue;
  grossPriceWithTax: hotel_common.PriceValue;
  commission: hotel_common.PercentageAmountValue;
}

export function makeBackOfficeUserPaymentInformation(
  input: {
    supplierPrice: hotel_common.PriceValue,
    buyPrice: hotel_common.PriceValue,
    netPriceWithTax: hotel_common.PriceValue,
    grossPriceWithTax: hotel_common.PriceValue,
    commission: hotel_common.PercentageAmountValue,
  }
): BackOfficeUserPaymentInformation {
  return {
    supplierPrice: input.supplierPrice,
    buyPrice: input.buyPrice,
    netPriceWithTax: input.netPriceWithTax,
    grossPriceWithTax: input.grossPriceWithTax,
    commission: input.commission,
  };
}

const BackOfficeUserPaymentInformation_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Price information that is relevant to a Back Office user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"supplierPrice","default":{"kind":"nothing"},"name":"supplierPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[],"serializedName":"buyPrice","default":{"kind":"nothing"},"name":"buyPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[],"serializedName":"netPriceWithTax","default":{"kind":"nothing"},"name":"netPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[],"serializedName":"grossPriceWithTax","default":{"kind":"nothing"},"name":"grossPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[],"serializedName":"commission","default":{"kind":"nothing"},"name":"commission","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PercentageAmountValue"}},"parameters":[]}}]}},"name":"BackOfficeUserPaymentInformation","version":{"kind":"nothing"}}};

export const snBackOfficeUserPaymentInformation: ADL.ScopedName = {moduleName:"hotel.api", name:"BackOfficeUserPaymentInformation"};

export function texprBackOfficeUserPaymentInformation(): ADL.ATypeExpr<BackOfficeUserPaymentInformation> {
  return {value : {typeRef : {kind: "reference", value : snBackOfficeUserPaymentInformation}, parameters : []}};
}

export interface BackOfficeUserBookingData {
  bookingData: ClientBookingData;
  lineItems: hotel_db.BookingLineItem[];
  taxesAndFees: hotel_db.BookingTaxFee[];
  bookingPrice: BackOfficeUserPaymentInformation;
  balance: BackOfficeUserPaymentInformation;
  supplierData: SupplierData;
}

export function makeBackOfficeUserBookingData(
  input: {
    bookingData: ClientBookingData,
    lineItems: hotel_db.BookingLineItem[],
    taxesAndFees: hotel_db.BookingTaxFee[],
    bookingPrice: BackOfficeUserPaymentInformation,
    balance: BackOfficeUserPaymentInformation,
    supplierData: SupplierData,
  }
): BackOfficeUserBookingData {
  return {
    bookingData: input.bookingData,
    lineItems: input.lineItems,
    taxesAndFees: input.taxesAndFees,
    bookingPrice: input.bookingPrice,
    balance: input.balance,
    supplierData: input.supplierData,
  };
}

const BackOfficeUserBookingData_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingData","default":{"kind":"nothing"},"name":"bookingData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ClientBookingData"}},"parameters":[]}},{"annotations":[],"serializedName":"lineItems","default":{"kind":"nothing"},"name":"lineItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"BookingLineItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"taxesAndFees","default":{"kind":"nothing"},"name":"taxesAndFees","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"BookingTaxFee"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bookingPrice","default":{"kind":"nothing"},"name":"bookingPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BackOfficeUserPaymentInformation"}},"parameters":[]}},{"annotations":[],"serializedName":"balance","default":{"kind":"nothing"},"name":"balance","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BackOfficeUserPaymentInformation"}},"parameters":[]}},{"annotations":[],"serializedName":"supplierData","default":{"kind":"nothing"},"name":"supplierData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"SupplierData"}},"parameters":[]}}]}},"name":"BackOfficeUserBookingData","version":{"kind":"nothing"}}};

export const snBackOfficeUserBookingData: ADL.ScopedName = {moduleName:"hotel.api", name:"BackOfficeUserBookingData"};

export function texprBackOfficeUserBookingData(): ADL.ATypeExpr<BackOfficeUserBookingData> {
  return {value : {typeRef : {kind: "reference", value : snBackOfficeUserBookingData}, parameters : []}};
}

/**
 * Supplier information that is safe to view by a Back Office user, should not be visible to an agent
 */
export interface SupplierData {
  /**
   * The name of the supplier
   */
  supplierName: string;
  /**
   * A list of supplier session IDs related to this booking
   */
  sessionIds: hotel_db.SupplierSession[];
  /**
   * Contains supplier information about this booking, i.e booking ID,
   * reference, etc. Present if the booking is confirmed
   */
  supplierBookingInfo: ({}|null|null);
}

export function makeSupplierData(
  input: {
    supplierName: string,
    sessionIds: hotel_db.SupplierSession[],
    supplierBookingInfo?: ({}|null|null),
  }
): SupplierData {
  return {
    supplierName: input.supplierName,
    sessionIds: input.sessionIds,
    supplierBookingInfo: input.supplierBookingInfo === undefined ? null : input.supplierBookingInfo,
  };
}

const SupplierData_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier information that is safe to view by a Back Office user, should not be visible to an agent\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The name of the supplier\n"}],"serializedName":"supplierName","default":{"kind":"nothing"},"name":"supplierName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A list of supplier session IDs related to this booking\n"}],"serializedName":"sessionIds","default":{"kind":"nothing"},"name":"sessionIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"SupplierSession"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Contains supplier information about this booking, i.e booking ID,\nreference, etc. Present if the booking is confirmed\n"}],"serializedName":"supplierBookingInfo","default":{"kind":"just","value":null},"name":"supplierBookingInfo","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}]}}]}},"name":"SupplierData","version":{"kind":"nothing"}}};

export const snSupplierData: ADL.ScopedName = {moduleName:"hotel.api", name:"SupplierData"};

export function texprSupplierData(): ADL.ATypeExpr<SupplierData> {
  return {value : {typeRef : {kind: "reference", value : snSupplierData}, parameters : []}};
}

/**
 * Line item information that is safe to view by an agent
 */
export interface AgentPaymentLineItem {
  created: common.Instant;
  lineItemId: hotel_booking.LineItemType;
  netPriceWithTax: hotel_common.PriceValue;
  grossPriceWithTax: hotel_common.PriceValue;
}

export function makeAgentPaymentLineItem(
  input: {
    created: common.Instant,
    lineItemId: hotel_booking.LineItemType,
    netPriceWithTax: hotel_common.PriceValue,
    grossPriceWithTax: hotel_common.PriceValue,
  }
): AgentPaymentLineItem {
  return {
    created: input.created,
    lineItemId: input.lineItemId,
    netPriceWithTax: input.netPriceWithTax,
    grossPriceWithTax: input.grossPriceWithTax,
  };
}

const AgentPaymentLineItem_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Line item information that is safe to view by an agent\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"lineItemId","default":{"kind":"nothing"},"name":"lineItemId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"LineItemType"}},"parameters":[]}},{"annotations":[],"serializedName":"netPriceWithTax","default":{"kind":"nothing"},"name":"netPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}},{"annotations":[],"serializedName":"grossPriceWithTax","default":{"kind":"nothing"},"name":"grossPriceWithTax","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PriceValue"}},"parameters":[]}}]}},"name":"AgentPaymentLineItem","version":{"kind":"nothing"}}};

export const snAgentPaymentLineItem: ADL.ScopedName = {moduleName:"hotel.api", name:"AgentPaymentLineItem"};

export function texprAgentPaymentLineItem(): ADL.ATypeExpr<AgentPaymentLineItem> {
  return {value : {typeRef : {kind: "reference", value : snAgentPaymentLineItem}, parameters : []}};
}

/**
 * Collection of booking data that is safe to send to the client, should not
 * leak any internal information
 */
export interface ClientBookingData {
  /**
   * The ID of this booking
   */
  bookingId: common_db.DbKey<hotel_db.Booking>;
  /**
   * Id of itinerary this booking is associated with.
   */
  itineraryId: common_db.DbKey<hotel_db.Itinerary>;
  /**
   * Generated unique short booking number
   */
  bookingNumber: common_strings.StringNE;
  /**
   * Details about hotel.
   */
  hotelDetails: hotel_booking.HotelDetails;
  /**
   * Name of the agent user associated with the booking.
   */
  userName: string;
  /**
   * Email of the agent user associated with the booking.
   */
  userEmail: string;
  /**
   * Phone number of the agent user associated with the booking, if present.
   */
  phoneNumber: (ids_common.PhoneNumber|null);
  /**
   * Id of hotel to generate link to hotel page on IDS for backoffice users.
   */
  hotelId: hotel_common.HotelId;
  /**
   * Name of room (from supplier).
   */
  roomName: common_strings.StringNE;
  /**
   * Board description e.g. Room Only, Breakfast Included etc.
   */
  board: hotel_booking.Board;
  /**
   * Represents the current status of this booking.
   */
  liveStatus: hotel_booking.LiveStatus;
  /**
   * Represents the current status of the client payment for this booking.
   */
  clientPaymentStatus: hotel_booking.ClientPaymentStatus;
  /**
   * Represents the payment mode of the client payment used to pay for this booking.
   */
  clientPaymentMode: (hotel_booking.PaymentMode|null);
  /**
   * Represents the current status of the supplier payment
   */
  supplierPaymentStatus: hotel_booking.SupplierPaymentStatus;
  /**
   * Optional agent reference
   */
  agentReference: (string|null);
  /**
   * Date of check in.
   */
  checkInDate: common.LocalDate;
  /**
   * Date of check out.
   */
  checkOutDate: common.LocalDate;
  /**
   * Payment due date.
   */
  paymentDueDate: common.LocalDate;
  /**
   * Payment paid on date.
   */
  paidOn: (common.Instant|null);
  /**
   * Standard special requests (empty if none).
   */
  specialRequests: hotel_booking.StandardSpecialRequest[];
  /**
   * Details of all the people staying in the booked rooms
   */
  rooms: hotel_booking.RoomOccupancyDetails[];
  /**
   * Used to flag when the user has requested a cancellation
   * but there has been a failure or error cancelling the
   * booking with the supplier.
   */
  isCancellationFailed: boolean;
  /**
   * Used to flag if the booking has been confirmed and agency
   * payment is required within 24 hours. This happens when
   * confirmation of the booking is successful with the supplier
   * but payment has failed or aborted.
   */
  isPaymentPending: boolean;
  /**
   * True when it should be paid before confirm
   */
  isInstantPurchase: boolean;
  /**
   * Cancellation policy of booking.
   */
  cancellationPolicy: hotel_common.PackageCancellationPolicy;
  /**
   * Itinerary number associated with the booking.
   */
  itineraryNumber: string;
  /**
   * Date booking was last updated.
   */
  lastUpdated: common.Instant;
  /**
   * Date booking was created.
   */
  created: common.Instant;
}

export function makeClientBookingData(
  input: {
    bookingId: common_db.DbKey<hotel_db.Booking>,
    itineraryId: common_db.DbKey<hotel_db.Itinerary>,
    bookingNumber: common_strings.StringNE,
    hotelDetails: hotel_booking.HotelDetails,
    userName: string,
    userEmail: string,
    phoneNumber: (ids_common.PhoneNumber|null),
    hotelId: hotel_common.HotelId,
    roomName: common_strings.StringNE,
    board: hotel_booking.Board,
    liveStatus: hotel_booking.LiveStatus,
    clientPaymentStatus: hotel_booking.ClientPaymentStatus,
    clientPaymentMode: (hotel_booking.PaymentMode|null),
    supplierPaymentStatus: hotel_booking.SupplierPaymentStatus,
    agentReference: (string|null),
    checkInDate: common.LocalDate,
    checkOutDate: common.LocalDate,
    paymentDueDate: common.LocalDate,
    paidOn: (common.Instant|null),
    specialRequests: hotel_booking.StandardSpecialRequest[],
    rooms: hotel_booking.RoomOccupancyDetails[],
    isCancellationFailed?: boolean,
    isPaymentPending?: boolean,
    isInstantPurchase: boolean,
    cancellationPolicy: hotel_common.PackageCancellationPolicy,
    itineraryNumber: string,
    lastUpdated: common.Instant,
    created: common.Instant,
  }
): ClientBookingData {
  return {
    bookingId: input.bookingId,
    itineraryId: input.itineraryId,
    bookingNumber: input.bookingNumber,
    hotelDetails: input.hotelDetails,
    userName: input.userName,
    userEmail: input.userEmail,
    phoneNumber: input.phoneNumber,
    hotelId: input.hotelId,
    roomName: input.roomName,
    board: input.board,
    liveStatus: input.liveStatus,
    clientPaymentStatus: input.clientPaymentStatus,
    clientPaymentMode: input.clientPaymentMode,
    supplierPaymentStatus: input.supplierPaymentStatus,
    agentReference: input.agentReference,
    checkInDate: input.checkInDate,
    checkOutDate: input.checkOutDate,
    paymentDueDate: input.paymentDueDate,
    paidOn: input.paidOn,
    specialRequests: input.specialRequests,
    rooms: input.rooms,
    isCancellationFailed: input.isCancellationFailed === undefined ? false : input.isCancellationFailed,
    isPaymentPending: input.isPaymentPending === undefined ? false : input.isPaymentPending,
    isInstantPurchase: input.isInstantPurchase,
    cancellationPolicy: input.cancellationPolicy,
    itineraryNumber: input.itineraryNumber,
    lastUpdated: input.lastUpdated,
    created: input.created,
  };
}

const ClientBookingData_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Collection of booking data that is safe to send to the client, should not\nleak any internal information\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of this booking\n"}],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of itinerary this booking is associated with.\n"}],"serializedName":"itineraryId","default":{"kind":"nothing"},"name":"itineraryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Itinerary"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Generated unique short booking number\n"}],"serializedName":"bookingNumber","default":{"kind":"nothing"},"name":"bookingNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details about hotel.\n"}],"serializedName":"hotelDetails","default":{"kind":"nothing"},"name":"hotelDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"HotelDetails"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of the agent user associated with the booking.\n"}],"serializedName":"userName","default":{"kind":"nothing"},"name":"userName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Email of the agent user associated with the booking.\n"}],"serializedName":"userEmail","default":{"kind":"nothing"},"name":"userEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Phone number of the agent user associated with the booking, if present.\n"}],"serializedName":"phoneNumber","default":{"kind":"nothing"},"name":"phoneNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of hotel to generate link to hotel page on IDS for backoffice users.\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"HotelId"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of room (from supplier).\n"}],"serializedName":"roomName","default":{"kind":"nothing"},"name":"roomName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Board description e.g. Room Only, Breakfast Included etc.\n"}],"serializedName":"board","default":{"kind":"nothing"},"name":"board","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"Board"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the current status of this booking.\n"}],"serializedName":"liveStatus","default":{"kind":"nothing"},"name":"liveStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"LiveStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the current status of the client payment for this booking.\n"}],"serializedName":"clientPaymentStatus","default":{"kind":"nothing"},"name":"clientPaymentStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"ClientPaymentStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the payment mode of the client payment used to pay for this booking.\n"}],"serializedName":"clientPaymentMode","default":{"kind":"nothing"},"name":"clientPaymentMode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"PaymentMode"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents the current status of the supplier payment\n"}],"serializedName":"supplierPaymentStatus","default":{"kind":"nothing"},"name":"supplierPaymentStatus","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"SupplierPaymentStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Optional agent reference\n"}],"serializedName":"agentReference","default":{"kind":"nothing"},"name":"agentReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date of check in.\n"}],"serializedName":"checkInDate","default":{"kind":"nothing"},"name":"checkInDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date of check out.\n"}],"serializedName":"checkOutDate","default":{"kind":"nothing"},"name":"checkOutDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment due date.\n"}],"serializedName":"paymentDueDate","default":{"kind":"nothing"},"name":"paymentDueDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Payment paid on date.\n"}],"serializedName":"paidOn","default":{"kind":"nothing"},"name":"paidOn","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Standard special requests (empty if none).\n"}],"serializedName":"specialRequests","default":{"kind":"nothing"},"name":"specialRequests","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"StandardSpecialRequest"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details of all the people staying in the booked rooms\n"}],"serializedName":"rooms","default":{"kind":"nothing"},"name":"rooms","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"RoomOccupancyDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Used to flag when the user has requested a cancellation\nbut there has been a failure or error cancelling the\nbooking with the supplier.\n"}],"serializedName":"isCancellationFailed","default":{"kind":"just","value":false},"name":"isCancellationFailed","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Used to flag if the booking has been confirmed and agency\npayment is required within 24 hours. This happens when\nconfirmation of the booking is successful with the supplier\nbut payment has failed or aborted.\n"}],"serializedName":"isPaymentPending","default":{"kind":"just","value":false},"name":"isPaymentPending","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"True when it should be paid before confirm\n"}],"serializedName":"isInstantPurchase","default":{"kind":"nothing"},"name":"isInstantPurchase","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Cancellation policy of booking.\n"}],"serializedName":"cancellationPolicy","default":{"kind":"nothing"},"name":"cancellationPolicy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.common","name":"PackageCancellationPolicy"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Itinerary number associated with the booking.\n"}],"serializedName":"itineraryNumber","default":{"kind":"nothing"},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date booking was last updated.\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Date booking was created.\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ClientBookingData","version":{"kind":"nothing"}}};

export const snClientBookingData: ADL.ScopedName = {moduleName:"hotel.api", name:"ClientBookingData"};

export function texprClientBookingData(): ADL.ATypeExpr<ClientBookingData> {
  return {value : {typeRef : {kind: "reference", value : snClientBookingData}, parameters : []}};
}

export interface CreateTermsAndConditionsReq {
  /**
   * The T&C content
   */
  content: common_strings.StringNE;
}

export function makeCreateTermsAndConditionsReq(
  input: {
    content: common_strings.StringNE,
  }
): CreateTermsAndConditionsReq {
  return {
    content: input.content,
  };
}

const CreateTermsAndConditionsReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The T&C content\n"}],"serializedName":"content","default":{"kind":"nothing"},"name":"content","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"CreateTermsAndConditionsReq","version":{"kind":"nothing"}}};

export const snCreateTermsAndConditionsReq: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateTermsAndConditionsReq"};

export function texprCreateTermsAndConditionsReq(): ADL.ATypeExpr<CreateTermsAndConditionsReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateTermsAndConditionsReq}, parameters : []}};
}

export interface CreateTermsAndConditionsResp_Success {
  kind: 'success';
  value: common_db.DbKey<hotel_db.TermsAndConditions>;
}
export interface CreateTermsAndConditionsResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

export type CreateTermsAndConditionsResp = CreateTermsAndConditionsResp_Success | CreateTermsAndConditionsResp_Error;

export interface CreateTermsAndConditionsRespOpts {
  success: common_db.DbKey<hotel_db.TermsAndConditions>;
  error: common_strings.StringNE;
}

export function makeCreateTermsAndConditionsResp<K extends keyof CreateTermsAndConditionsRespOpts>(kind: K, value: CreateTermsAndConditionsRespOpts[K]) { return {kind, value}; }

const CreateTermsAndConditionsResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"TermsAndConditions"}},"parameters":[]}]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"CreateTermsAndConditionsResp","version":{"kind":"nothing"}}};

export const snCreateTermsAndConditionsResp: ADL.ScopedName = {moduleName:"hotel.api", name:"CreateTermsAndConditionsResp"};

export function texprCreateTermsAndConditionsResp(): ADL.ATypeExpr<CreateTermsAndConditionsResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateTermsAndConditionsResp}, parameters : []}};
}

/**
 * Report type with the total number of bookings
 */
export interface BookingTotalReport {
  /**
   * Total number of bookings
   */
  total: number;
}

export function makeBookingTotalReport(
  input: {
    total: number,
  }
): BookingTotalReport {
  return {
    total: input.total,
  };
}

const BookingTotalReport_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Report type with the total number of bookings\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total number of bookings\n"}],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}]}},"name":"BookingTotalReport","version":{"kind":"nothing"}}};

export const snBookingTotalReport: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingTotalReport"};

export function texprBookingTotalReport(): ADL.ATypeExpr<BookingTotalReport> {
  return {value : {typeRef : {kind: "reference", value : snBookingTotalReport}, parameters : []}};
}

/**
 * Report type with the total number of bookings per live status
 */
export interface LiveStatusTotalsReport {
  /**
   * The live status of bookings
   */
  status: hotel_booking.LiveStatus;
  /**
   * The total number of bookings in the corresponding live status
   */
  total: number;
}

export function makeLiveStatusTotalsReport(
  input: {
    status: hotel_booking.LiveStatus,
    total: number,
  }
): LiveStatusTotalsReport {
  return {
    status: input.status,
    total: input.total,
  };
}

const LiveStatusTotalsReport_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Report type with the total number of bookings per live status\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The live status of bookings\n"}],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.booking","name":"LiveStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The total number of bookings in the corresponding live status\n"}],"serializedName":"total","default":{"kind":"nothing"},"name":"total","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}]}},"name":"LiveStatusTotalsReport","version":{"kind":"nothing"}}};

export const snLiveStatusTotalsReport: ADL.ScopedName = {moduleName:"hotel.api", name:"LiveStatusTotalsReport"};

export function texprLiveStatusTotalsReport(): ADL.ATypeExpr<LiveStatusTotalsReport> {
  return {value : {typeRef : {kind: "reference", value : snLiveStatusTotalsReport}, parameters : []}};
}

export enum ReportType {
  bookingTotal,
  liveStatusTotals,
}

const ReportType_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"What reports should be included\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Include the total number of bookings\n"}],"serializedName":"bookingTotal","default":{"kind":"nothing"},"name":"bookingTotal","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Include the total number of bookings per live status\n"}],"serializedName":"liveStatusTotals","default":{"kind":"nothing"},"name":"liveStatusTotals","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ReportType","version":{"kind":"nothing"}}};

export const snReportType: ADL.ScopedName = {moduleName:"hotel.api", name:"ReportType"};

export function texprReportType(): ADL.ATypeExpr<ReportType> {
  return {value : {typeRef : {kind: "reference", value : snReportType}, parameters : []}};
}

/**
 * Overall reports grouped by report type
 */
export interface Report {
  /**
   * Total number of bookings report type
   */
  bookingTotal: (BookingTotalReport|null);
  /**
   * Total number of bookings per live status report type
   */
  liveStatusTotals: LiveStatusTotalsReport[];
}

export function makeReport(
  input: {
    bookingTotal: (BookingTotalReport|null),
    liveStatusTotals: LiveStatusTotalsReport[],
  }
): Report {
  return {
    bookingTotal: input.bookingTotal,
    liveStatusTotals: input.liveStatusTotals,
  };
}

const Report_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Overall reports grouped by report type\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total number of bookings report type\n"}],"serializedName":"bookingTotal","default":{"kind":"nothing"},"name":"bookingTotal","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingTotalReport"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Total number of bookings per live status report type\n"}],"serializedName":"liveStatusTotals","default":{"kind":"nothing"},"name":"liveStatusTotals","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"LiveStatusTotalsReport"}},"parameters":[]}]}}]}},"name":"Report","version":{"kind":"nothing"}}};

export const snReport: ADL.ScopedName = {moduleName:"hotel.api", name:"Report"};

export function texprReport(): ADL.ATypeExpr<Report> {
  return {value : {typeRef : {kind: "reference", value : snReport}, parameters : []}};
}

/**
 * Report request options
 */
export interface GetReportReq {
  /**
   * The requested report types
   */
  types: sys_types.Set<ReportType>;
}

export function makeGetReportReq(
  input: {
    types?: sys_types.Set<ReportType>,
  }
): GetReportReq {
  return {
    types: input.types === undefined ? [0, 1] : input.types,
  };
}

const GetReportReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Report request options\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The requested report types\n"}],"serializedName":"types","default":{"kind":"just","value":["bookingTotal","liveStatusTotals"]},"name":"types","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"ReportType"}},"parameters":[]}]}}]}},"name":"GetReportReq","version":{"kind":"nothing"}}};

export const snGetReportReq: ADL.ScopedName = {moduleName:"hotel.api", name:"GetReportReq"};

export function texprGetReportReq(): ADL.ATypeExpr<GetReportReq> {
  return {value : {typeRef : {kind: "reference", value : snGetReportReq}, parameters : []}};
}

export interface GetReportResp_Reports {
  kind: 'reports';
  value: Report;
}
export interface GetReportResp_Error {
  kind: 'error';
  value: common_strings.StringNE;
}

/**
 * Report or error response
 */
export type GetReportResp = GetReportResp_Reports | GetReportResp_Error;

export interface GetReportRespOpts {
  reports: Report;
  error: common_strings.StringNE;
}

export function makeGetReportResp<K extends keyof GetReportRespOpts>(kind: K, value: GetReportRespOpts[K]) { return {kind, value}; }

const GetReportResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Report or error response\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"reports","default":{"kind":"nothing"},"name":"reports","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"Report"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"GetReportResp","version":{"kind":"nothing"}}};

export const snGetReportResp: ADL.ScopedName = {moduleName:"hotel.api", name:"GetReportResp"};

export function texprGetReportResp(): ADL.ATypeExpr<GetReportResp> {
  return {value : {typeRef : {kind: "reference", value : snGetReportResp}, parameters : []}};
}

export type BookingNumber = common_strings.StringNE;

const BookingNumber_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}},"name":"BookingNumber","version":{"kind":"nothing"}}};

export const snBookingNumber: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingNumber"};

export function texprBookingNumber(): ADL.ATypeExpr<BookingNumber> {
  return {value : {typeRef : {kind: "reference", value : snBookingNumber}, parameters : []}};
}

/**
 * Input data for itinerary creation
 */
export interface ItineraryCommentCreateReq {
  /**
   * Parent itinerary
   */
  itineraryNumber: common_strings.StringNE;
  /**
   * Related booking numbers
   */
  bookingNumbers: BookingNumber[];
  /**
   * Comment text
   */
  text: common_strings.StringNE;
}

export function makeItineraryCommentCreateReq(
  input: {
    itineraryNumber: common_strings.StringNE,
    bookingNumbers: BookingNumber[],
    text: common_strings.StringNE,
  }
): ItineraryCommentCreateReq {
  return {
    itineraryNumber: input.itineraryNumber,
    bookingNumbers: input.bookingNumbers,
    text: input.text,
  };
}

const ItineraryCommentCreateReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Input data for itinerary creation\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Parent itinerary\n"}],"serializedName":"itineraryNumber","default":{"kind":"nothing"},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Related booking numbers\n"}],"serializedName":"bookingNumbers","default":{"kind":"nothing"},"name":"bookingNumbers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment text\n"}],"serializedName":"text","default":{"kind":"nothing"},"name":"text","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"ItineraryCommentCreateReq","version":{"kind":"nothing"}}};

export const snItineraryCommentCreateReq: ADL.ScopedName = {moduleName:"hotel.api", name:"ItineraryCommentCreateReq"};

export function texprItineraryCommentCreateReq(): ADL.ATypeExpr<ItineraryCommentCreateReq> {
  return {value : {typeRef : {kind: "reference", value : snItineraryCommentCreateReq}, parameters : []}};
}

/**
 * Input data for itinerary creation
 */
export interface ItineraryCommentsQuery {
  /**
   * Itinerary number
   */
  itineraryNumber: common_strings.StringNE;
  /**
   * Pagination offset
   */
  offset: number;
  /**
   * Number of items to return
   */
  count: number;
}

export function makeItineraryCommentsQuery(
  input: {
    itineraryNumber: common_strings.StringNE,
    offset?: number,
    count?: number,
  }
): ItineraryCommentsQuery {
  return {
    itineraryNumber: input.itineraryNumber,
    offset: input.offset === undefined ? 0 : input.offset,
    count: input.count === undefined ? 20 : input.count,
  };
}

const ItineraryCommentsQuery_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Input data for itinerary creation\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Itinerary number\n"}],"serializedName":"itineraryNumber","default":{"kind":"nothing"},"name":"itineraryNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Pagination offset\n"}],"serializedName":"offset","default":{"kind":"just","value":0},"name":"offset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Number of items to return\n"}],"serializedName":"count","default":{"kind":"just","value":20},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"ItineraryCommentsQuery","version":{"kind":"nothing"}}};

export const snItineraryCommentsQuery: ADL.ScopedName = {moduleName:"hotel.api", name:"ItineraryCommentsQuery"};

export function texprItineraryCommentsQuery(): ADL.ATypeExpr<ItineraryCommentsQuery> {
  return {value : {typeRef : {kind: "reference", value : snItineraryCommentsQuery}, parameters : []}};
}

/**
 * Itinerary comment API output
 */
export interface ItineraryCommentData {
  /**
   * Comment ID
   */
  commentId: common_db.DbKey<hotel_db.ItineraryComment>;
  /**
   * Comment creation time
   */
  created: common.Instant;
  /**
   * Comment's owner
   */
  owner: AppUserDetails;
  /**
   * Related booking numbers
   */
  bookingNumbers: BookingNumber[];
  /**
   * Comment text
   */
  text: common_strings.StringNE;
}

export function makeItineraryCommentData(
  input: {
    commentId: common_db.DbKey<hotel_db.ItineraryComment>,
    created: common.Instant,
    owner: AppUserDetails,
    bookingNumbers: BookingNumber[],
    text: common_strings.StringNE,
  }
): ItineraryCommentData {
  return {
    commentId: input.commentId,
    created: input.created,
    owner: input.owner,
    bookingNumbers: input.bookingNumbers,
    text: input.text,
  };
}

const ItineraryCommentData_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Itinerary comment API output\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment ID\n"}],"serializedName":"commentId","default":{"kind":"nothing"},"name":"commentId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"ItineraryComment"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment creation time\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment's owner\n"}],"serializedName":"owner","default":{"kind":"nothing"},"name":"owner","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"AppUserDetails"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Related booking numbers\n"}],"serializedName":"bookingNumbers","default":{"kind":"nothing"},"name":"bookingNumbers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Comment text\n"}],"serializedName":"text","default":{"kind":"nothing"},"name":"text","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"ItineraryCommentData","version":{"kind":"nothing"}}};

export const snItineraryCommentData: ADL.ScopedName = {moduleName:"hotel.api", name:"ItineraryCommentData"};

export function texprItineraryCommentData(): ADL.ATypeExpr<ItineraryCommentData> {
  return {value : {typeRef : {kind: "reference", value : snItineraryCommentData}, parameters : []}};
}

export interface BookingRefundabilityReq {
  bookingIds: common_db.DbKey<hotel_db.Booking>[];
}

export function makeBookingRefundabilityReq(
  input: {
    bookingIds: common_db.DbKey<hotel_db.Booking>[],
  }
): BookingRefundabilityReq {
  return {
    bookingIds: input.bookingIds,
  };
}

const BookingRefundabilityReq_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingIds","default":{"kind":"nothing"},"name":"bookingIds","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}]}}]}},"name":"BookingRefundabilityReq","version":{"kind":"nothing"}}};

export const snBookingRefundabilityReq: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingRefundabilityReq"};

export function texprBookingRefundabilityReq(): ADL.ATypeExpr<BookingRefundabilityReq> {
  return {value : {typeRef : {kind: "reference", value : snBookingRefundabilityReq}, parameters : []}};
}

export interface BookingRefundabilityResp {
  statuses: BookingRefundabilityItem[];
}

export function makeBookingRefundabilityResp(
  input: {
    statuses: BookingRefundabilityItem[],
  }
): BookingRefundabilityResp {
  return {
    statuses: input.statuses,
  };
}

const BookingRefundabilityResp_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"statuses","default":{"kind":"nothing"},"name":"statuses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"BookingRefundabilityItem"}},"parameters":[]}]}}]}},"name":"BookingRefundabilityResp","version":{"kind":"nothing"}}};

export const snBookingRefundabilityResp: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingRefundabilityResp"};

export function texprBookingRefundabilityResp(): ADL.ATypeExpr<BookingRefundabilityResp> {
  return {value : {typeRef : {kind: "reference", value : snBookingRefundabilityResp}, parameters : []}};
}

export interface BookingRefundabilityItem {
  bookingId: common_db.DbKey<hotel_db.Booking>;
  isRefundable: boolean;
}

export function makeBookingRefundabilityItem(
  input: {
    bookingId: common_db.DbKey<hotel_db.Booking>,
    isRefundable: boolean,
  }
): BookingRefundabilityItem {
  return {
    bookingId: input.bookingId,
    isRefundable: input.isRefundable,
  };
}

const BookingRefundabilityItem_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingId","default":{"kind":"nothing"},"name":"bookingId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[],"serializedName":"isRefundable","default":{"kind":"nothing"},"name":"isRefundable","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"BookingRefundabilityItem","version":{"kind":"nothing"}}};

export const snBookingRefundabilityItem: ADL.ScopedName = {moduleName:"hotel.api", name:"BookingRefundabilityItem"};

export function texprBookingRefundabilityItem(): ADL.ATypeExpr<BookingRefundabilityItem> {
  return {value : {typeRef : {kind: "reference", value : snBookingRefundabilityItem}, parameters : []}};
}

export interface CanPayLaterCacheKey {
  /**
   * The price token representing a hotel search
   */
  priceToken: PriceToken;
  /**
   * The internal ID of the hotel
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
  /**
   * The ID of the selected package
   */
  packageId: PackageId;
}

export function makeCanPayLaterCacheKey(
  input: {
    priceToken: PriceToken,
    hotelId: common_db.DbKey<ids_db.Hotel>,
    packageId: PackageId,
  }
): CanPayLaterCacheKey {
  return {
    priceToken: input.priceToken,
    hotelId: input.hotelId,
    packageId: input.packageId,
  };
}

const CanPayLaterCacheKey_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token representing a hotel search\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The internal ID of the hotel\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the selected package\n"}],"serializedName":"packageId","default":{"kind":"nothing"},"name":"packageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PackageId"}},"parameters":[]}}]}},"name":"CanPayLaterCacheKey","version":{"kind":"nothing"}}};

export const snCanPayLaterCacheKey: ADL.ScopedName = {moduleName:"hotel.api", name:"CanPayLaterCacheKey"};

export function texprCanPayLaterCacheKey(): ADL.ATypeExpr<CanPayLaterCacheKey> {
  return {value : {typeRef : {kind: "reference", value : snCanPayLaterCacheKey}, parameters : []}};
}

export interface CancellationPolicyCacheKey {
  /**
   * The price token representing a hotel search
   */
  priceToken: PriceToken;
  /**
   * The internal ID of the hotel
   */
  hotelId: common_db.DbKey<ids_db.Hotel>;
}

export function makeCancellationPolicyCacheKey(
  input: {
    priceToken: PriceToken,
    hotelId: common_db.DbKey<ids_db.Hotel>,
  }
): CancellationPolicyCacheKey {
  return {
    priceToken: input.priceToken,
    hotelId: input.hotelId,
  };
}

const CancellationPolicyCacheKey_AST : ADL.ScopedDecl =
  {"moduleName":"hotel.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The price token representing a hotel search\n"}],"serializedName":"priceToken","default":{"kind":"nothing"},"name":"priceToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"hotel.api","name":"PriceToken"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The internal ID of the hotel\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}}]}},"name":"CancellationPolicyCacheKey","version":{"kind":"nothing"}}};

export const snCancellationPolicyCacheKey: ADL.ScopedName = {moduleName:"hotel.api", name:"CancellationPolicyCacheKey"};

export function texprCancellationPolicyCacheKey(): ADL.ATypeExpr<CancellationPolicyCacheKey> {
  return {value : {typeRef : {kind: "reference", value : snCancellationPolicyCacheKey}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "hotel.api.PriceToken" : PriceToken_AST,
  "hotel.api.PackageId" : PackageId_AST,
  "hotel.api.ApiRequests" : ApiRequests_AST,
  "hotel.api.GetItineraryReq" : GetItineraryReq_AST,
  "hotel.api.GetItineraryResp" : GetItineraryResp_AST,
  "hotel.api.ItineraryDetails" : ItineraryDetails_AST,
  "hotel.api.CancelBookingResp" : CancelBookingResp_AST,
  "hotel.api.JobReq" : JobReq_AST,
  "hotel.api.JobResp" : JobResp_AST,
  "hotel.api.JobRunMode" : JobRunMode_AST,
  "hotel.api.JobReport" : JobReport_AST,
  "hotel.api.ConfirmBookingReq" : ConfirmBookingReq_AST,
  "hotel.api.PaymentClientConfig" : PaymentClientConfig_AST,
  "hotel.api.PaymentClientConfigResp" : PaymentClientConfigResp_AST,
  "hotel.api.CreditCardToken" : CreditCardToken_AST,
  "hotel.api.PayForBookingReq" : PayForBookingReq_AST,
  "hotel.api.BookingPaymentResult" : BookingPaymentResult_AST,
  "hotel.api.PayForBookingResp" : PayForBookingResp_AST,
  "hotel.api.FinalizePaymentReq" : FinalizePaymentReq_AST,
  "hotel.api.FinalizePaymentResp" : FinalizePaymentResp_AST,
  "hotel.api.SupplierPackageDetails" : SupplierPackageDetails_AST,
  "hotel.api.ConfirmBookingResp" : ConfirmBookingResp_AST,
  "hotel.api.PaymentDetailsReq" : PaymentDetailsReq_AST,
  "hotel.api.PaymentDetailsResp" : PaymentDetailsResp_AST,
  "hotel.api.PaymentDetails" : PaymentDetails_AST,
  "hotel.api.CancellationPoliciesQuery" : CancellationPoliciesQuery_AST,
  "hotel.api.CancellationPoliciesResp" : CancellationPoliciesResp_AST,
  "hotel.api.PackageCancellationPolicyWithId" : PackageCancellationPolicyWithId_AST,
  "hotel.api.AvailablePackagesQuery" : AvailablePackagesQuery_AST,
  "hotel.api.AvailablePackagesResp" : AvailablePackagesResp_AST,
  "hotel.api.PackageInfo" : PackageInfo_AST,
  "hotel.api.TaxesAndFees" : TaxesAndFees_AST,
  "hotel.api.SimpleCancellationPolicy" : SimpleCancellationPolicy_AST,
  "hotel.api.LeadingPriceQuery" : LeadingPriceQuery_AST,
  "hotel.api.LeadingPriceQueryResp" : LeadingPriceQueryResp_AST,
  "hotel.api.HotelLeadingPrice" : HotelLeadingPrice_AST,
  "hotel.api.LeadingPriceType" : LeadingPriceType_AST,
  "hotel.api.LeadingPrice" : LeadingPrice_AST,
  "hotel.api.AgentHotelSearchResp" : AgentHotelSearchResp_AST,
  "hotel.api.AvailableHotels" : AvailableHotels_AST,
  "hotel.api.HotelListingDetails" : HotelListingDetails_AST,
  "hotel.api.AgentHotelSearchQuery" : AgentHotelSearchQuery_AST,
  "hotel.api.RoomSearchType" : RoomSearchType_AST,
  "hotel.api.ExistingSearchParameters" : ExistingSearchParameters_AST,
  "hotel.api.HotelSearchParameters" : HotelSearchParameters_AST,
  "hotel.api.StayDetails" : StayDetails_AST,
  "hotel.api.HotelQueryParameters" : HotelQueryParameters_AST,
  "hotel.api.HotelRoom" : HotelRoom_AST,
  "hotel.api.Child" : Child_AST,
  "hotel.api.HotelSearchFilters" : HotelSearchFilters_AST,
  "hotel.api.HotelSearchSortOrder" : HotelSearchSortOrder_AST,
  "hotel.api.CreateItineraryReq" : CreateItineraryReq_AST,
  "hotel.api.CreateItineraryResp" : CreateItineraryResp_AST,
  "hotel.api.CreateBookingReq" : CreateBookingReq_AST,
  "hotel.api.CreateBookingResp" : CreateBookingResp_AST,
  "hotel.api.RefreshBookingResp" : RefreshBookingResp_AST,
  "hotel.api.UpdateAgencyResp" : UpdateAgencyResp_AST,
  "hotel.api.CreateAgencyResp" : CreateAgencyResp_AST,
  "hotel.api.CreateAgentUserReq" : CreateAgentUserReq_AST,
  "hotel.api.CreateAgentUserResp" : CreateAgentUserResp_AST,
  "hotel.api.ConfirmInviteAgentUserReq" : ConfirmInviteAgentUserReq_AST,
  "hotel.api.ConfirmInviteAgentUserResp" : ConfirmInviteAgentUserResp_AST,
  "hotel.api.ValidateInviteAgentUserReq" : ValidateInviteAgentUserReq_AST,
  "hotel.api.ValidateInviteAgentUserResp" : ValidateInviteAgentUserResp_AST,
  "hotel.api.UserInviteReq" : UserInviteReq_AST,
  "hotel.api.UserInviteResp" : UserInviteResp_AST,
  "hotel.api.UserProfile" : UserProfile_AST,
  "hotel.api.AppUserDetails" : AppUserDetails_AST,
  "hotel.api.UserReq" : UserReq_AST,
  "hotel.api.LoginReq" : LoginReq_AST,
  "hotel.api.LoginResp" : LoginResp_AST,
  "hotel.api.NewMessageReq" : NewMessageReq_AST,
  "hotel.api.RecentMessagesReq" : RecentMessagesReq_AST,
  "hotel.api.CreateUserResp" : CreateUserResp_AST,
  "hotel.api.UpdateUserResp" : UpdateUserResp_AST,
  "hotel.api.DeleteUserResp" : DeleteUserResp_AST,
  "hotel.api.UpdateUserPasswordReq" : UpdateUserPasswordReq_AST,
  "hotel.api.UpdateUserPasswordResp" : UpdateUserPasswordResp_AST,
  "hotel.api.BookingSearchQuery" : BookingSearchQuery_AST,
  "hotel.api.LocalDateRange" : LocalDateRange_AST,
  "hotel.api.BookingSearchShortcutQuery" : BookingSearchShortcutQuery_AST,
  "hotel.api.BookingSearchShortcut" : BookingSearchShortcut_AST,
  "hotel.api.BookingSearchShortcutCountResp" : BookingSearchShortcutCountResp_AST,
  "hotel.api.ShortcutTotalsReport" : ShortcutTotalsReport_AST,
  "hotel.api.BookingSearchQueryResp" : BookingSearchQueryResp_AST,
  "hotel.api.AgentBookingData" : AgentBookingData_AST,
  "hotel.api.AgentPaymentInformation" : AgentPaymentInformation_AST,
  "hotel.api.BackOfficeUserPaymentInformation" : BackOfficeUserPaymentInformation_AST,
  "hotel.api.BackOfficeUserBookingData" : BackOfficeUserBookingData_AST,
  "hotel.api.SupplierData" : SupplierData_AST,
  "hotel.api.AgentPaymentLineItem" : AgentPaymentLineItem_AST,
  "hotel.api.ClientBookingData" : ClientBookingData_AST,
  "hotel.api.CreateTermsAndConditionsReq" : CreateTermsAndConditionsReq_AST,
  "hotel.api.CreateTermsAndConditionsResp" : CreateTermsAndConditionsResp_AST,
  "hotel.api.BookingTotalReport" : BookingTotalReport_AST,
  "hotel.api.LiveStatusTotalsReport" : LiveStatusTotalsReport_AST,
  "hotel.api.ReportType" : ReportType_AST,
  "hotel.api.Report" : Report_AST,
  "hotel.api.GetReportReq" : GetReportReq_AST,
  "hotel.api.GetReportResp" : GetReportResp_AST,
  "hotel.api.BookingNumber" : BookingNumber_AST,
  "hotel.api.ItineraryCommentCreateReq" : ItineraryCommentCreateReq_AST,
  "hotel.api.ItineraryCommentsQuery" : ItineraryCommentsQuery_AST,
  "hotel.api.ItineraryCommentData" : ItineraryCommentData_AST,
  "hotel.api.BookingRefundabilityReq" : BookingRefundabilityReq_AST,
  "hotel.api.BookingRefundabilityResp" : BookingRefundabilityResp_AST,
  "hotel.api.BookingRefundabilityItem" : BookingRefundabilityItem_AST,
  "hotel.api.CanPayLaterCacheKey" : CanPayLaterCacheKey_AST,
  "hotel.api.CancellationPolicyCacheKey" : CancellationPolicyCacheKey_AST
};
